export const styles_plugin = `
<style>
@charset "UTF-8";.col,.container {
    padding: 0 var(--ifm-spacing-horizontal);
    width: 100%
}

.markdown>h2,.markdown>h3,.markdown>h4,.markdown>h5,.markdown>h6 {
    margin-bottom: calc(var(--ifm-heading-vertical-rhythm-bottom)*var(--ifm-leading))
}

body,ol ol,ol ul,ul ol,ul ul {
    margin: 0
}

pre,table {
    overflow: auto
}

blockquote,pre {
    margin: 0 0 var(--ifm-spacing-vertical)
}

.breadcrumbs__link,.button {
    transition-timing-function: var(--ifm-transition-timing-default)
}

.button,code {
    vertical-align: middle
}

.button--outline.button--active,.button--outline:active,.button--outline:hover,:root {
    --ifm-button-color: var(--ifm-font-color-base-inverse)
}

.menu__link:hover,a {
    transition: color var(--ifm-transition-fast) var(--ifm-transition-timing-default)
}

.navbar--dark,:root {
    --ifm-navbar-link-hover-color: var(--ifm-color-primary)
}

.menu,.navbar-sidebar {
    overflow-x: hidden
}

:root,html[data-theme=dark] {
    --ifm-color-emphasis-500: var(--ifm-color-gray-500)
}

.toggleButton_gllP,html {
    -webkit-tap-highlight-color: transparent
}

*,.DocSearch-Container,.DocSearch-Container *,.uppy-Root {
    box-sizing: border-box
}

.markdown li,body {
    word-wrap: break-word
}

:root {
    --ifm-color-scheme: light;
    --ifm-dark-value: 10%;
    --ifm-darker-value: 15%;
    --ifm-darkest-value: 30%;
    --ifm-light-value: 15%;
    --ifm-lighter-value: 30%;
    --ifm-lightest-value: 50%;
    --ifm-contrast-background-value: 90%;
    --ifm-contrast-foreground-value: 70%;
    --ifm-contrast-background-dark-value: 70%;
    --ifm-contrast-foreground-dark-value: 90%;
    --ifm-color-primary: #3578e5;
    --ifm-color-secondary: #ebedf0;
    --ifm-color-success: #00a400;
    --ifm-color-info: #54c7ec;
    --ifm-color-warning: #ffba00;
    --ifm-color-danger: #fa383e;
    --ifm-color-primary-dark: #306cce;
    --ifm-color-primary-darker: #2d66c3;
    --ifm-color-primary-darkest: #2554a0;
    --ifm-color-primary-light: #538ce9;
    --ifm-color-primary-lighter: #72a1ed;
    --ifm-color-primary-lightest: #9abcf2;
    --ifm-color-primary-contrast-background: #ebf2fc;
    --ifm-color-primary-contrast-foreground: #102445;
    --ifm-color-secondary-dark: #d4d5d8;
    --ifm-color-secondary-darker: #c8c9cc;
    --ifm-color-secondary-darkest: #a4a6a8;
    --ifm-color-secondary-light: #eef0f2;
    --ifm-color-secondary-lighter: #f1f2f5;
    --ifm-color-secondary-lightest: #f5f6f8;
    --ifm-color-secondary-contrast-background: #fdfdfe;
    --ifm-color-secondary-contrast-foreground: #474748;
    --ifm-color-success-dark: #009400;
    --ifm-color-success-darker: #008b00;
    --ifm-color-success-darkest: #007300;
    --ifm-color-success-light: #26b226;
    --ifm-color-success-lighter: #4dbf4d;
    --ifm-color-success-lightest: #80d280;
    --ifm-color-success-contrast-background: #e6f6e6;
    --ifm-color-success-contrast-foreground: #003100;
    --ifm-color-info-dark: #4cb3d4;
    --ifm-color-info-darker: #47a9c9;
    --ifm-color-info-darkest: #3b8ba5;
    --ifm-color-info-light: #6ecfef;
    --ifm-color-info-lighter: #87d8f2;
    --ifm-color-info-lightest: #aae3f6;
    --ifm-color-info-contrast-background: #eef9fd;
    --ifm-color-info-contrast-foreground: #193c47;
    --ifm-color-warning-dark: #e6a700;
    --ifm-color-warning-darker: #d99e00;
    --ifm-color-warning-darkest: #b38200;
    --ifm-color-warning-light: #ffc426;
    --ifm-color-warning-lighter: #ffcf4d;
    --ifm-color-warning-lightest: #ffdd80;
    --ifm-color-warning-contrast-background: #fff8e6;
    --ifm-color-warning-contrast-foreground: #4d3800;
    --ifm-color-danger-dark: #e13238;
    --ifm-color-danger-darker: #d53035;
    --ifm-color-danger-darkest: #af272b;
    --ifm-color-danger-light: #fb565b;
    --ifm-color-danger-lighter: #fb7478;
    --ifm-color-danger-lightest: #fd9c9f;
    --ifm-color-danger-contrast-background: #ffebec;
    --ifm-color-danger-contrast-foreground: #4b1113;
    --ifm-color-white: #fff;
    --ifm-color-black: #000;
    --ifm-color-gray-0: var(--ifm-color-white);
    --ifm-color-gray-100: #f5f6f7;
    --ifm-color-gray-200: #ebedf0;
    --ifm-color-gray-300: #dadde1;
    --ifm-color-gray-400: #ccd0d5;
    --ifm-color-gray-500: #bec3c9;
    --ifm-color-gray-600: #8d949e;
    --ifm-color-gray-700: #606770;
    --ifm-color-gray-800: #444950;
    --ifm-color-gray-900: #1c1e21;
    --ifm-color-gray-1000: var(--ifm-color-black);
    --ifm-color-emphasis-0: var(--ifm-color-gray-0);
    --ifm-color-emphasis-100: var(--ifm-color-gray-100);
    --ifm-color-emphasis-200: var(--ifm-color-gray-200);
    --ifm-color-emphasis-300: var(--ifm-color-gray-300);
    --ifm-color-emphasis-400: var(--ifm-color-gray-400);
    --ifm-color-emphasis-600: var(--ifm-color-gray-600);
    --ifm-color-emphasis-700: var(--ifm-color-gray-700);
    --ifm-color-emphasis-800: var(--ifm-color-gray-800);
    --ifm-color-emphasis-900: var(--ifm-color-gray-900);
    --ifm-color-emphasis-1000: var(--ifm-color-gray-1000);
    --ifm-color-content: var(--ifm-color-emphasis-900);
    --ifm-color-content-inverse: var(--ifm-color-emphasis-0);
    --ifm-color-content-secondary: #525860;
    --ifm-background-color: #0000;
    --ifm-background-surface-color: var(--ifm-color-content-inverse);
    --ifm-global-border-width: 1px;
    --ifm-global-radius: 0.4rem;
    --ifm-hover-overlay: #0000000d;
    --ifm-font-color-base: var(--ifm-color-content);
    --ifm-font-color-base-inverse: var(--ifm-color-content-inverse);
    --ifm-font-color-secondary: var(--ifm-color-content-secondary);
    --ifm-font-family-base: system-ui,-apple-system,Segoe UI,Roboto,Ubuntu,Cantarell,Noto Sans,sans-serif,BlinkMacSystemFont,"Segoe UI",Helvetica,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol";
    --ifm-font-family-monospace: SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace;
    --ifm-font-size-base: 100%;
    --ifm-font-weight-light: 300;
    --ifm-font-weight-normal: 400;
    --ifm-font-weight-semibold: 500;
    --ifm-font-weight-bold: 700;
    --ifm-font-weight-base: var(--ifm-font-weight-normal);
    --ifm-line-height-base: 1.65;
    --ifm-global-spacing: 1rem;
    --ifm-spacing-vertical: var(--ifm-global-spacing);
    --ifm-spacing-horizontal: var(--ifm-global-spacing);
    --ifm-transition-fast: 200ms;
    --ifm-transition-slow: 400ms;
    --ifm-transition-timing-default: cubic-bezier(0.08,0.52,0.52,1);
    --ifm-global-shadow-lw: 0 1px 2px 0 #0000001a;
    --ifm-global-shadow-md: 0 5px 40px #0003;
    --ifm-global-shadow-tl: 0 12px 28px 0 #0003,0 2px 4px 0 #0000001a;
    --ifm-z-index-dropdown: 100;
    --ifm-z-index-fixed: 200;
    --ifm-z-index-overlay: 400;
    --ifm-container-width: 1140px;
    --ifm-container-width-xl: 1320px;
    --ifm-code-background: #f6f7f8;
    --ifm-code-border-radius: var(--ifm-global-radius);
    --ifm-code-font-size: 90%;
    --ifm-code-padding-horizontal: 0.1rem;
    --ifm-code-padding-vertical: 0.1rem;
    --ifm-pre-background: var(--ifm-code-background);
    --ifm-pre-border-radius: var(--ifm-code-border-radius);
    --ifm-pre-color: inherit;
    --ifm-pre-line-height: 1.45;
    --ifm-pre-padding: 1rem;
    --ifm-heading-color: inherit;
    --ifm-heading-margin-top: 0;
    --ifm-heading-margin-bottom: var(--ifm-spacing-vertical);
    --ifm-heading-font-family: var(--ifm-font-family-base);
    --ifm-heading-font-weight: var(--ifm-font-weight-bold);
    --ifm-heading-line-height: 1.25;
    --ifm-h1-font-size: 2rem;
    --ifm-h2-font-size: 1.5rem;
    --ifm-h3-font-size: 1.25rem;
    --ifm-h4-font-size: 1rem;
    --ifm-h5-font-size: 0.875rem;
    --ifm-h6-font-size: 0.85rem;
    --ifm-image-alignment-padding: 1.25rem;
    --ifm-leading-desktop: 1.25;
    --ifm-leading: calc(var(--ifm-leading-desktop)*1rem);
    --ifm-list-left-padding: 2rem;
    --ifm-list-margin: 1rem;
    --ifm-list-item-margin: 0.25rem;
    --ifm-list-paragraph-margin: 1rem;
    --ifm-table-cell-padding: 0.75rem;
    --ifm-table-background: #0000;
    --ifm-table-stripe-background: #00000008;
    --ifm-table-border-width: 1px;
    --ifm-table-border-color: var(--ifm-color-emphasis-300);
    --ifm-table-head-background: inherit;
    --ifm-table-head-color: inherit;
    --ifm-table-head-font-weight: var(--ifm-font-weight-bold);
    --ifm-table-cell-color: inherit;
    --ifm-link-color: var(--ifm-color-primary);
    --ifm-link-decoration: none;
    --ifm-link-hover-color: var(--ifm-link-color);
    --ifm-link-hover-decoration: underline;
    --ifm-paragraph-margin-bottom: var(--ifm-leading);
    --ifm-blockquote-font-size: var(--ifm-font-size-base);
    --ifm-blockquote-border-left-width: 2px;
    --ifm-blockquote-padding-horizontal: var(--ifm-spacing-horizontal);
    --ifm-blockquote-padding-vertical: 0;
    --ifm-blockquote-shadow: none;
    --ifm-blockquote-color: var(--ifm-color-emphasis-800);
    --ifm-blockquote-border-color: var(--ifm-color-emphasis-300);
    --ifm-hr-background-color: var(--ifm-color-emphasis-500);
    --ifm-hr-height: 1px;
    --ifm-hr-margin-vertical: 1.5rem;
    --ifm-scrollbar-size: 7px;
    --ifm-scrollbar-track-background-color: #f1f1f1;
    --ifm-scrollbar-thumb-background-color: silver;
    --ifm-scrollbar-thumb-hover-background-color: #a7a7a7;
    --ifm-alert-background-color: inherit;
    --ifm-alert-border-color: inherit;
    --ifm-alert-border-radius: var(--ifm-global-radius);
    --ifm-alert-border-width: 0px;
    --ifm-alert-border-left-width: 5px;
    --ifm-alert-color: var(--ifm-font-color-base);
    --ifm-alert-padding-horizontal: var(--ifm-spacing-horizontal);
    --ifm-alert-padding-vertical: var(--ifm-spacing-vertical);
    --ifm-alert-shadow: var(--ifm-global-shadow-lw);
    --ifm-avatar-intro-margin: 1rem;
    --ifm-avatar-intro-alignment: inherit;
    --ifm-avatar-photo-size: 3rem;
    --ifm-badge-background-color: inherit;
    --ifm-badge-border-color: inherit;
    --ifm-badge-border-radius: var(--ifm-global-radius);
    --ifm-badge-border-width: var(--ifm-global-border-width);
    --ifm-badge-color: var(--ifm-color-white);
    --ifm-badge-padding-horizontal: calc(var(--ifm-spacing-horizontal)*0.5);
    --ifm-badge-padding-vertical: calc(var(--ifm-spacing-vertical)*0.25);
    --ifm-breadcrumb-border-radius: 1.5rem;
    --ifm-breadcrumb-spacing: 0.5rem;
    --ifm-breadcrumb-color-active: var(--ifm-color-primary);
    --ifm-breadcrumb-item-background-active: var(--ifm-hover-overlay);
    --ifm-breadcrumb-padding-horizontal: 0.8rem;
    --ifm-breadcrumb-padding-vertical: 0.4rem;
    --ifm-breadcrumb-size-multiplier: 1;
    --ifm-breadcrumb-separator: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 256 256"><g><g><polygon points="79.093,0 48.907,30.187 146.72,128 48.907,225.813 79.093,256 207.093,128"/></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>');
    --ifm-breadcrumb-separator-filter: none;
    --ifm-breadcrumb-separator-size: 0.5rem;
    --ifm-breadcrumb-separator-size-multiplier: 1.25;
    --ifm-button-background-color: inherit;
    --ifm-button-border-color: var(--ifm-button-background-color);
    --ifm-button-border-width: var(--ifm-global-border-width);
    --ifm-button-font-weight: var(--ifm-font-weight-bold);
    --ifm-button-padding-horizontal: 1.5rem;
    --ifm-button-padding-vertical: 0.375rem;
    --ifm-button-size-multiplier: 1;
    --ifm-button-transition-duration: var(--ifm-transition-fast);
    --ifm-button-border-radius: calc(var(--ifm-global-radius)*var(--ifm-button-size-multiplier));
    --ifm-button-group-spacing: 2px;
    --ifm-card-background-color: var(--ifm-background-surface-color);
    --ifm-card-border-radius: calc(var(--ifm-global-radius)*2);
    --ifm-card-horizontal-spacing: var(--ifm-global-spacing);
    --ifm-card-vertical-spacing: var(--ifm-global-spacing);
    --ifm-toc-border-color: var(--ifm-color-emphasis-300);
    --ifm-toc-link-color: var(--ifm-color-content-secondary);
    --ifm-toc-padding-vertical: 0.5rem;
    --ifm-toc-padding-horizontal: 0.5rem;
    --ifm-dropdown-background-color: var(--ifm-background-surface-color);
    --ifm-dropdown-font-weight: var(--ifm-font-weight-semibold);
    --ifm-dropdown-link-color: var(--ifm-font-color-base);
    --ifm-dropdown-hover-background-color: var(--ifm-hover-overlay);
    --ifm-footer-background-color: var(--ifm-color-emphasis-100);
    --ifm-footer-color: inherit;
    --ifm-footer-link-color: var(--ifm-color-emphasis-700);
    --ifm-footer-link-hover-color: var(--ifm-color-primary);
    --ifm-footer-link-horizontal-spacing: 0.5rem;
    --ifm-footer-padding-horizontal: calc(var(--ifm-spacing-horizontal)*2);
    --ifm-footer-padding-vertical: calc(var(--ifm-spacing-vertical)*2);
    --ifm-footer-title-color: inherit;
    --ifm-footer-logo-max-width: min(30rem,90vw);
    --ifm-hero-background-color: var(--ifm-background-surface-color);
    --ifm-hero-text-color: var(--ifm-color-emphasis-800);
    --ifm-menu-color: var(--ifm-color-emphasis-700);
    --ifm-menu-color-active: var(--ifm-color-primary);
    --ifm-menu-color-background-active: var(--ifm-hover-overlay);
    --ifm-menu-color-background-hover: var(--ifm-hover-overlay);
    --ifm-menu-link-padding-horizontal: 0.75rem;
    --ifm-menu-link-padding-vertical: 0.375rem;
    --ifm-menu-link-sublist-icon: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="16px" height="16px" viewBox="0 0 24 24"><path fill="rgba(0,0,0,0.5)" d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"></path></svg>');
    --ifm-menu-link-sublist-icon-filter: none;
    --ifm-navbar-background-color: var(--ifm-background-surface-color);
    --ifm-navbar-height: 3.75rem;
    --ifm-navbar-item-padding-horizontal: 0.75rem;
    --ifm-navbar-item-padding-vertical: 0.25rem;
    --ifm-navbar-link-color: var(--ifm-font-color-base);
    --ifm-navbar-link-active-color: var(--ifm-link-color);
    --ifm-navbar-padding-horizontal: var(--ifm-spacing-horizontal);
    --ifm-navbar-padding-vertical: calc(var(--ifm-spacing-vertical)*0.5);
    --ifm-navbar-shadow: var(--ifm-global-shadow-lw);
    --ifm-navbar-search-input-background-color: var(--ifm-color-emphasis-200);
    --ifm-navbar-search-input-color: var(--ifm-color-emphasis-800);
    --ifm-navbar-search-input-placeholder-color: var(--ifm-color-emphasis-500);
    --ifm-navbar-search-input-icon: url('data:image/svg+xml;utf8,<svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" height="16px" width="16px"><path d="M6.02945,10.20327a4.17382,4.17382,0,1,1,4.17382-4.17382A4.15609,4.15609,0,0,1,6.02945,10.20327Zm9.69195,4.2199L10.8989,9.59979A5.88021,5.88021,0,0,0,12.058,6.02856,6.00467,6.00467,0,1,0,9.59979,10.8989l4.82338,4.82338a.89729.89729,0,0,0,1.29912,0,.89749.89749,0,0,0-.00087-1.29909Z" /></svg>');
    --ifm-navbar-sidebar-width: 83vw;
    --ifm-pagination-border-radius: var(--ifm-global-radius);
    --ifm-pagination-color-active: var(--ifm-color-primary);
    --ifm-pagination-font-size: 1rem;
    --ifm-pagination-item-active-background: var(--ifm-hover-overlay);
    --ifm-pagination-page-spacing: 0.2em;
    --ifm-pagination-padding-horizontal: calc(var(--ifm-spacing-horizontal)*1);
    --ifm-pagination-padding-vertical: calc(var(--ifm-spacing-vertical)*0.25);
    --ifm-pagination-nav-border-radius: var(--ifm-global-radius);
    --ifm-pagination-nav-color-hover: var(--ifm-color-primary);
    --ifm-pills-color-active: var(--ifm-color-primary);
    --ifm-pills-color-background-active: var(--ifm-hover-overlay);
    --ifm-pills-spacing: 0.125rem;
    --ifm-tabs-color: var(--ifm-font-color-secondary);
    --ifm-tabs-color-active: var(--ifm-color-primary);
    --ifm-tabs-color-active-border: var(--ifm-tabs-color-active);
    --ifm-tabs-padding-horizontal: 1rem;
    --ifm-tabs-padding-vertical: 1rem
}

:root,[data-theme=dark] {
    --ifm-color-primary: #f37
}

.avatar--vertical,:root {
    --ifm-avatar-intro-margin: 0.5rem
}

.badge--danger,.badge--info,.badge--primary,.badge--secondary,.badge--success,.badge--warning {
    --ifm-badge-border-color: var(--ifm-badge-background-color)
}

.button--link,.button--outline {
    --ifm-button-background-color: #0000
}

html {
    background-color: var(--ifm-background-color);
    color: var(--ifm-font-color-base);
    color-scheme: var(--ifm-color-scheme);
    font: var(--ifm-font-size-base)/var(--ifm-line-height-base) var(--ifm-font-family-base);
    -webkit-font-smoothing: antialiased;
    text-rendering: optimizelegibility;
    -webkit-text-size-adjust: 100%;
    text-size-adjust: 100%
}

iframe {
    border: 0;
    color-scheme: auto
}

.container {
    margin: 0 auto;
    max-width: var(--ifm-container-width)
}

.container--fluid {
    max-width: inherit
}

.row {
    display: flex;
    flex-wrap: wrap;
    margin: 0 calc(var(--ifm-spacing-horizontal)*-1)
}

.margin-bottom--none,.margin-vert--none,.markdown>:last-child {
    margin-bottom: 0!important
}

.margin-top--none,.margin-vert--none,.tabItem_LNqP {
    margin-top: 0!important
}

.row--no-gutters {
    margin-left: 0;
    margin-right: 0
}

.margin-horiz--none,.margin-right--none {
    margin-right: 0!important
}

.row--no-gutters>.col {
    padding-left: 0;
    padding-right: 0
}

.row--align-top {
    align-items: flex-start
}

.row--align-bottom {
    align-items: flex-end
}

.menuExternalLink_NmtK,.row--align-center {
    align-items: center
}

.row--align-stretch {
    align-items: stretch
}

.row--align-baseline {
    align-items: baseline
}

.col {
    --ifm-col-width: 100%;
    flex: 1 0;
    margin-left: 0;
    max-width: var(--ifm-col-width)
}

.padding-bottom--none,.padding-vert--none {
    padding-bottom: 0!important
}

.padding-top--none,.padding-vert--none {
    padding-top: 0!important
}

.padding-horiz--none,.padding-left--none {
    padding-left: 0!important
}

.padding-horiz--none,.padding-right--none {
    padding-right: 0!important
}

.col[class*=col--] {
    flex: 0 0 var(--ifm-col-width)
}

.col--1 {
    --ifm-col-width: 8.33333%
}

.col--offset-1 {
    margin-left: 8.33333%
}

.col--2 {
    --ifm-col-width: 16.66667%
}

.col--offset-2 {
    margin-left: 16.66667%
}

.col--3 {
    --ifm-col-width: 25%
}

.col--offset-3 {
    margin-left: 25%
}

.col--4 {
    --ifm-col-width: 33.33333%
}

.col--offset-4 {
    margin-left: 33.33333%
}

.col--5 {
    --ifm-col-width: 41.66667%
}

.col--offset-5 {
    margin-left: 41.66667%
}

.col--6 {
    --ifm-col-width: 50%
}

.col--offset-6 {
    margin-left: 50%
}

.col--7 {
    --ifm-col-width: 58.33333%
}

.col--offset-7 {
    margin-left: 58.33333%
}

.col--8 {
    --ifm-col-width: 66.66667%
}

.col--offset-8 {
    margin-left: 66.66667%
}

.col--9 {
    --ifm-col-width: 75%
}

.col--offset-9 {
    margin-left: 75%
}

.col--10 {
    --ifm-col-width: 83.33333%
}

.col--offset-10 {
    margin-left: 83.33333%
}

.col--11 {
    --ifm-col-width: 91.66667%
}

.col--offset-11 {
    margin-left: 91.66667%
}

.col--12 {
    --ifm-col-width: 100%
}

.col--offset-12 {
    margin-left: 100%
}

.margin-horiz--none,.margin-left--none {
    margin-left: 0!important
}

.margin--none {
    margin: 0!important
}

.margin-bottom--xs,.margin-vert--xs {
    margin-bottom: .25rem!important
}

.margin-top--xs,.margin-vert--xs {
    margin-top: .25rem!important
}

.margin-horiz--xs,.margin-left--xs {
    margin-left: .25rem!important
}

.margin-horiz--xs,.margin-right--xs {
    margin-right: .25rem!important
}

.margin--xs {
    margin: .25rem!important
}

.margin-bottom--sm,.margin-vert--sm {
    margin-bottom: .5rem!important
}

.margin-top--sm,.margin-vert--sm {
    margin-top: .5rem!important
}

.margin-horiz--sm,.margin-left--sm {
    margin-left: .5rem!important
}

.margin-horiz--sm,.margin-right--sm {
    margin-right: .5rem!important
}

.margin--sm {
    margin: .5rem!important
}

.margin-bottom--md,.margin-vert--md {
    margin-bottom: 1rem!important
}

.margin-top--md,.margin-vert--md {
    margin-top: 1rem!important
}

.margin-horiz--md,.margin-left--md {
    margin-left: 1rem!important
}

.margin-horiz--md,.margin-right--md {
    margin-right: 1rem!important
}

.margin--md {
    margin: 1rem!important
}

.margin-bottom--lg,.margin-vert--lg {
    margin-bottom: 2rem!important
}

.margin-top--lg,.margin-vert--lg {
    margin-top: 2rem!important
}

.margin-horiz--lg,.margin-left--lg {
    margin-left: 2rem!important
}

.margin-horiz--lg,.margin-right--lg {
    margin-right: 2rem!important
}

.margin--lg {
    margin: 2rem!important
}

.margin-bottom--xl,.margin-vert--xl {
    margin-bottom: 5rem!important
}

.margin-top--xl,.margin-vert--xl {
    margin-top: 5rem!important
}

.margin-horiz--xl,.margin-left--xl {
    margin-left: 5rem!important
}

.margin-horiz--xl,.margin-right--xl {
    margin-right: 5rem!important
}

.margin--xl {
    margin: 5rem!important
}

.padding--none {
    padding: 0!important
}

.padding-bottom--xs,.padding-vert--xs {
    padding-bottom: .25rem!important
}

.padding-top--xs,.padding-vert--xs {
    padding-top: .25rem!important
}

.padding-horiz--xs,.padding-left--xs {
    padding-left: .25rem!important
}

.padding-horiz--xs,.padding-right--xs {
    padding-right: .25rem!important
}

.padding--xs {
    padding: .25rem!important
}

.padding-bottom--sm,.padding-vert--sm {
    padding-bottom: .5rem!important
}

.padding-top--sm,.padding-vert--sm {
    padding-top: .5rem!important
}

.padding-horiz--sm,.padding-left--sm {
    padding-left: .5rem!important
}

.padding-horiz--sm,.padding-right--sm {
    padding-right: .5rem!important
}

.padding--sm {
    padding: .5rem!important
}

.padding-bottom--md,.padding-vert--md {
    padding-bottom: 1rem!important
}

.padding-top--md,.padding-vert--md {
    padding-top: 1rem!important
}

.padding-horiz--md,.padding-left--md {
    padding-left: 1rem!important
}

.padding-horiz--md,.padding-right--md {
    padding-right: 1rem!important
}

.padding--md {
    padding: 1rem!important
}

.padding-bottom--lg,.padding-vert--lg {
    padding-bottom: 2rem!important
}

.padding-top--lg,.padding-vert--lg {
    padding-top: 2rem!important
}

.padding-horiz--lg,.padding-left--lg {
    padding-left: 2rem!important
}

.padding-horiz--lg,.padding-right--lg {
    padding-right: 2rem!important
}

.padding--lg {
    padding: 2rem!important
}

.padding-bottom--xl,.padding-vert--xl {
    padding-bottom: 5rem!important
}

.padding-top--xl,.padding-vert--xl {
    padding-top: 5rem!important
}

.padding-horiz--xl,.padding-left--xl {
    padding-left: 5rem!important
}

.padding-horiz--xl,.padding-right--xl {
    padding-right: 5rem!important
}

.padding--xl {
    padding: 5rem!important
}

code {
    background-color: var(--ifm-code-background);
    border: .1rem solid #0000001a;
    border-radius: var(--ifm-code-border-radius);
    font-family: var(--ifm-font-family-monospace);
    font-size: var(--ifm-code-font-size);
    padding: var(--ifm-code-padding-vertical) var(--ifm-code-padding-horizontal)
}

a code {
    color: inherit
}

pre {
    background-color: var(--ifm-pre-background);
    border-radius: var(--ifm-pre-border-radius);
    color: var(--ifm-pre-color);
    font: var(--ifm-code-font-size)/var(--ifm-pre-line-height) var(--ifm-font-family-monospace);
    padding: var(--ifm-pre-padding)
}

pre code {
    background-color: initial;
    border: none;
    font-size: 100%;
    line-height: inherit;
    padding: 0
}

kbd {
    background-color: var(--ifm-color-emphasis-0);
    border: 1px solid var(--ifm-color-emphasis-400);
    border-radius: .2rem;
    box-shadow: inset 0 -1px 0 var(--ifm-color-emphasis-400);
    color: var(--ifm-color-emphasis-800);
    font: 80% var(--ifm-font-family-monospace);
    padding: .15rem .3rem
}

h1,h2,h3,h4,h5,h6 {
    color: var(--ifm-heading-color);
    font-family: var(--ifm-heading-font-family);
    font-weight: var(--ifm-heading-font-weight);
    line-height: var(--ifm-heading-line-height);
    margin: var(--ifm-heading-margin-top) 0 var(--ifm-heading-margin-bottom) 0
}

h1 {
    font-size: var(--ifm-h1-font-size);
    margin-top: calc(var(--ifm-h1-vertical-rhythm-top)*var(--ifm-leading)/2)
}

h2 {
    font-size: var(--ifm-h2-font-size)
}

h3 {
    font-size: var(--ifm-h3-font-size)
}

h4 {
    font-size: var(--ifm-h4-font-size)
}

h5 {
    font-size: var(--ifm-h5-font-size)
}

h6 {
    font-size: var(--ifm-h6-font-size)
}

.markdown img,.markdown video,.uppy-size--md .uppy-ScreenCapture-videoContainer,img {
    max-width: 100%
}

img[align=right] {
    padding-left: var(--image-alignment-padding)
}

img[align=left] {
    padding-right: var(--image-alignment-padding)
}

.markdown {
    --ifm-h1-vertical-rhythm-top: 3;
    --ifm-h2-vertical-rhythm-top: 2;
    --ifm-h3-vertical-rhythm-top: 1.5;
    --ifm-heading-vertical-rhythm-top: 1.25;
    --ifm-h1-vertical-rhythm-bottom: 1.25;
    --ifm-heading-vertical-rhythm-bottom: 1
}

.markdown:after,.markdown:before {
    content: "";
    display: table
}

.markdown:after {
    clear: both
}

.markdown h1:first-child {
    --ifm-h1-font-size: 3rem;
    margin-bottom: calc(var(--ifm-h1-vertical-rhythm-bottom)*var(--ifm-leading))
}

.markdown>h2 {
    --ifm-h2-font-size: 2rem;
    margin-top: calc(var(--ifm-h2-vertical-rhythm-top)*var(--ifm-leading));
    --ifm-h2-font-size: 1.75rem
}

.markdown>h3 {
    --ifm-h3-font-size: 1.5rem;
    margin-top: calc(var(--ifm-h3-vertical-rhythm-top)*var(--ifm-leading));
    --ifm-h3-font-size: 1.3rem
}

.markdown>h4,.markdown>h5,.markdown>h6 {
    margin-top: calc(var(--ifm-heading-vertical-rhythm-top)*var(--ifm-leading))
}

.markdown>p,.markdown>pre,.markdown>ul,.tabList__CuJ {
    margin-bottom: var(--ifm-leading)
}

.markdown li>p {
    margin-top: var(--ifm-list-paragraph-margin)
}

.markdown li+li {
    margin-top: var(--ifm-list-item-margin)
}

ol,ul {
    margin: 0 0 var(--ifm-list-margin);
    padding-left: var(--ifm-list-left-padding)
}

ol ol,ul ol {
    list-style-type: lower-roman
}

ol ol ol,ol ul ol,ul ol ol,ul ul ol {
    list-style-type: lower-alpha
}

table {
    border-collapse: collapse;
    display: block;
    margin-bottom: var(--ifm-spacing-vertical)
}

table thead tr {
    border-bottom: 2px solid var(--ifm-table-border-color)
}

table thead,table tr:nth-child(2n) {
    background-color: var(--ifm-table-stripe-background)
}

table tr {
    background-color: var(--ifm-table-background);
    border-top: var(--ifm-table-border-width) solid var(--ifm-table-border-color)
}

table td,table th {
    border: var(--ifm-table-border-width) solid var(--ifm-table-border-color);
    padding: var(--ifm-table-cell-padding)
}

table th {
    background-color: var(--ifm-table-head-background);
    color: var(--ifm-table-head-color);
    font-weight: var(--ifm-table-head-font-weight)
}

table td {
    color: var(--ifm-table-cell-color)
}

strong {
    font-weight: var(--ifm-font-weight-bold)
}

a {
    color: var(--ifm-link-color);
    text-decoration: var(--ifm-link-decoration)
}

a:hover {
    color: var(--ifm-link-hover-color);
    text-decoration: var(--ifm-link-hover-decoration)
}

.button:hover,.text--no-decoration,.text--no-decoration:hover,a:not([href]) {
    text-decoration: none
}

p {
    margin: 0 0 var(--ifm-paragraph-margin-bottom)
}

blockquote {
    border-left: var(--ifm-blockquote-border-left-width) solid var(--ifm-blockquote-border-color);
    box-shadow: var(--ifm-blockquote-shadow);
    color: var(--ifm-blockquote-color);
    font-size: var(--ifm-blockquote-font-size);
    padding: var(--ifm-blockquote-padding-vertical) var(--ifm-blockquote-padding-horizontal)
}

blockquote>:first-child {
    margin-top: 0
}

blockquote>:last-child {
    margin-bottom: 0
}

hr {
    background-color: var(--ifm-hr-background-color);
    border: 0;
    height: var(--ifm-hr-height);
    margin: var(--ifm-hr-margin-vertical) 0
}

.shadow--lw {
    box-shadow: var(--ifm-global-shadow-lw)!important
}

.shadow--md {
    box-shadow: var(--ifm-global-shadow-md)!important
}

.shadow--tl {
    box-shadow: var(--ifm-global-shadow-tl)!important
}

.text--primary,.wordWrapButtonEnabled_EoeP .wordWrapButtonIcon_Bwma {
    color: var(--ifm-color-primary)
}

.text--secondary {
    color: var(--ifm-color-secondary)
}

.text--success {
    color: var(--ifm-color-success)
}

.text--info {
    color: var(--ifm-color-info)
}

.text--warning {
    color: var(--ifm-color-warning)
}

.text--danger {
    color: var(--ifm-color-danger)
}

.text--center,.uppy-c-btn,[dir=rtl] .uppy-c-btn {
    text-align: center
}

.text--left,[dir=ltr] .uppy-Provider-breadcrumbs {
    text-align: left
}

.text--justify {
    text-align: justify
}

.text--right,.uppy-Root[dir=rtl],[dir=rtl] .uppy-Provider-breadcrumbs,[dir=rtl] .uppy-Root,[dir=rtl] .uppy-u-reset {
    text-align: right
}

.text--capitalize {
    text-transform: capitalize
}

.text--lowercase {
    text-transform: lowercase
}

.admonitionHeading_Gvgb,.alert__heading,.text--uppercase,.uppy-Dashboard-Item-statusSize {
    text-transform: uppercase
}

.text--light {
    font-weight: var(--ifm-font-weight-light)
}

.text--normal {
    font-weight: var(--ifm-font-weight-normal)
}

.text--semibold {
    font-weight: var(--ifm-font-weight-semibold)
}

.text--bold {
    font-weight: var(--ifm-font-weight-bold)
}

.text--italic {
    font-style: italic
}

.text--truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
}

.text--break {
    word-wrap: break-word!important;
    word-break: break-word!important
}

.clean-btn {
    background: none;
    border: none;
    color: inherit;
    cursor: pointer;
    font-family: inherit;
    padding: 0
}

.alert,.alert .close {
    color: var(--ifm-alert-foreground-color)
}

.clean-list {
    list-style: none;
    padding-left: 0
}

.alert--primary {
    --ifm-alert-background-color: var(--ifm-color-primary-contrast-background);
    --ifm-alert-background-color-highlight: #3578e526;
    --ifm-alert-foreground-color: var(--ifm-color-primary-contrast-foreground);
    --ifm-alert-border-color: var(--ifm-color-primary-dark)
}

.alert--secondary {
    --ifm-alert-background-color: var(--ifm-color-secondary-contrast-background);
    --ifm-alert-background-color-highlight: #ebedf026;
    --ifm-alert-foreground-color: var(--ifm-color-secondary-contrast-foreground);
    --ifm-alert-border-color: var(--ifm-color-secondary-dark)
}

.alert--success {
    --ifm-alert-background-color: var(--ifm-color-success-contrast-background);
    --ifm-alert-background-color-highlight: #00a40026;
    --ifm-alert-foreground-color: var(--ifm-color-success-contrast-foreground);
    --ifm-alert-border-color: var(--ifm-color-success-dark)
}

.alert--info {
    --ifm-alert-background-color: var(--ifm-color-info-contrast-background);
    --ifm-alert-background-color-highlight: #54c7ec26;
    --ifm-alert-foreground-color: var(--ifm-color-info-contrast-foreground);
    --ifm-alert-border-color: var(--ifm-color-info-dark)
}

.alert--warning {
    --ifm-alert-background-color: var(--ifm-color-warning-contrast-background);
    --ifm-alert-background-color-highlight: #ffba0026;
    --ifm-alert-foreground-color: var(--ifm-color-warning-contrast-foreground);
    --ifm-alert-border-color: var(--ifm-color-warning-dark)
}

.alert--danger {
    --ifm-alert-background-color: var(--ifm-color-danger-contrast-background);
    --ifm-alert-background-color-highlight: #fa383e26;
    --ifm-alert-foreground-color: var(--ifm-color-danger-contrast-foreground);
    --ifm-alert-border-color: var(--ifm-color-danger-dark)
}

.alert {
    --ifm-code-background: var(--ifm-alert-background-color-highlight);
    --ifm-link-color: var(--ifm-alert-foreground-color);
    --ifm-link-hover-color: var(--ifm-alert-foreground-color);
    --ifm-link-decoration: underline;
    --ifm-tabs-color: var(--ifm-alert-foreground-color);
    --ifm-tabs-color-active: var(--ifm-alert-foreground-color);
    --ifm-tabs-color-active-border: var(--ifm-alert-border-color);
    background-color: var(--ifm-alert-background-color);
    border: var(--ifm-alert-border-width) solid var(--ifm-alert-border-color);
    border-left-width: var(--ifm-alert-border-left-width);
    border-radius: var(--ifm-alert-border-radius);
    box-shadow: var(--ifm-alert-shadow);
    padding: var(--ifm-alert-padding-vertical) var(--ifm-alert-padding-horizontal)
}

.alert__heading {
    align-items: center;
    display: flex;
    font: 700 var(--ifm-h5-font-size)/var(--ifm-heading-line-height) var(--ifm-heading-font-family);
    margin-bottom: .5rem
}

.alert__icon {
    display: inline-flex;
    margin-right: .4em
}

.alert__icon svg {
    fill: var(--ifm-alert-foreground-color);
    stroke: var(--ifm-alert-foreground-color);
    stroke-width: 0
}

.alert .close {
    margin: calc(var(--ifm-alert-padding-vertical)*-1) calc(var(--ifm-alert-padding-horizontal)*-1) 0 0;
    opacity: .75
}

.alert .close:focus,.alert .close:hover,.hash-link:focus,.uppy-ProviderBrowser-viewType--grid .uppy-ProviderBrowserItem--is-checked .uppy-ProviderBrowserItem-checkbox,.uppy-ProviderBrowser-viewType--unsplash .uppy-ProviderBrowserItem--is-checked .uppy-ProviderBrowserItem-checkbox,.uppy-StatusBar-actionCircleBtn:hover,:hover>.hash-link {
    opacity: 1
}

.alert a {
    text-decoration-color: var(--ifm-alert-border-color)
}

.alert a:hover {
    text-decoration-thickness: 2px
}

.avatar {
    column-gap: var(--ifm-avatar-intro-margin);
    display: flex
}

.avatar__photo {
    border-radius: 50%;
    display: block;
    height: var(--ifm-avatar-photo-size);
    overflow: hidden;
    width: var(--ifm-avatar-photo-size)
}

.card--full-height,.navbar__logo img,body,html {
    height: 100%
}

.avatar__photo--sm {
    --ifm-avatar-photo-size: 2rem
}

.avatar__photo--lg {
    --ifm-avatar-photo-size: 4rem
}

.avatar__photo--xl {
    --ifm-avatar-photo-size: 6rem
}

.avatar__intro {
    display: flex;
    flex: 1 1;
    flex-direction: column;
    justify-content: center;
    text-align: var(--ifm-avatar-intro-alignment)
}

.badge,.breadcrumbs__item,.breadcrumbs__link,.button,.dropdown>.navbar__link:after {
    display: inline-block
}

.avatar__name {
    font: 700 var(--ifm-h4-font-size)/var(--ifm-heading-line-height) var(--ifm-font-family-base)
}

.avatar__subtitle {
    margin-top: .25rem
}

.avatar--vertical {
    --ifm-avatar-intro-alignment: center;
    align-items: center;
    flex-direction: column
}

.badge {
    background-color: var(--ifm-badge-background-color);
    border: var(--ifm-badge-border-width) solid var(--ifm-badge-border-color);
    border-radius: var(--ifm-badge-border-radius);
    color: var(--ifm-badge-color);
    font-size: 75%;
    font-weight: var(--ifm-font-weight-bold);
    line-height: 1;
    padding: var(--ifm-badge-padding-vertical) var(--ifm-badge-padding-horizontal)
}

.badge--primary {
    --ifm-badge-background-color: var(--ifm-color-primary)
}

.badge--secondary {
    --ifm-badge-background-color: var(--ifm-color-secondary);
    color: var(--ifm-color-black)
}

.breadcrumbs__link,.button.button--secondary.button--outline:not(.button--active):not(:hover) {
    color: var(--ifm-font-color-base)
}

.badge--success {
    --ifm-badge-background-color: var(--ifm-color-success)
}

.badge--info {
    --ifm-badge-background-color: var(--ifm-color-info)
}

.badge--warning {
    --ifm-badge-background-color: var(--ifm-color-warning)
}

.badge--danger {
    --ifm-badge-background-color: var(--ifm-color-danger)
}

.breadcrumbs {
    margin-bottom: 0;
    padding-left: 0
}

.breadcrumbs__item:not(:last-child):after {
    background: var(--ifm-breadcrumb-separator) center;
    content: " ";
    display: inline-block;
    filter: var(--ifm-breadcrumb-separator-filter);
    height: calc(var(--ifm-breadcrumb-separator-size)*var(--ifm-breadcrumb-size-multiplier)*var(--ifm-breadcrumb-separator-size-multiplier));
    margin: 0 var(--ifm-breadcrumb-spacing);
    opacity: .5;
    width: calc(var(--ifm-breadcrumb-separator-size)*var(--ifm-breadcrumb-size-multiplier)*var(--ifm-breadcrumb-separator-size-multiplier))
}

.breadcrumbs__item--active .breadcrumbs__link {
    background: var(--ifm-breadcrumb-item-background-active);
    color: var(--ifm-breadcrumb-color-active)
}

.breadcrumbs__link {
    border-radius: var(--ifm-breadcrumb-border-radius);
    font-size: calc(1rem*var(--ifm-breadcrumb-size-multiplier));
    padding: calc(var(--ifm-breadcrumb-padding-vertical)*var(--ifm-breadcrumb-size-multiplier)) calc(var(--ifm-breadcrumb-padding-horizontal)*var(--ifm-breadcrumb-size-multiplier));
    transition-duration: var(--ifm-transition-fast);
    transition-property: background,color
}

.breadcrumbs__link:any-link:hover,.breadcrumbs__link:link:hover,.breadcrumbs__link:visited:hover,area[href].breadcrumbs__link:hover {
    background: var(--ifm-breadcrumb-item-background-active);
    text-decoration: none
}

.breadcrumbs--sm {
    --ifm-breadcrumb-size-multiplier: 0.8
}

.breadcrumbs--lg {
    --ifm-breadcrumb-size-multiplier: 1.2
}

.button {
    background-color: var(--ifm-button-background-color);
    border: var(--ifm-button-border-width) solid var(--ifm-button-border-color);
    border-radius: var(--ifm-button-border-radius);
    cursor: pointer;
    font-size: calc(.875rem*var(--ifm-button-size-multiplier));
    font-weight: var(--ifm-button-font-weight);
    line-height: 1.5;
    padding: calc(var(--ifm-button-padding-vertical)*var(--ifm-button-size-multiplier)) calc(var(--ifm-button-padding-horizontal)*var(--ifm-button-size-multiplier));
    text-align: center;
    transition-duration: var(--ifm-button-transition-duration);
    transition-property: color,background,border-color;
    -webkit-user-select: none;
    user-select: none;
    white-space: nowrap
}

.button,.button:hover {
    color: var(--ifm-button-color)
}

.button--outline {
    --ifm-button-color: var(--ifm-button-border-color)
}

.button--outline:hover {
    --ifm-button-background-color: var(--ifm-button-border-color)
}

.button--link {
    --ifm-button-border-color: #0000;
    color: var(--ifm-link-color);
    text-decoration: var(--ifm-link-decoration)
}

.button--link.button--active,.button--link:active,.button--link:hover {
    color: var(--ifm-link-hover-color);
    text-decoration: var(--ifm-link-hover-decoration)
}

.button.disabled,.button:disabled,.button[disabled] {
    opacity: .65;
    pointer-events: none
}

.button--sm {
    --ifm-button-size-multiplier: 0.8
}

.button--lg {
    --ifm-button-size-multiplier: 1.35
}

.button--block {
    display: block;
    width: 100%
}

.button.button--secondary {
    color: var(--ifm-color-gray-900)
}

:where(.button--primary) {
    --ifm-button-background-color: var(--ifm-color-primary);
    --ifm-button-border-color: var(--ifm-color-primary)
}

:where(.button--primary):not(.button--outline):hover {
    --ifm-button-background-color: var(--ifm-color-primary-dark);
    --ifm-button-border-color: var(--ifm-color-primary-dark)
}

.button--primary.button--active,.button--primary:active {
    --ifm-button-background-color: var(--ifm-color-primary-darker);
    --ifm-button-border-color: var(--ifm-color-primary-darker)
}

:where(.button--secondary) {
    --ifm-button-background-color: var(--ifm-color-secondary);
    --ifm-button-border-color: var(--ifm-color-secondary)
}

:where(.button--secondary):not(.button--outline):hover {
    --ifm-button-background-color: var(--ifm-color-secondary-dark);
    --ifm-button-border-color: var(--ifm-color-secondary-dark)
}

.button--secondary.button--active,.button--secondary:active {
    --ifm-button-background-color: var(--ifm-color-secondary-darker);
    --ifm-button-border-color: var(--ifm-color-secondary-darker)
}

:where(.button--success) {
    --ifm-button-background-color: var(--ifm-color-success);
    --ifm-button-border-color: var(--ifm-color-success)
}

:where(.button--success):not(.button--outline):hover {
    --ifm-button-background-color: var(--ifm-color-success-dark);
    --ifm-button-border-color: var(--ifm-color-success-dark)
}

.button--success.button--active,.button--success:active {
    --ifm-button-background-color: var(--ifm-color-success-darker);
    --ifm-button-border-color: var(--ifm-color-success-darker)
}

:where(.button--info) {
    --ifm-button-background-color: var(--ifm-color-info);
    --ifm-button-border-color: var(--ifm-color-info)
}

:where(.button--info):not(.button--outline):hover {
    --ifm-button-background-color: var(--ifm-color-info-dark);
    --ifm-button-border-color: var(--ifm-color-info-dark)
}

.button--info.button--active,.button--info:active {
    --ifm-button-background-color: var(--ifm-color-info-darker);
    --ifm-button-border-color: var(--ifm-color-info-darker)
}

:where(.button--warning) {
    --ifm-button-background-color: var(--ifm-color-warning);
    --ifm-button-border-color: var(--ifm-color-warning)
}

:where(.button--warning):not(.button--outline):hover {
    --ifm-button-background-color: var(--ifm-color-warning-dark);
    --ifm-button-border-color: var(--ifm-color-warning-dark)
}

.button--warning.button--active,.button--warning:active {
    --ifm-button-background-color: var(--ifm-color-warning-darker);
    --ifm-button-border-color: var(--ifm-color-warning-darker)
}

:where(.button--danger) {
    --ifm-button-background-color: var(--ifm-color-danger);
    --ifm-button-border-color: var(--ifm-color-danger)
}

:where(.button--danger):not(.button--outline):hover {
    --ifm-button-background-color: var(--ifm-color-danger-dark);
    --ifm-button-border-color: var(--ifm-color-danger-dark)
}

.button--danger.button--active,.button--danger:active {
    --ifm-button-background-color: var(--ifm-color-danger-darker);
    --ifm-button-border-color: var(--ifm-color-danger-darker)
}

.button-group {
    display: inline-flex;
    gap: var(--ifm-button-group-spacing)
}

.button-group>.button:not(:first-child) {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0
}

.button-group>.button:not(:last-child) {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0
}

.button-group--block {
    display: flex;
    justify-content: stretch
}

.button-group--block>.button,.uppy-ImageCropper-container {
    flex-grow: 1
}

.card {
    background-color: var(--ifm-card-background-color);
    border-radius: var(--ifm-card-border-radius);
    box-shadow: var(--ifm-global-shadow-lw);
    display: flex;
    flex-direction: column;
    overflow: hidden
}

.card__image {
    padding-top: var(--ifm-card-vertical-spacing)
}

.card__image:first-child,.uppy-size--md .uppy-ImageCropper-controls {
    padding-top: 0
}

.card__body,.card__footer,.card__header {
    padding: var(--ifm-card-vertical-spacing) var(--ifm-card-horizontal-spacing)
}

.card__body:not(:last-child),.card__footer:not(:last-child),.card__header:not(:last-child) {
    padding-bottom: 0
}

.card__body>:last-child,.card__footer>:last-child,.card__header>:last-child {
    margin-bottom: 0
}

.card__footer {
    margin-top: auto
}

.table-of-contents {
    font-size: .8rem;
    margin-bottom: 0;
    padding: var(--ifm-toc-padding-vertical) 0
}

.table-of-contents,.table-of-contents ul {
    list-style: none;
    padding-left: var(--ifm-toc-padding-horizontal)
}

.table-of-contents li {
    margin: var(--ifm-toc-padding-vertical) var(--ifm-toc-padding-horizontal)
}

.table-of-contents__left-border {
    border-left: 1px solid var(--ifm-toc-border-color)
}

.table-of-contents__link {
    color: var(--ifm-toc-link-color);
    display: block
}

.table-of-contents__link--active,.table-of-contents__link--active code,.table-of-contents__link:hover,.table-of-contents__link:hover code {
    color: var(--ifm-color-primary);
    text-decoration: none
}

.close {
    color: var(--ifm-color-black);
    float: right;
    font-size: 1.5rem;
    font-weight: var(--ifm-font-weight-bold);
    line-height: 1;
    opacity: .5;
    padding: 1rem;
    transition: opacity var(--ifm-transition-fast) var(--ifm-transition-timing-default)
}

.close:hover {
    opacity: .7
}

.close:focus,.theme-code-block-highlighted-line .codeLineNumber_Tfdd:before {
    opacity: .8
}

.dropdown {
    display: inline-flex;
    font-weight: var(--ifm-dropdown-font-weight);
    position: relative;
    vertical-align: top
}

.iconLanguage_nlXk,.uppy-StatusBar-statusIndicator svg {
    vertical-align: text-bottom
}

.dropdown--hoverable:hover .dropdown__menu,.dropdown--show .dropdown__menu {
    opacity: 1;
    pointer-events: all;
    transform: translateY(-1px);
    visibility: visible
}

.dropdown--right .dropdown__menu {
    left: inherit;
    right: 0
}

.dropdown--nocaret .navbar__link:after {
    content: none!important
}

.dropdown__menu {
    background-color: var(--ifm-dropdown-background-color);
    border-radius: var(--ifm-global-radius);
    box-shadow: var(--ifm-global-shadow-md);
    left: 0;
    list-style: none;
    max-height: 80vh;
    min-width: 10rem;
    opacity: 0;
    overflow-y: auto;
    padding: .5rem;
    pointer-events: none;
    position: absolute;
    top: calc(100% - var(--ifm-navbar-item-padding-vertical) + .3rem);
    transform: translateY(-.625rem);
    transition-duration: var(--ifm-transition-fast);
    transition-property: opacity,transform,visibility;
    transition-timing-function: var(--ifm-transition-timing-default);
    visibility: hidden;
    z-index: var(--ifm-z-index-dropdown)
}

.menu__caret,.menu__link,.menu__list-item-collapsible {
    border-radius: .25rem;
    transition: background var(--ifm-transition-fast) var(--ifm-transition-timing-default)
}

.dropdown__link {
    border-radius: .25rem;
    color: var(--ifm-dropdown-link-color);
    display: block;
    font-size: .875rem;
    margin-top: .2rem;
    padding: .25rem .5rem;
    white-space: nowrap
}

.dropdown__link--active,.dropdown__link:hover {
    background-color: var(--ifm-dropdown-hover-background-color);
    color: var(--ifm-dropdown-link-color);
    text-decoration: none
}

.dropdown__link--active,.dropdown__link--active:hover {
    --ifm-dropdown-link-color: var(--ifm-link-color)
}

.dropdown>.navbar__link:after {
    border-color: currentcolor #0000;
    border-style: solid;
    border-width: .4em .4em 0;
    content: "";
    margin-left: .3em;
    position: relative;
    top: 2px;
    transform: translateY(-50%)
}

.footer {
    background-color: var(--ifm-footer-background-color);
    color: var(--ifm-footer-color);
    padding: var(--ifm-footer-padding-vertical) var(--ifm-footer-padding-horizontal)
}

.footer--dark {
    --ifm-footer-background-color: #303846;
    --ifm-footer-color: var(--ifm-footer-link-color);
    --ifm-footer-link-color: var(--ifm-color-secondary);
    --ifm-footer-title-color: var(--ifm-color-white)
}

.footer__links {
    margin-bottom: 1rem
}

.footer__link-item {
    color: var(--ifm-footer-link-color);
    line-height: 2
}

.footer__link-item:hover {
    color: var(--ifm-footer-link-hover-color)
}

.footer__link-separator {
    margin: 0 var(--ifm-footer-link-horizontal-spacing)
}

.footer__logo {
    margin-top: 1rem;
    max-width: var(--ifm-footer-logo-max-width)
}

.footer__title {
    color: var(--ifm-footer-title-color);
    font: 700 var(--ifm-h4-font-size)/var(--ifm-heading-line-height) var(--ifm-font-family-base);
    margin-bottom: var(--ifm-heading-margin-bottom)
}

.menu,.navbar__link {
    font-weight: var(--ifm-font-weight-semibold)
}

.footer__item {
    margin-top: 0
}

.admonitionContent_BuS1>:last-child,.collapsibleContent_i85q p:last-child,.details_lb9f>summary>p:last-child,.footer__items,.tabItem_Ymn6>:last-child,.uppy-size--md .uppy-Provider-breadcrumbs {
    margin-bottom: 0
}

.codeBlockStandalone_MEMb,[type=checkbox] {
    padding: 0
}

.hero {
    align-items: center;
    background-color: var(--ifm-hero-background-color);
    color: var(--ifm-hero-text-color);
    display: flex;
    padding: 4rem 2rem
}

.hero--primary {
    --ifm-hero-background-color: var(--ifm-color-primary);
    --ifm-hero-text-color: var(--ifm-font-color-base-inverse)
}

.hero--dark {
    --ifm-hero-background-color: #303846;
    --ifm-hero-text-color: var(--ifm-color-white)
}

.h1_kkW1,.hero__title,.title_f1Hy {
    font-size: 3rem
}

.hero__subtitle {
    font-size: 1.5rem
}

.menu__list {
    list-style: none;
    margin: 0;
    padding-left: 0
}

.menu__caret,.menu__link {
    padding: var(--ifm-menu-link-padding-vertical) var(--ifm-menu-link-padding-horizontal)
}

.menu__list .menu__list {
    flex: 0 0 100%;
    margin-top: .25rem;
    padding-left: var(--ifm-menu-link-padding-horizontal)
}

.menu__list-item:not(:first-child) {
    margin-top: .25rem
}

.menu__list-item--collapsed .menu__list {
    height: 0;
    overflow: hidden
}

.details_lb9f[data-collapsed=false].isBrowser_bmU9>summary:before,.details_lb9f[open]:not(.isBrowser_bmU9)>summary:before,.menu__list-item--collapsed .menu__caret:before,.menu__list-item--collapsed .menu__link--sublist:after {
    transform: rotate(90deg)
}

.menu__list-item-collapsible {
    display: flex;
    flex-wrap: wrap;
    position: relative
}

.menu__caret:hover,.menu__link:hover,.menu__list-item-collapsible--active,.menu__list-item-collapsible:hover {
    background: var(--ifm-menu-color-background-hover)
}

.menu__list-item-collapsible .menu__link--active,.menu__list-item-collapsible .menu__link:hover {
    background: none!important
}

.menu__caret,.menu__link {
    align-items: center;
    display: flex
}

.menu__link {
    color: var(--ifm-menu-color);
    flex: 1;
    line-height: 1.25
}

.menu__link:hover {
    color: var(--ifm-menu-color);
    text-decoration: none
}

.menu__caret:before,.menu__link--sublist-caret:after {
    content: "";
    filter: var(--ifm-menu-link-sublist-icon-filter);
    height: 1.25rem;
    transform: rotate(180deg);
    transition: transform var(--ifm-transition-fast) linear;
    width: 1.25rem
}

.menu__link--sublist-caret:after {
    background: var(--ifm-menu-link-sublist-icon) 50%/2rem 2rem;
    margin-left: auto;
    min-width: 1.25rem
}

.menu__link--active,.menu__link--active:hover {
    color: var(--ifm-menu-color-active)
}

.navbar__brand,.navbar__link {
    color: var(--ifm-navbar-link-color)
}

.menu__link--active:not(.menu__link--sublist) {
    background-color: var(--ifm-menu-color-background-active)
}

.menu__caret:before {
    background: var(--ifm-menu-link-sublist-icon) 50%/2rem 2rem
}

.navbar--dark,html[data-theme=dark] {
    --ifm-menu-link-sublist-icon-filter: invert(100%) sepia(94%) saturate(17%) hue-rotate(223deg) brightness(104%) contrast(98%)
}

.navbar {
    background-color: var(--ifm-navbar-background-color);
    box-shadow: var(--ifm-navbar-shadow);
    height: var(--ifm-navbar-height);
    padding: var(--ifm-navbar-padding-vertical) var(--ifm-navbar-padding-horizontal)
}

.navbar,.navbar>.container,.navbar>.container-fluid {
    display: flex
}

.navbar--fixed-top {
    position: sticky;
    top: 0;
    z-index: var(--ifm-z-index-fixed)
}

.navbar-sidebar,.navbar-sidebar__backdrop {
    bottom: 0;
    opacity: 0;
    position: fixed;
    transition-duration: var(--ifm-transition-fast);
    transition-timing-function: ease-in-out;
    top: 0;
    visibility: hidden;
    left: 0
}

.navbar__inner {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 100%
}

.navbar__brand {
    align-items: center;
    display: flex;
    margin-right: 1rem;
    min-width: 0
}

.navbar__brand:hover {
    color: var(--ifm-navbar-link-hover-color);
    text-decoration: none
}

.announcementBarContent_xLdY,.navbar__title {
    flex: 1 1 auto
}

.navbar__toggle {
    display: none;
    margin-right: .5rem
}

.navbar__logo {
    flex: 0 0 auto;
    height: 2rem;
    margin-right: .5rem
}

.navbar__items {
    align-items: center;
    display: flex;
    flex: 1;
    min-width: 0
}

.navbar__items--center {
    flex: 0 0 auto
}

.navbar__items--center .navbar__brand {
    margin: 0
}

.navbar__items--center+.navbar__items--right {
    flex: 1
}

.navbar__items--right {
    flex: 0 0 auto;
    justify-content: flex-end
}

.navbar__items--right>:last-child,[dir=ltr] .uppy-Dashboard:not(.uppy-Dashboard--singleFile) .uppy-Dashboard-Item {
    padding-right: 0
}


.navbar__item {
    display: inline-block;
    padding: var(--ifm-navbar-item-padding-vertical) var(--ifm-navbar-item-padding-horizontal)
}

#nprogress,.navbar__item.dropdown .navbar__link:not([href]) {
    pointer-events: none
}

.navbar__link--active,.navbar__link:hover {
    color: var(--ifm-navbar-link-hover-color);
    text-decoration: none
}

.navbar--dark,.navbar--primary {
    --ifm-menu-color: var(--ifm-color-gray-300);
    --ifm-navbar-link-color: var(--ifm-color-gray-100);
    --ifm-navbar-search-input-background-color: #ffffff1a;
    --ifm-navbar-search-input-placeholder-color: #ffffff80;
    color: var(--ifm-color-white)
}

.navbar--dark {
    --ifm-navbar-background-color: #242526;
    --ifm-menu-color-background-active: #ffffff0d;
    --ifm-navbar-search-input-color: var(--ifm-color-white)
}

.navbar--primary {
    --ifm-navbar-background-color: var(--ifm-color-primary);
    --ifm-navbar-link-hover-color: var(--ifm-color-white);
    --ifm-menu-color-active: var(--ifm-color-white);
    --ifm-navbar-search-input-color: var(--ifm-color-emphasis-500)
}

.navbar__search-input {
    appearance: none;
    background: var(--ifm-navbar-search-input-background-color) var(--ifm-navbar-search-input-icon) no-repeat .75rem center/1rem 1rem;
    border: none;
    border-radius: 2rem;
    color: var(--ifm-navbar-search-input-color);
    cursor: text;
    display: inline-block;
    font-size: .9rem;
    height: 2rem;
    padding: 0 .5rem 0 2.25rem;
    width: 12.5rem
}

.navbar__search-input::placeholder {
    color: var(--ifm-navbar-search-input-placeholder-color)
}

.navbar-sidebar {
    background-color: var(--ifm-navbar-background-color);
    box-shadow: var(--ifm-global-shadow-md);
    transform: translate3d(-100%,0,0);
    transition-property: opacity,visibility,transform;
    width: var(--ifm-navbar-sidebar-width)
}

.navbar-sidebar--show .navbar-sidebar,.navbar-sidebar--show .navbar-sidebar__backdrop {
    opacity: 1;
    visibility: visible
}

.navbar-sidebar--show .navbar-sidebar {
    transform: translateZ(0)
}

.navbar-sidebar__backdrop {
    background-color: #0009;
    right: 0;
    transition-property: opacity,visibility
}

.navbar-sidebar__brand {
    align-items: center;
    box-shadow: var(--ifm-navbar-shadow);
    display: flex;
    flex: 1;
    height: var(--ifm-navbar-height);
    padding: var(--ifm-navbar-padding-vertical) var(--ifm-navbar-padding-horizontal)
}

.navbar-sidebar__items {
    display: flex;
    height: calc(100% - var(--ifm-navbar-height));
    transform: translateZ(0);
    transition: transform var(--ifm-transition-fast) ease-in-out
}

.navbar-sidebar__items--show-secondary {
    transform: translate3d(calc((var(--ifm-navbar-sidebar-width))*-1),0,0)
}

.navbar-sidebar__item {
    flex-shrink: 0;
    padding: .5rem;
    width: calc(var(--ifm-navbar-sidebar-width))
}

.navbar-sidebar__back {
    background: var(--ifm-menu-color-background-active);
    font-size: 15px;
    font-weight: var(--ifm-button-font-weight);
    margin: 0 0 .2rem -.5rem;
    padding: .6rem 1.5rem;
    position: relative;
    text-align: left;
    top: -.5rem;
    width: calc(100% + 1rem)
}

.navbar-sidebar__close {
    display: flex;
    margin-left: auto
}

.pagination {
    column-gap: var(--ifm-pagination-page-spacing);
    display: flex;
    font-size: var(--ifm-pagination-font-size);
    padding-left: 0
}

.pagination--sm {
    --ifm-pagination-font-size: 0.8rem;
    --ifm-pagination-padding-horizontal: 0.8rem;
    --ifm-pagination-padding-vertical: 0.2rem
}

.pagination--lg {
    --ifm-pagination-font-size: 1.2rem;
    --ifm-pagination-padding-horizontal: 1.2rem;
    --ifm-pagination-padding-vertical: 0.3rem
}

.pagination__item {
    display: inline-flex
}

.pagination__item>span {
    padding: var(--ifm-pagination-padding-vertical)
}

.pagination__item--active .pagination__link {
    color: var(--ifm-pagination-color-active)
}

.pagination__item--active .pagination__link,.pagination__item:not(.pagination__item--active):hover .pagination__link {
    background: var(--ifm-pagination-item-active-background)
}

.pagination__item--disabled,.pagination__item[disabled] {
    opacity: .25;
    pointer-events: none
}

.pagination__link {
    border-radius: var(--ifm-pagination-border-radius);
    color: var(--ifm-font-color-base);
    display: inline-block;
    padding: var(--ifm-pagination-padding-vertical) var(--ifm-pagination-padding-horizontal);
    transition: background var(--ifm-transition-fast) var(--ifm-transition-timing-default)
}

.pagination__link:hover {
    text-decoration: none
}

.pagination-nav {
    display: grid;
    grid-gap: var(--ifm-spacing-horizontal);
    gap: var(--ifm-spacing-horizontal);
    grid-template-columns: repeat(2,1fr)
}

.pagination-nav__link {
    border: 1px solid var(--ifm-color-emphasis-300);
    border-radius: var(--ifm-pagination-nav-border-radius);
    display: block;
    height: 100%;
    line-height: var(--ifm-heading-line-height);
    padding: var(--ifm-global-spacing);
    transition: border-color var(--ifm-transition-fast) var(--ifm-transition-timing-default)
}

.pagination-nav__link:hover {
    border-color: var(--ifm-pagination-nav-color-hover);
    text-decoration: none
}

.pagination-nav__link--next {
    grid-column: 2/3;
    text-align: right
}

.pagination-nav__label {
    font-size: var(--ifm-h4-font-size);
    font-weight: var(--ifm-heading-font-weight);
    word-break: break-word
}

.pagination-nav__link--prev .pagination-nav__label:before {
    content: "« "
}

.pagination-nav__link--next .pagination-nav__label:after {
    content: " »"
}

.pagination-nav__sublabel {
    color: var(--ifm-color-content-secondary);
    font-size: var(--ifm-h5-font-size);
    font-weight: var(--ifm-font-weight-semibold);
    margin-bottom: .25rem
}

.pills__item,.tabs {
    font-weight: var(--ifm-font-weight-bold)
}

.pills {
    display: flex;
    gap: var(--ifm-pills-spacing);
    padding-left: 0
}

.pills__item {
    border-radius: .5rem;
    cursor: pointer;
    display: inline-block;
    padding: .25rem 1rem;
    transition: background var(--ifm-transition-fast) var(--ifm-transition-timing-default)
}

.pills__item--active {
    color: var(--ifm-pills-color-active)
}

.pills__item--active,.pills__item:not(.pills__item--active):hover {
    background: var(--ifm-pills-color-background-active)
}

.pills--block {
    justify-content: stretch
}

.pills--block .pills__item {
    flex-grow: 1;
    text-align: center
}

.tabs {
    color: var(--ifm-tabs-color);
    display: flex;
    margin-bottom: 0;
    overflow-x: auto;
    padding-left: 0
}

.tabs__item {
    border-bottom: 3px solid #0000;
    border-radius: var(--ifm-global-radius);
    cursor: pointer;
    display: inline-flex;
    padding: var(--ifm-tabs-padding-vertical) var(--ifm-tabs-padding-horizontal);
    transition: background-color var(--ifm-transition-fast) var(--ifm-transition-timing-default)
}

.tabs__item--active {
    border-bottom-color: var(--ifm-tabs-color-active-border);
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    color: var(--ifm-tabs-color-active)
}

.tabs__item:hover {
    background-color: var(--ifm-hover-overlay)
}

.tabs--block {
    justify-content: stretch
}

.tabs--block .tabs__item {
    flex-grow: 1;
    justify-content: center
}

html[data-theme=dark] {
    --ifm-color-scheme: dark;
    --ifm-color-emphasis-0: var(--ifm-color-gray-1000);
    --ifm-color-emphasis-100: var(--ifm-color-gray-900);
    --ifm-color-emphasis-200: var(--ifm-color-gray-800);
    --ifm-color-emphasis-300: var(--ifm-color-gray-700);
    --ifm-color-emphasis-400: var(--ifm-color-gray-600);
    --ifm-color-emphasis-600: var(--ifm-color-gray-400);
    --ifm-color-emphasis-700: var(--ifm-color-gray-300);
    --ifm-color-emphasis-800: var(--ifm-color-gray-200);
    --ifm-color-emphasis-900: var(--ifm-color-gray-100);
    --ifm-color-emphasis-1000: var(--ifm-color-gray-0);
    --ifm-background-color: #1b1b1d;
    --ifm-background-surface-color: #242526;
    --ifm-hover-overlay: #ffffff0d;
    --ifm-color-content: #e3e3e3;
    --ifm-color-content-secondary: #fff;
    --ifm-breadcrumb-separator-filter: invert(64%) sepia(11%) saturate(0%) hue-rotate(149deg) brightness(99%) contrast(95%);
    --ifm-code-background: #ffffff1a;
    --ifm-scrollbar-track-background-color: #444;
    --ifm-scrollbar-thumb-background-color: #686868;
    --ifm-scrollbar-thumb-hover-background-color: #7a7a7a;
    --ifm-table-stripe-background: #ffffff12;
    --ifm-toc-border-color: var(--ifm-color-emphasis-200);
    --ifm-color-primary-contrast-background: #102445;
    --ifm-color-primary-contrast-foreground: #ebf2fc;
    --ifm-color-secondary-contrast-background: #474748;
    --ifm-color-secondary-contrast-foreground: #fdfdfe;
    --ifm-color-success-contrast-background: #003100;
    --ifm-color-success-contrast-foreground: #e6f6e6;
    --ifm-color-info-contrast-background: #193c47;
    --ifm-color-info-contrast-foreground: #eef9fd;
    --ifm-color-warning-contrast-background: #4d3800;
    --ifm-color-warning-contrast-foreground: #fff8e6;
    --ifm-color-danger-contrast-background: #4b1113;
    --ifm-color-danger-contrast-foreground: #ffebec;
    --docsearch-text-color: #f5f6f7;
    --docsearch-container-background: #090a11cc;
    --docsearch-modal-background: #15172a;
    --docsearch-modal-shadow: inset 1px 1px 0 0 #2c2e40,0 3px 8px 0 #000309;
    --docsearch-searchbox-background: #090a11;
    --docsearch-searchbox-focus-background: #000;
    --docsearch-hit-color: #bec3c9;
    --docsearch-hit-shadow: none;
    --docsearch-hit-background: #090a11;
    --docsearch-key-gradient: linear-gradient(-26.5deg,#565872,#31355b);
    --docsearch-key-shadow: inset 0 -2px 0 0 #282d55,inset 0 0 1px 1px #51577d,0 2px 2px 0 #0304094d;
    --docsearch-key-pressed-shadow: inset 0 -2px 0 0 #282d55,inset 0 0 1px 1px #51577d,0 1px 1px 0 rgba(3,4,9,.302);
    --docsearch-footer-background: #1e2136;
    --docsearch-footer-shadow: inset 0 1px 0 0 #494c6a80,0 -4px 8px 0 #0003;
    --docsearch-logo-color: #fff;
    --docsearch-muted-color: #7f8497
}

:root {
    --docusaurus-progress-bar-color: var(--ifm-color-primary);
    tab-size: 2;
    --ifm-color-primary-dark: #29784c;
    --ifm-color-primary-darker: #277148;
    --ifm-color-primary-darkest: #205d3b;
    --ifm-color-primary-light: #33925d;
    --ifm-color-primary-lighter: #359962;
    --ifm-color-primary-lightest: #3cad6e;
    --ifm-code-font-size: 95%;
    --ifm-font-size-base: 18px;
    --ifm-font-family-base: "IBM Plex Sans",serif;
    --ifm-font-family-monospace: "IBM Plex Mono",mono-space;
    --ifm-heading-font-family: "IBM Plex Serif",sans-serif;
    --ifm-heading-font-weight: 600;
    --docusaurus-highlighted-code-line-bg: #0000001a;
    --ifm-avatar-photo-size: 1.2rem;
    --docsearch-primary-color: #5468ff;
    --docsearch-text-color: #1c1e21;
    --docsearch-spacing: 12px;
    --docsearch-icon-stroke-width: 1.4;
    --docsearch-highlight-color: var(--docsearch-primary-color);
    --docsearch-muted-color: #969faf;
    --docsearch-container-background: #656c85cc;
    --docsearch-logo-color: #5468ff;
    --docsearch-modal-width: 560px;
    --docsearch-modal-height: 600px;
    --docsearch-modal-background: #f5f6f7;
    --docsearch-modal-shadow: inset 1px 1px 0 0 #ffffff80,0 3px 8px 0 #555a64;
    --docsearch-searchbox-height: 56px;
    --docsearch-searchbox-background: #ebedf0;
    --docsearch-searchbox-focus-background: #fff;
    --docsearch-searchbox-shadow: inset 0 0 0 2px var(--docsearch-primary-color);
    --docsearch-hit-height: 56px;
    --docsearch-hit-color: #444950;
    --docsearch-hit-active-color: #fff;
    --docsearch-hit-background: #fff;
    --docsearch-hit-shadow: 0 1px 3px 0 #d4d9e1;
    --docsearch-key-gradient: linear-gradient(-225deg,#d5dbe4,#f8f8f8);
    --docsearch-key-shadow: inset 0 -2px 0 0 #cdcde6,inset 0 0 1px 1px #fff,0 1px 2px 1px #1e235a66;
    --docsearch-key-pressed-shadow: inset 0 -2px 0 0 #cdcde6,inset 0 0 1px 1px #fff,0 1px 1px 0 #1e235a66;
    --docsearch-footer-height: 44px;
    --docsearch-footer-background: #fff;
    --docsearch-footer-shadow: 0 -1px 0 0 #e0e3e8,0 -3px 6px 0 #45629b1f;
    --docsearch-primary-color: var(--ifm-color-primary);
    --docsearch-text-color: var(--ifm-font-color-base);
    --docusaurus-announcement-bar-height: auto;
    --docusaurus-collapse-button-bg: #0000;
    --docusaurus-collapse-button-bg-hover: #0000001a;
    --doc-sidebar-width: 300px;
    --doc-sidebar-hidden-width: 30px;
    --docusaurus-tag-list-border: var(--ifm-color-emphasis-300);
    --pink: #f37;
    --blue: #2563eb;
    --bg-blue: #e0f2fe
}

#nprogress .bar {
    background: var(--docusaurus-progress-bar-color);
    height: 2px;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 1031
}

#nprogress .peg {
    box-shadow: 0 0 10px var(--docusaurus-progress-bar-color),0 0 5px var(--docusaurus-progress-bar-color);
    height: 100%;
    opacity: 1;
    position: absolute;
    right: 0;
    transform: rotate(3deg) translateY(-4px);
    width: 100px
}

@font-face {
    font-display: swap;
    font-family: IBM Plex Mono;
    font-style: normal;
    font-weight: 400;
    src: local("IBM Plex Mono"),local("IBMPlexMono"),url(/assets/fonts/IBMPlexMono-Regular-235eee7acf05753afa554df5f7ca6693.woff2) format("woff2")
}

@font-face {
    font-display: swap;
    font-family: IBM Plex Mono;
    font-style: normal;
    font-weight: 600;
    src: local("IBM Plex Mono SemiBold"),local("IBMPlexMono-SemiBold"),url(/assets/fonts/IBMPlexMono-SemiBold-951fdec86f888a07b0e7be680f854993.woff2) format("woff2")
}

@font-face {
    font-display: swap;
    font-family: IBM Plex Sans;
    font-style: normal;
    font-weight: 500;
    src: local("IBM Plex Sans Regular"),local("IBMPlexSans-Regular"),url(/assets/fonts/IBMPlexSans-Regular-f406ac24b8376b17efd411a0c6895e55.woff2) format("woff2")
}

@font-face {
    font-display: swap;
    font-family: IBM Plex Sans;
    font-style: italic;
    font-weight: 500;
    src: local("IBM Plex Sans Italic"),local("IBMPlexSans-Italic"),url(/assets/fonts/IBMPlexSans-Italic-8e8ec09cb78c2df99952e301e6d1e55a.woff2) format("woff2")
}

@font-face {
    font-display: swap;
    font-family: IBM Plex Sans;
    font-style: normal;
    font-weight: 600;
    src: local("IBM Plex Sans SemiBold"),local("IBMPlexSans-SemiBold"),url(/assets/fonts/IBMPlexSans-SemiBold-532d7bd54cb337af1b998d7a828179a4.woff2) format("woff2")
}

@font-face {
    font-display: swap;
    font-family: IBM Plex Sans;
    font-style: italic;
    font-weight: 600;
    src: local("IBM Plex Sans SemiBoldItalic"),local("IBMPlexSans-SemiBoldItalic"),url(/assets/fonts/IBMPlexSans-SemiBoldItalic-11859374baf3e7cfcdcafbd6cdbcd94d.woff2) format("woff2")
}

@font-face {
    font-display: swap;
    font-family: "IBM Plex Serif";
    font-style: normal;
    font-weight: 500;
    src: local("IBM Plex Serif Regular"),local("IBMPlexSerif-Regular"),url(/assets/fonts/IBMPlexSerif-Regular-4b17ffc2535f909f84bf83d025ae7024.woff2) format("woff2")
}

@font-face {
    font-display: swap;
    font-family: "IBM Plex Serif";
    font-style: normal;
    font-weight: 600;
    src: local("IBM Plex Serif SemiBold"),local("IBMPlexSerif-SemiBold"),url(/assets/fonts/IBMPlexSerif-SemiBold-054578cc529efde63e7a9ae6f4aa61ed.woff2) format("woff2")
}

.markdown>h4:not(:first-of-type) {
    margin-top: calc(var(--ifm-heading-vertical-rhythm-top)*var(--ifm-leading)*2)
}

code {
    border: none
}

p>code {
    font-size: var(--ifm-font-size-base);
    vertical-align: initial
}

div[class*=" admonitionHeading"],div[class^=admonitionHeading] {
    font-family: var(--ifm-font-family-base)
}

[data-theme=dark] {
    --ifm-color-primary-dark: #21af90;
    --ifm-color-primary-darker: #1fa588;
    --ifm-color-primary-darkest: #1a8870;
    --ifm-color-primary-light: #29d5b0;
    --ifm-color-primary-lighter: #32d8b4;
    --ifm-color-primary-lightest: #4fddbf
}

.docusaurus-highlight-code-line {
    background-color: #0000001a;
    display: block;
    margin: 0 calc(var(--ifm-pre-padding)*-1);
    padding: 0 var(--ifm-pre-padding)
}

[data-theme=dark] .docusaurus-highlight-code-line {
    background-color: #0000004d
}

.avatar__name {
    font-weight: 500
}

h1[itemprop=headline],h2[itemprop=headline] {
    font-size: 2rem;
    margin-bottom: .4rem
}

.markdown img.border {
    border: 1px solid #a5a5a54d
}

.backToTopButton_sjWU {
    background-color: var(--ifm-color-emphasis-200);
    border-radius: 50%;
    bottom: 1.3rem;
    box-shadow: var(--ifm-global-shadow-lw);
    height: 3rem;
    opacity: 0;
    position: fixed;
    right: 1.3rem;
    transform: scale(0);
    transition: all var(--ifm-transition-fast) var(--ifm-transition-timing-default);
    visibility: hidden;
    width: 3rem;
    z-index: calc(var(--ifm-z-index-fixed) - 1)
}

.backToTopButton_sjWU:after {
    background-color: var(--ifm-color-emphasis-1000);
    content: " ";
    display: inline-block;
    height: 100%;
    -webkit-mask: var(--ifm-menu-link-sublist-icon) 50%/2rem 2rem no-repeat;
    mask: var(--ifm-menu-link-sublist-icon) 50%/2rem 2rem no-repeat;
    width: 100%
}

.backToTopButtonShow_xfvO {
    opacity: 1;
    transform: scale(1);
    visibility: visible
}

.DocSearch-Button {
    align-items: center;
    background: var(--docsearch-searchbox-background);
    border: 0;
    border-radius: 40px;
    color: var(--docsearch-muted-color);
    cursor: pointer;
    display: flex;
    font-weight: 500;
    height: 36px;
    justify-content: space-between;
    padding: 0 8px;
    -webkit-user-select: none;
    user-select: none
}

.DocSearch-Button:active,.DocSearch-Button:focus,.DocSearch-Button:hover {
    background: var(--docsearch-searchbox-focus-background);
    box-shadow: var(--docsearch-searchbox-shadow);
    color: var(--docsearch-text-color);
    outline: 0
}

.DocSearch-Button-Container {
    align-items: center;
    display: flex
}

.DocSearch-Search-Icon {
    stroke-width: 1.6
}

.DocSearch-Hit-Tree,.DocSearch-Hit-action,.DocSearch-Hit-icon,.DocSearch-Reset {
    stroke-width: var(--docsearch-icon-stroke-width)
}

.DocSearch-Button .DocSearch-Search-Icon {
    color: var(--docsearch-text-color)
}

.DocSearch-Button-Placeholder {
    font-size: 1rem;
    padding: 0 12px 0 6px
}

.DocSearch-Button-Keys {
    display: flex;
    min-width: calc(40px + .8em)
}

.DocSearch-Button-Key {
    align-items: center;
    background: var(--docsearch-key-gradient);
    border: 0;
    border-radius: 3px;
    box-shadow: var(--docsearch-key-shadow);
    color: var(--docsearch-muted-color);
    display: flex;
    height: 18px;
    justify-content: center;
    margin-right: .4em;
    padding: 0 0 2px;
    position: relative;
    top: -1px;
    width: 20px
}

.DocSearch-Button-Key--pressed {
    box-shadow: var(--docsearch-key-pressed-shadow);
    transform: translate3d(0,1px,0)
}

.DocSearch--active {
    overflow: hidden!important
}

.DocSearch-Container {
    background-color: var(--docsearch-container-background);
    height: 100vh;
    left: 0;
    position: fixed;
    top: 0;
    width: 100vw;
    z-index: 200
}

.DocSearch-Container a,.sidebarItemLink_mo7H:hover,section a:hover {
    text-decoration: none
}

.DocSearch-Hit[aria-selected=true] mark,.content_knG7 a,.footer_J6tW a,.uppy-Provider-breadcrumbs button:not(:last-of-type) {
    text-decoration: underline
}

.DocSearch-Link {
    appearance: none;
    background: none;
    border: 0;
    color: var(--docsearch-highlight-color);
    cursor: pointer;
    font: inherit;
    margin: 0;
    padding: 0
}

.DocSearch-Modal {
    background: var(--docsearch-modal-background);
    border-radius: 6px;
    box-shadow: var(--docsearch-modal-shadow);
    flex-direction: column;
    margin: 60px auto auto;
    max-width: var(--docsearch-modal-width);
    position: relative
}

.DocSearch-SearchBar {
    display: flex;
    padding: var(--docsearch-spacing) var(--docsearch-spacing) 0
}

.DocSearch-Form {
    align-items: center;
    background: var(--docsearch-searchbox-focus-background);
    border-radius: 4px;
    box-shadow: var(--docsearch-searchbox-shadow);
    display: flex;
    height: var(--docsearch-searchbox-height);
    margin: 0;
    padding: 0 var(--docsearch-spacing);
    position: relative;
    width: 100%
}

.DocSearch-Input {
    appearance: none;
    background: #0000;
    border: 0;
    color: var(--docsearch-text-color);
    flex: 1;
    font: inherit;
    font-size: 1.2em;
    height: 100%;
    outline: 0;
    padding: 0 0 0 8px;
    width: 80%
}

.DocSearch-Input::placeholder {
    color: var(--docsearch-muted-color);
    opacity: 1
}

.DocSearch-Input::-webkit-search-cancel-button,.DocSearch-Input::-webkit-search-decoration,.DocSearch-Input::-webkit-search-results-button,.DocSearch-Input::-webkit-search-results-decoration {
    display: none
}

.DocSearch-LoadingIndicator,.DocSearch-MagnifierLabel,.DocSearch-Reset {
    margin: 0;
    padding: 0
}

.DocSearch-Container--Stalled .DocSearch-LoadingIndicator,.DocSearch-MagnifierLabel,.DocSearch-Reset {
    align-items: center;
    color: var(--docsearch-highlight-color);
    display: flex;
    justify-content: center
}

.DocSearch-Cancel,.DocSearch-Container--Stalled .DocSearch-MagnifierLabel,.DocSearch-LoadingIndicator,.DocSearch-Reset[hidden] {
    display: none
}

.DocSearch-Reset {
    animation: .1s ease-in forwards d;
    appearance: none;
    background: none;
    border: 0;
    border-radius: 50%;
    color: var(--docsearch-icon-color);
    cursor: pointer;
    padding: 2px;
    right: 0
}

.DocSearch-Help,.DocSearch-HitsFooter,.DocSearch-Label {
    color: var(--docsearch-muted-color)
}

.DocSearch-Reset:hover {
    color: var(--docsearch-highlight-color)
}

.DocSearch-LoadingIndicator svg,.DocSearch-MagnifierLabel svg {
    height: 24px;
    width: 24px
}

.DocSearch-Dropdown {
    max-height: calc(var(--docsearch-modal-height) - var(--docsearch-searchbox-height) - var(--docsearch-spacing) - var(--docsearch-footer-height));
    min-height: var(--docsearch-spacing);
    overflow-y: auto;
    overflow-y: overlay;
    padding: 0 var(--docsearch-spacing);
    scrollbar-color: var(--docsearch-muted-color) var(--docsearch-modal-background);
    scrollbar-width: thin
}

.DocSearch-Dropdown::-webkit-scrollbar {
    width: 12px
}

.DocSearch-Dropdown::-webkit-scrollbar-track {
    background: #0000
}

.DocSearch-Dropdown::-webkit-scrollbar-thumb {
    background-color: var(--docsearch-muted-color);
    border: 3px solid var(--docsearch-modal-background);
    border-radius: 20px
}

.DocSearch-Dropdown ul,.section-much-more_zGqh ul {
    list-style: none;
    margin: 0;
    padding: 0
}

.DocSearch-Label {
    font-size: .75em;
    line-height: 1.6em
}

.DocSearch-Help {
    font-size: .9em;
    margin: 0;
    -webkit-user-select: none;
    user-select: none
}

.DocSearch-Title {
    font-size: 1.2em
}

.DocSearch-Logo a {
    display: flex
}

.DocSearch-Logo svg {
    color: var(--docsearch-logo-color);
    margin-left: 8px
}

.DocSearch-Hits:last-of-type {
    margin-bottom: 24px
}

.DocSearch-Hits mark {
    background: none;
    color: var(--docsearch-highlight-color)
}

.DocSearch-HitsFooter {
    display: flex;
    font-size: .85em;
    justify-content: center;
    margin-bottom: var(--docsearch-spacing);
    padding: var(--docsearch-spacing)
}

.DocSearch-HitsFooter a {
    border-bottom: 1px solid;
    color: inherit
}

.DocSearch-Hit {
    border-radius: 4px;
    display: flex;
    padding-bottom: 4px;
    position: relative
}

.DocSearch-Hit--deleting {
    opacity: 0;
    transition: .25s linear
}

.DocSearch-Hit--favoriting {
    transform: scale(0);
    transform-origin: top center;
    transition: .25s linear .25s
}

.DocSearch-Hit a {
    background: var(--docsearch-hit-background);
    border-radius: 4px;
    box-shadow: var(--docsearch-hit-shadow);
    display: block;
    padding-left: var(--docsearch-spacing);
    width: 100%
}

.DocSearch-Hit-source {
    background: var(--docsearch-modal-background);
    color: var(--docsearch-highlight-color);
    font-size: .85em;
    font-weight: 600;
    line-height: 32px;
    margin: 0 -4px;
    padding: 8px 4px 0;
    position: sticky;
    top: 0;
    z-index: 10
}

.DocSearch-Hit-Tree {
    color: var(--docsearch-muted-color);
    height: var(--docsearch-hit-height);
    opacity: .5;
    width: 24px
}

.DocSearch-Hit[aria-selected=true] a {
    background-color: var(--docsearch-highlight-color)
}

.DocSearch-Hit-Container {
    align-items: center;
    color: var(--docsearch-hit-color);
    display: flex;
    flex-direction: row;
    height: var(--docsearch-hit-height);
    padding: 0 var(--docsearch-spacing) 0 0
}

.DocSearch-Hit-icon {
    height: 20px;
    width: 20px
}

.DocSearch-Hit-action,.DocSearch-Hit-icon {
    color: var(--docsearch-muted-color)
}

.DocSearch-Hit-action {
    align-items: center;
    display: flex;
    height: 22px;
    width: 22px
}

.DocSearch-Hit-action svg {
    display: block;
    height: 18px;
    width: 18px
}

.DocSearch-Hit-action+.DocSearch-Hit-action {
    margin-left: 6px
}

.DocSearch-Hit-action-button {
    appearance: none;
    background: none;
    border: 0;
    border-radius: 50%;
    color: inherit;
    cursor: pointer;
    padding: 2px
}

#__docusaurus-base-url-issue-banner-container,.docSidebarContainer_YfHR,.navbarSearchContainer_Bca1:empty,.sidebarLogo_isFc,.themedComponent_mlkZ,.uppy-Root [hidden],.uppy-StatusBar.is-waiting .uppy-StatusBar-progress,[data-theme=dark] .lightToggleIcon_pyhR,[data-theme=light] .darkToggleIcon_wfgR,html[data-announcement-bar-initially-dismissed=true] .announcementBar_mb4j,svg.DocSearch-Hit-Select-Icon {
    display: none
}

.DocSearch-Hit[aria-selected=true] .DocSearch-Hit-Select-Icon,.uppy-Dashboard-Item.is-error .uppy-Dashboard-Item-previewInnerWrap:after,.uppy-Dashboard-Item.is-inprogress .uppy-Dashboard-Item-previewInnerWrap:after,.uppy-ProviderBrowser-viewType--grid .uppy-ProviderBrowserItem-checkbox--grid:focus+label .uppy-ProviderBrowserItem-author,.uppy-ProviderBrowser-viewType--grid .uppy-ProviderBrowserItem-checkbox--grid:hover+label .uppy-ProviderBrowserItem-author,.uppy-ProviderBrowser-viewType--unsplash .uppy-ProviderBrowserItem-checkbox--grid:focus+label .uppy-ProviderBrowserItem-author,.uppy-ProviderBrowser-viewType--unsplash .uppy-ProviderBrowserItem-checkbox--grid:hover+label .uppy-ProviderBrowserItem-author {
    display: block
}

.DocSearch-Hit-action-button:focus,.DocSearch-Hit-action-button:hover {
    background: #0003;
    transition: background-color .1s ease-in
}

.DocSearch-Hit-action-button:focus path,.DocSearch-Hit-action-button:hover path {
    fill: #fff
}

.DocSearch-Hit-content-wrapper {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    font-weight: 500;
    justify-content: center;
    line-height: 1.2em;
    margin: 0 8px;
    overflow-x: hidden;
    position: relative;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 80%
}

.DocSearch-Hit-title {
    font-size: .9em
}

.DocSearch-Hit-path {
    color: var(--docsearch-muted-color);
    font-size: .75em
}

.DocSearch-Hit[aria-selected=true] .DocSearch-Hit-Tree,.DocSearch-Hit[aria-selected=true] .DocSearch-Hit-action,.DocSearch-Hit[aria-selected=true] .DocSearch-Hit-icon,.DocSearch-Hit[aria-selected=true] .DocSearch-Hit-path,.DocSearch-Hit[aria-selected=true] .DocSearch-Hit-text,.DocSearch-Hit[aria-selected=true] .DocSearch-Hit-title,.DocSearch-Hit[aria-selected=true] mark {
    color: var(--docsearch-hit-active-color)!important
}

.DocSearch-ErrorScreen,.DocSearch-NoResults,.DocSearch-StartScreen {
    font-size: .9em;
    margin: 0 auto;
    padding: 36px 0;
    text-align: center;
    width: 80%
}

.DocSearch-Screen-Icon {
    color: var(--docsearch-muted-color);
    padding-bottom: 12px
}

.DocSearch-NoResults-Prefill-List {
    display: inline-block;
    padding-bottom: 24px;
    text-align: left
}

.DocSearch-NoResults-Prefill-List ul {
    display: inline-block;
    padding: 8px 0 0
}

.DocSearch-NoResults-Prefill-List li {
    list-style-position: inside;
    list-style-type: "» "
}

.DocSearch-Prefill {
    appearance: none;
    background: none;
    border: 0;
    border-radius: 1em;
    color: var(--docsearch-highlight-color);
    cursor: pointer;
    display: inline-block;
    font-size: 1em;
    font-weight: 700;
    padding: 0
}

.DocSearch-Prefill:focus,.DocSearch-Prefill:hover {
    outline: 0;
    text-decoration: underline
}

.DocSearch-Footer {
    align-items: center;
    background: var(--docsearch-footer-background);
    border-radius: 0 0 8px 8px;
    box-shadow: var(--docsearch-footer-shadow);
    display: flex;
    flex-direction: row-reverse;
    flex-shrink: 0;
    height: var(--docsearch-footer-height);
    justify-content: space-between;
    padding: 0 var(--docsearch-spacing);
    position: relative;
    -webkit-user-select: none;
    user-select: none;
    width: 100%;
    z-index: 300
}

.DocSearch-Commands li,.DocSearch-Commands-Key,.uppy-size--md .uppy-ProviderBrowser-headerBar {
    align-items: center;
    display: flex
}

.DocSearch-Commands {
    color: var(--docsearch-muted-color);
    display: flex;
    list-style: none;
    margin: 0;
    padding: 0
}

.DocSearch-Commands li:not(:last-of-type) {
    margin-right: .8em
}

.DocSearch-Commands-Key {
    background: var(--docsearch-key-gradient);
    border: 0;
    border-radius: 2px;
    box-shadow: var(--docsearch-key-shadow);
    color: var(--docsearch-muted-color);
    height: 18px;
    justify-content: center;
    margin-right: .4em;
    padding: 0 0 1px;
    width: 20px
}

.DocSearch-VisuallyHiddenForAccessibility {
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px
}

.DocSearch-Button {
    margin: 0;
    transition: all var(--ifm-transition-fast) var(--ifm-transition-timing-default)
}

.DocSearch-Container,.skipToContent_fXgn {
    z-index: calc(var(--ifm-z-index-fixed) + 1)
}

.skipToContent_fXgn {
    background-color: var(--ifm-background-surface-color);
    color: var(--ifm-color-emphasis-900);
    left: 100%;
    padding: calc(var(--ifm-global-spacing)/2) var(--ifm-global-spacing);
    position: fixed;
    top: 1rem
}

.skipToContent_fXgn:focus {
    box-shadow: var(--ifm-global-shadow-md);
    left: 1rem
}

.closeButton_CVFx {
    line-height: 0;
    padding: 0
}

.content_knG7 {
    font-size: 85%;
    padding: 5px 0;
    text-align: center
}

.content_knG7 a {
    color: inherit
}

.announcementBar_mb4j {
    align-items: center;
    background-color: var(--ifm-color-white);
    border-bottom: 1px solid var(--ifm-color-emphasis-100);
    color: var(--ifm-color-black);
    display: flex;
    height: var(--docusaurus-announcement-bar-height)
}

.announcementBarPlaceholder_vyr4 {
    flex: 0 0 10px
}

.announcementBarClose_gvF7 {
    align-self: stretch;
    flex: 0 0 30px
}

.toggle_vylO {
    height: 2rem;
    width: 2rem
}

.toggleButton_gllP {
    align-items: center;
    border-radius: 50%;
    display: flex;
    height: 100%;
    justify-content: center;
    transition: background var(--ifm-transition-fast);
    width: 100%
}

.toggleButton_gllP:hover {
    background: var(--ifm-color-emphasis-200)
}

.toggleButtonDisabled_aARS {
    cursor: not-allowed
}

.darkNavbarColorModeToggle_X3D1:hover {
    background: var(--ifm-color-gray-800)
}

[data-theme=dark] .themedComponent--dark_xIcU,[data-theme=light] .themedComponent--light_NVdE,html:not([data-theme]) .themedComponent--light_NVdE {
    display: initial
}

[data-theme=dark]:root {
    --docusaurus-collapse-button-bg: #ffffff0d;
    --docusaurus-collapse-button-bg-hover: #ffffff1a
}

.collapseSidebarButton_PEFL {
    display: none;
    margin: 0
}

.iconExternalLink_nPIU {
    margin-left: .3rem
}

.docMainContainer_TBSr,.docRoot_UBD9 {
    display: flex;
    width: 100%
}

.docsWrapper_hBAB {
    display: flex;
    flex: 1 0 auto
}

.dropdownNavbarItemMobile_S0Fm,.uppy-Provider-breadcrumbs button:hover,.uppy-c-btn:not(:disabled):not(.disabled),button.uppy-Dashboard-Item-progressIndicator {
    cursor: pointer
}

.iconLanguage_nlXk {
    margin-right: 5px
}

.navbarHideable_m1mJ {
    transition: transform var(--ifm-transition-fast) ease
}

.navbarHidden_jGov {
    transform: translate3d(0,calc(-100% - 2px),0)
}

.errorBoundaryError_a6uf {
    color: red;
    white-space: pre-wrap
}

.errorBoundaryFallback_VBag {
    color: red;
    padding: .55rem
}

.header_wuUL {
    align-items: center;
    border-bottom: 1px solid var(--ifm-color-emphasis-200);
    display: flex;
    justify-content: center;
    margin: 0;
    padding: .5rem;
    z-index: var(--ifm-z-index-fixed)
}

.footer_J6tW {
    background-color: #15192a;
    color: #fff;
    margin-top: 50px;
    padding: 2em 1em 3em;
    text-align: center
}

.footer_J6tW p {
    margin: 1em 0
}

.footer_J6tW img {
    height: auto;
    width: 44px
}

.footer_J6tW a {
    color: #fff
}

.uppy-ProviderBrowser-list:focus,.uppy-ProviderBrowser-viewType--grid .uppy-ProviderBrowserItem-checkbox--grid:focus+label:focus,.uppy-ProviderBrowser-viewType--unsplash .uppy-ProviderBrowserItem-checkbox--grid:focus+label:focus,.uppy-StatusBar-actionCircleBtn:focus,body:not(.navigation-with-keyboard) :not(input):focus,button.uppy-Dashboard-Item-progressIndicator:focus {
    outline: 0
}

.anchorWithStickyNavbar_LWe7 {
    scroll-margin-top: calc(var(--ifm-navbar-height) + .5rem)
}

.anchorWithHideOnScrollNavbar_WYt5 {
    scroll-margin-top: .5rem
}

.hash-link {
    opacity: 0;
    padding-left: .5rem;
    transition: opacity var(--ifm-transition-fast);
    -webkit-user-select: none;
    user-select: none
}

.hash-link:before {
    content: "#"
}

.mainWrapper_z2l0 {
    display: flex;
    flex: 1 0 auto;
    flex-direction: column
}

.companion_gSfg .provider_QNcp:nth-of-type(3),.companion_gSfg .provider_QNcp:nth-of-type(5),.docusaurus-mt-lg {
    margin-top: 3rem
}

#__docusaurus {
    display: flex;
    flex-direction: column;
    min-height: 100%
}

.searchQueryInput_u2C7,.searchVersionInput_m0Ui {
    background: var(--docsearch-searchbox-focus-background);
    border: 2px solid var(--ifm-toc-border-color);
    border-radius: var(--ifm-global-radius);
    color: var(--docsearch-text-color);
    font: var(--ifm-font-size-base) var(--ifm-font-family-base);
    margin-bottom: .5rem;
    padding: .8rem;
    transition: border var(--ifm-transition-fast) ease;
    width: 100%
}

.searchQueryInput_u2C7:focus,.searchVersionInput_m0Ui:focus {
    border-color: var(--docsearch-primary-color);
    outline: 0
}

.searchQueryInput_u2C7::placeholder {
    color: var(--docsearch-muted-color)
}

.searchResultsColumn_JPFH {
    font-size: .9rem;
    font-weight: 700
}

.algoliaLogo_rT1R {
    max-width: 150px
}

.algoliaLogoPathFill_WdUC {
    fill: var(--ifm-font-color-base)
}

.searchResultItem_Tv2o {
    border-bottom: 1px solid var(--ifm-toc-border-color);
    padding: 1rem 0
}

.searchResultItemHeading_KbCB {
    font-weight: 400;
    margin-bottom: 0
}

.searchResultItemPath_lhe1 {
    color: var(--ifm-color-content-secondary);
    font-size: .8rem;
    --ifm-breadcrumb-separator-size-multiplier: 1
}

.searchResultItemSummary_AEaO {
    font-style: italic;
    margin: .5rem 0 0
}

.loadingSpinner_XVxU {
    animation: 1s linear infinite a;
    border: .4em solid #eee;
    border-radius: 50%;
    border-top: .4em solid var(--ifm-color-primary);
    height: 3rem;
    margin: 0 auto;
    width: 3rem
}

@keyframes a {
    to {
        transform: rotate(1turn)
    }
}

.loader_vvXV,.quote_cnET:first-of-type {
    margin-top: 2rem
}

.search-result-match {
    background: #ffd78e40;
    color: var(--docsearch-hit-color);
    padding: .09em 0
}

.sidebar_re4s {
    max-height: calc(100vh - var(--ifm-navbar-height) - 2rem);
    overflow-y: auto;
    position: sticky;
    top: calc(var(--ifm-navbar-height) + 2rem)
}

.sidebarItemTitle_pO2u {
    font-size: var(--ifm-h3-font-size);
    font-weight: var(--ifm-font-weight-bold)
}

.container_mt6G,.sidebarItemList_Yudw {
    font-size: .9rem
}

.sidebarItem__DBe {
    margin-top: .7rem
}

.sidebarItemLink_mo7H {
    color: var(--ifm-font-color-base);
    display: block
}

.sidebarItemLinkActive_I1ZP {
    color: var(--ifm-color-primary)!important
}

.buttonGroup__atx button,.codeBlockContainer_Ckt0 {
    background: var(--prism-background-color);
    color: var(--prism-color)
}

.authorCol_Hf19 {
    flex-grow: 1!important;
    max-width: inherit!important
}

.imageOnlyAuthorRow_pa_O {
    display: flex;
    flex-flow: row wrap
}

.imageOnlyAuthorCol_G86a {
    margin-left: .3rem;
    margin-right: .3rem
}

.codeBlockContainer_Ckt0 {
    border-radius: var(--ifm-code-border-radius);
    box-shadow: var(--ifm-global-shadow-lw);
    margin-bottom: var(--ifm-leading)
}

.codeBlockContent_biex {
    border-radius: inherit;
    direction: ltr;
    position: relative
}

.codeBlockTitle_Ktv7 {
    border-bottom: 1px solid var(--ifm-color-emphasis-300);
    border-top-left-radius: inherit;
    border-top-right-radius: inherit;
    font-size: var(--ifm-code-font-size);
    font-weight: 500;
    padding: .75rem var(--ifm-pre-padding)
}

.codeBlock_bY9V {
    --ifm-pre-background: var(--prism-background-color);
    margin: 0;
    padding: 0
}

.codeBlockTitle_Ktv7+.codeBlockContent_biex .codeBlock_bY9V {
    border-top-left-radius: 0;
    border-top-right-radius: 0
}

.codeBlockLines_e6Vv {
    float: left;
    font: inherit;
    min-width: 100%;
    padding: var(--ifm-pre-padding)
}

.uppy-Root,.uppy-u-reset {
    font-family: -apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Segoe UI Symbol,Segoe UI Emoji,Apple Color Emoji,Roboto,Helvetica,Arial,sans-serif;
    line-height: 1
}

.codeBlockLinesWithNumbering_o6Pm {
    display: table;
    padding: var(--ifm-pre-padding) 0
}

.buttonGroup__atx {
    column-gap: .2rem;
    display: flex;
    position: absolute;
    right: calc(var(--ifm-pre-padding)/2);
    top: calc(var(--ifm-pre-padding)/2)
}

.buttonGroup__atx button {
    align-items: center;
    border: 1px solid var(--ifm-color-emphasis-300);
    border-radius: var(--ifm-global-radius);
    display: flex;
    line-height: 0;
    opacity: 0;
    padding: .4rem;
    transition: opacity var(--ifm-transition-fast) ease-in-out
}

.buttonGroup__atx button:focus-visible,.buttonGroup__atx button:hover {
    opacity: 1!important
}

.theme-code-block:hover .buttonGroup__atx button {
    opacity: .4
}

:where(:root) {
    --docusaurus-highlighted-code-line-bg: #484d5b
}

:where([data-theme=dark]) {
    --docusaurus-highlighted-code-line-bg: #646464
}

.theme-code-block-highlighted-line {
    background-color: var(--docusaurus-highlighted-code-line-bg);
    display: block;
    margin: 0 calc(var(--ifm-pre-padding)*-1);
    padding: 0 var(--ifm-pre-padding)
}

.codeLine_lJS_ {
    counter-increment: a;
    display: table-row
}

.codeLineNumber_Tfdd {
    background: var(--ifm-pre-background);
    display: table-cell;
    left: 0;
    overflow-wrap: normal;
    padding: 0 var(--ifm-pre-padding);
    position: sticky;
    text-align: right;
    width: 1%
}

.codeLineNumber_Tfdd:before {
    content: counter(a);
    opacity: .4
}

.codeLineContent_feaV {
    padding-right: var(--ifm-pre-padding)
}

.tag_zVej {
    border: 1px solid var(--docusaurus-tag-list-border);
    transition: border var(--ifm-transition-fast)
}

.tag_zVej:hover {
    --docusaurus-tag-list-border: var(--ifm-link-color);
    text-decoration: none
}

.tagRegular_sFm0 {
    border-radius: var(--ifm-global-radius);
    font-size: 90%;
    padding: .2rem .5rem .3rem
}

.tagWithCount_h2kH {
    align-items: center;
    border-left: 0;
    display: flex;
    padding: 0 .5rem 0 1rem;
    position: relative
}

.tagWithCount_h2kH:after,.tagWithCount_h2kH:before {
    border: 1px solid var(--docusaurus-tag-list-border);
    content: "";
    position: absolute;
    top: 50%;
    transition: inherit
}

.tagWithCount_h2kH:before {
    border-bottom: 0;
    border-right: 0;
    height: 1.18rem;
    right: 100%;
    transform: translate(50%,-50%) rotate(-45deg);
    width: 1.18rem
}

.tagWithCount_h2kH:after {
    border-radius: 50%;
    height: .5rem;
    left: 0;
    transform: translateY(-50%);
    width: .5rem
}

.tagWithCount_h2kH span {
    background: var(--ifm-color-secondary);
    border-radius: var(--ifm-global-radius);
    color: var(--ifm-color-black);
    font-size: .7rem;
    line-height: 1.2;
    margin-left: .3rem;
    padding: .1rem .4rem
}

.uppy-Informer p,[data-uppy-theme=dark] .uppy-StatusBar:before {
    background-color: #757575
}

.theme-code-block:hover .copyButtonCopied_obH4 {
    opacity: 1!important
}

.copyButtonIcons_eSgA {
    height: 1.125rem;
    position: relative;
    width: 1.125rem
}

.copyButtonIcon_y97N,.copyButtonSuccessIcon_LjdS {
    left: 0;
    position: absolute;
    top: 0;
    fill: currentColor;
    height: inherit;
    opacity: inherit;
    transition: all var(--ifm-transition-fast) ease;
    width: inherit
}

.copyButtonSuccessIcon_LjdS {
    color: #00d600;
    left: 50%;
    opacity: 0;
    top: 50%;
    transform: translate(-50%,-50%) scale(.33)
}

.copyButtonCopied_obH4 .copyButtonIcon_y97N {
    opacity: 0;
    transform: scale(.33)
}

.copyButtonCopied_obH4 .copyButtonSuccessIcon_LjdS {
    opacity: 1;
    transform: translate(-50%,-50%) scale(1);
    transition-delay: 75ms
}

.tags_jXut {
    display: inline
}

.tag_QGVx,.uppy-Informer p,.uppy-c-icon {
    display: inline-block
}

.tag_QGVx {
    margin: 0 .4rem .5rem 0
}

.wordWrapButtonIcon_Bwma {
    height: 1.2rem;
    width: 1.2rem
}

.uppy-Root {
    color: #333;
    position: relative;
    text-align: left;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale
}

.uppy-Root *,.uppy-Root :after,.uppy-Root :before {
    box-sizing: inherit
}

.uppy-u-reset {
    all: initial;
    appearance: none;
    box-sizing: border-box
}

.uppy-c-textInput {
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-family: inherit;
    font-size: 14px;
    line-height: 1.5;
    padding: 6px 8px
}

.uppy-size--md .uppy-c-textInput {
    padding: 8px 10px
}

.uppy-c-textInput:focus {
    border-color: #1269cf99;
    box-shadow: 0 0 0 3px #1269cf26;
    outline: 0
}

[data-uppy-theme=dark] .uppy-c-textInput {
    background-color: #333;
    border-color: #333;
    color: #eaeaea
}

[data-uppy-theme=dark] .uppy-c-textInput:focus {
    border-color: #525252;
    box-shadow: none
}

[data-uppy-theme=dark] .uppy-Audio-button:focus,[data-uppy-theme=dark] .uppy-Dashboard-Item-action:focus,[data-uppy-theme=dark] .uppy-ScreenCapture-button:focus,[data-uppy-theme=dark] .uppy-StatusBar-actionBtn--retry:focus,[data-uppy-theme=dark] .uppy-StatusBar-actionBtn--uploadNewlyAdded:focus,[data-uppy-theme=dark] .uppy-StatusBar-actionCircleBtn:focus,[data-uppy-theme=dark] .uppy-Webcam-button:focus,[data-uppy-theme=dark] .uppy-c-btn-link:focus,[data-uppy-theme=dark] .uppy-c-btn-primary:focus {
    box-shadow: 0 0 0 2px #aae1ffd9;
    outline: 0
}

.uppy-c-icon {
    max-height: 100%;
    max-width: 100%;
    overflow: hidden;
    fill: currentColor
}

.uppy-c-btn {
    align-items: center;
    color: inherit;
    display: inline-flex;
    font-family: inherit;
    font-size: inherit;
    font-weight: 500;
    justify-content: center;
    line-height: 1;
    transition-duration: .3s;
    transition-property: background-color,color;
    -webkit-user-select: none;
    user-select: none;
    white-space: nowrap
}

.uppy-ProviderBrowser-searchFilterInput,.uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-inner {
    font-family: -apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Segoe UI Symbol,Segoe UI Emoji,Apple Color Emoji,Roboto,Helvetica,Arial,sans-serif
}

.uppy-Informer p,.uppy-StatusBar {
    font-weight: 400;
    font-size: 12px;
    color: #fff
}

.uppy-c-btn::-moz-focus-inner {
    border: 0
}

.uppy-c-btn-primary {
    background-color: #1269cf;
    border-radius: 4px;
    color: #fff;
    font-size: 14px;
    padding: 10px 18px
}

.uppy-c-btn-primary:not(:disabled):hover {
    background-color: #0e51a0
}

.uppy-c-btn-primary:focus {
    box-shadow: 0 0 0 3px #1269cf66;
    outline: 0
}

.uppy-size--md .uppy-c-btn-primary {
    padding: 13px 22px
}

[data-uppy-theme=dark] .uppy-StatusBar-content,[data-uppy-theme=dark] .uppy-StatusBar-serviceMsg,[data-uppy-theme=dark] .uppy-StatusBar-statusPrimary,[data-uppy-theme=dark] .uppy-c-btn-link,[data-uppy-theme=dark] .uppy-c-btn-primary {
    color: #eaeaea
}

[data-uppy-theme=dark] .uppy-c-btn-primary::-moz-focus-inner {
    border: 0
}

.uppy-c-btn-primary.uppy-c-btn--disabled {
    background-color: #8eb2db
}

.uppy-c-btn-link {
    background-color: initial;
    border-radius: 4px;
    color: #525252;
    font-size: 14px;
    line-height: 1;
    padding: 10px 15px
}

.uppy-c-btn-link:hover {
    color: #333
}

.uppy-c-btn-link:focus {
    box-shadow: 0 0 0 3px #1269cf40;
    outline: 0
}

.uppy-size--md .uppy-c-btn-link {
    padding: 13px 18px
}

[data-uppy-theme=dark] .uppy-c-btn-link::-moz-focus-inner {
    border: 0
}

.uppy-Provider-empty,[data-uppy-theme=dark] .uppy-c-btn-link:hover {
    color: #939393
}

.uppy-Informer {
    bottom: 60px;
    left: 0;
    position: absolute;
    right: 0;
    text-align: center;
    z-index: 1005
}

.dashboard_zMnL,.uppy-Root [aria-label][role~=tooltip],.uppy-StatusBar {
    position: relative
}

.uppy-Informer span>div {
    margin-bottom: 6px
}

.uppy-Informer-animated {
    opacity: 0;
    transform: translateY(350%);
    transition: .3s ease-in;
    z-index: -1000
}

.uppy-Informer p {
    border-radius: 18px;
    line-height: 1.4;
    margin: 0;
    max-width: 90%;
    padding: 6px 15px
}

.uppy-size--md .uppy-Informer p {
    font-size: 14px;
    line-height: 1.3;
    max-width: 500px;
    padding: 10px 20px
}

[data-uppy-theme=dark] .uppy-Informer p {
    background-color: #333
}

[dir=ltr] .uppy-Informer p span {
    left: 3px;
    margin-left: -1px
}

[dir=rtl] .uppy-Informer p span {
    right: 3px;
    margin-right: -1px
}

.uppy-Informer p span {
    background-color: #fff;
    border-radius: 50%;
    color: #525252;
    display: inline-block;
    font-size: 10px;
    height: 13px;
    line-height: 12px;
    position: relative;
    top: -1px;
    vertical-align: middle;
    width: 13px
}

.uppy-Informer p span:hover {
    cursor: help
}

.uppy-Dashboard-Item-errorDetails:after,.uppy-Informer p span:after,.uppy-StatusBar-details:after {
    line-height: 1.3;
    word-wrap: break-word
}

.uppy-Root [aria-label][role~=tooltip]:after,.uppy-Root [aria-label][role~=tooltip]:before {
    backface-visibility: hidden;
    box-sizing: border-box;
    opacity: 0;
    pointer-events: none;
    position: absolute;
    transform: translateZ(0);
    transform-origin: top;
    transition: all var(--microtip-transition-duration,.18s) var(--microtip-transition-easing,ease-in-out) var(--microtip-transition-delay,0s);
    will-change: transform;
    z-index: 10
}

.uppy-Root [aria-label][role~=tooltip]:before {
    background-size: 100% auto!important;
    content: ""
}

.uppy-Root [aria-label][role~=tooltip]:after {
    background: #111111e6;
    border-radius: 4px;
    box-sizing: initial;
    color: #fff;
    content: attr(aria-label);
    font-size: var(--microtip-font-size,13px);
    font-weight: var(--microtip-font-weight,normal);
    padding: .5em 1em;
    text-transform: var(--microtip-text-transform,none);
    white-space: nowrap
}

.uppy-Root [aria-label][role~=tooltip]:focus:after,.uppy-Root [aria-label][role~=tooltip]:focus:before,.uppy-Root [aria-label][role~=tooltip]:hover:after,.uppy-Root [aria-label][role~=tooltip]:hover:before {
    opacity: 1;
    pointer-events: auto
}

.uppy-Root [role~=tooltip][data-microtip-position|=top]:before {
    background: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='36' height='12'%3E%3Cpath fill='rgba(17, 17, 17, 0.9)' d='M2.658 0h32.004c-6 0-11.627 12.002-16.002 12.002S8.594 0 2.658 0'/%3E%3C/svg%3E") no-repeat;
    bottom: 100%;
    height: 6px;
    left: 50%;
    margin-bottom: 5px;
    transform: translate3d(-50%,0,0);
    width: 18px
}

.uppy-Root [role~=tooltip][data-microtip-position|=top]:after {
    bottom: 100%;
    left: 50%;
    margin-bottom: 11px;
    transform: translate3d(-50%,0,0)
}

.uppy-Root [role~=tooltip][data-microtip-position=top]:hover:after,.uppy-Root [role~=tooltip][data-microtip-position|=top]:hover:before {
    transform: translate3d(-50%,-5px,0)
}

.uppy-Root [role~=tooltip][data-microtip-position=top-left]:after {
    bottom: 100%;
    transform: translate3d(calc(-100% + 16px),0,0)
}

.uppy-Root [role~=tooltip][data-microtip-position=top-left]:hover:after {
    transform: translate3d(calc(-100% + 16px),-5px,0)
}

.uppy-Root [role~=tooltip][data-microtip-position=top-right]:after {
    bottom: 100%;
    transform: translate3d(-16px,0,0)
}

.uppy-Root [role~=tooltip][data-microtip-position=top-right]:hover:after {
    transform: translate3d(-16px,-5px,0)
}

.uppy-Root [role~=tooltip][data-microtip-position|=bottom]:before {
    background: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='36' height='12'%3E%3Cpath fill='rgba(17, 17, 17, 0.9)' d='M33.342 12H1.338c6 0 11.627-12.002 16.002-12.002S27.406 12 33.342 12'/%3E%3C/svg%3E") no-repeat;
    bottom: auto;
    height: 6px;
    left: 50%;
    margin-bottom: 0;
    margin-top: 5px;
    top: 100%;
    transform: translate3d(-50%,-10px,0);
    width: 18px
}

.uppy-Root [role~=tooltip][data-microtip-position|=bottom]:after {
    left: 50%;
    margin-top: 11px;
    top: 100%;
    transform: translate3d(-50%,-10px,0)
}

.uppy-Root [role~=tooltip][data-microtip-position=bottom]:hover:after,.uppy-Root [role~=tooltip][data-microtip-position|=bottom]:hover:before {
    transform: translate3d(-50%,0,0)
}

.uppy-Root [role~=tooltip][data-microtip-position=bottom-left]:after {
    top: 100%;
    transform: translate3d(calc(-100% + 16px),-10px,0)
}

.uppy-Root [role~=tooltip][data-microtip-position=bottom-left]:hover:after {
    transform: translate3d(calc(-100% + 16px),0,0)
}

.uppy-Root [role~=tooltip][data-microtip-position=bottom-right]:after {
    top: 100%;
    transform: translate3d(-16px,-10px,0)
}

.uppy-Root [role~=tooltip][data-microtip-position=bottom-right]:hover:after {
    transform: translate3d(-16px,0,0)
}

.uppy-Root [role~=tooltip][data-microtip-position=left]:after,.uppy-Root [role~=tooltip][data-microtip-position=left]:before {
    bottom: auto;
    left: auto;
    right: 100%;
    top: 50%;
    transform: translate3d(10px,-50%,0)
}

.uppy-Root [role~=tooltip][data-microtip-position=left]:before {
    background: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='36'%3E%3Cpath fill='rgba(17, 17, 17, 0.9)' d='M0 33.342V1.338c0 6 12.002 11.627 12.002 16.002S0 27.406 0 33.342'/%3E%3C/svg%3E") no-repeat;
    height: 18px;
    margin-bottom: 0;
    margin-right: 5px;
    width: 6px
}

.uppy-Root [role~=tooltip][data-microtip-position=left]:after {
    margin-right: 11px
}

.uppy-Root [role~=tooltip][data-microtip-position=left]:hover:after,.uppy-Root [role~=tooltip][data-microtip-position=left]:hover:before,.uppy-Root [role~=tooltip][data-microtip-position=right]:hover:after,.uppy-Root [role~=tooltip][data-microtip-position=right]:hover:before {
    transform: translate3d(0,-50%,0)
}

.uppy-Root [role~=tooltip][data-microtip-position=right]:after,.uppy-Root [role~=tooltip][data-microtip-position=right]:before {
    bottom: auto;
    left: 100%;
    top: 50%;
    transform: translate3d(-10px,-50%,0)
}

.uppy-Root [role~=tooltip][data-microtip-position=right]:before {
    background: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='36'%3E%3Cpath fill='rgba(17, 17, 17, 0.9)' d='M12 2.658v32.004c0-6-12.002-11.627-12.002-16.002S12 8.594 12 2.658'/%3E%3C/svg%3E") no-repeat;
    height: 18px;
    margin-bottom: 0;
    margin-left: 5px;
    width: 6px
}

.uppy-Root [role~=tooltip][data-microtip-position=right]:after {
    margin-left: 11px
}

.uppy-Root [role~=tooltip][data-microtip-size=small]:after {
    white-space: normal;
    width: 80px
}

.uppy-Root [role~=tooltip][data-microtip-size=medium]:after {
    white-space: normal;
    width: 150px
}

.uppy-Root [role~=tooltip][data-microtip-size=large]:after {
    white-space: normal;
    width: 260px
}

.uppy-StatusBar {
    background-color: #fff;
    display: flex;
    height: 46px;
    line-height: 40px;
    transition: height .2s;
    z-index: 1001
}

[data-uppy-theme=dark] .uppy-StatusBar,[data-uppy-theme=dark] .uppy-StatusBar.is-waiting .uppy-StatusBar-actions {
    background-color: #1f1f1f
}

.uppy-StatusBar:before {
    background-color: #eaeaea;
    bottom: 0;
    content: "";
    height: 2px;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: 100%
}

.uppy-StatusBar[aria-hidden=true] {
    height: 0;
    overflow-y: hidden
}

.uppy-StatusBar.is-complete .uppy-StatusBar-progress {
    background-color: #1bb240
}

.uppy-StatusBar.is-error .uppy-StatusBar-progress {
    background-color: #e32437
}

.uppy-StatusBar.is-complete .uppy-StatusBar-statusIndicator {
    color: #1bb240
}

.uppy-StatusBar.is-error .uppy-StatusBar-statusIndicator {
    color: #e32437
}

.uppy-StatusBar:not([aria-hidden=true]).is-waiting {
    background-color: #fff;
    border-top: 1px solid #eaeaea;
    height: 65px
}

[data-uppy-theme=dark] .uppy-Dashboard-FileCard-actions,[data-uppy-theme=dark] .uppy-ProviderBrowser-footer,[data-uppy-theme=dark] .uppy-ScreenCapture-buttonContainer,[data-uppy-theme=dark] .uppy-StatusBar:not([aria-hidden=true]).is-waiting {
    background-color: #1f1f1f;
    border-top: 1px solid #333
}

.uppy-StatusBar-progress {
    background-color: #1269cf;
    height: 2px;
    position: absolute;
    transition: background-color,width .3s ease-out;
    z-index: 1001
}

.uppy-StatusBar-progress.is-indeterminate {
    animation: 1s linear infinite b;
    background-image: linear-gradient(45deg,#0000004d 25%,#0000 0,#0000 50%,#0000004d 0,#0000004d 75%,#0000 0,#0000);
    background-size: 64px 64px
}

@keyframes b {
    0% {
        background-position: 0 0
    }

    to {
        background-position: 64px 0
    }
}

.uppy-StatusBar.is-postprocessing .uppy-StatusBar-progress,.uppy-StatusBar.is-preprocessing .uppy-StatusBar-progress {
    background-color: #f6a623
}

[dir=ltr] .uppy-StatusBar-content,[dir=rtl] .uppy-Dashboard--singleFile .uppy-Dashboard-Item-fileInfo {
    padding-left: 10px
}

[dir=ltr] .uppy-Dashboard--singleFile .uppy-Dashboard-Item-fileInfo,[dir=rtl] .uppy-StatusBar-content {
    padding-right: 10px
}

.uppy-StatusBar-content {
    align-items: center;
    color: #333;
    display: flex;
    height: 100%;
    position: relative;
    text-overflow: ellipsis;
    white-space: nowrap;
    z-index: 1002
}

[dir=ltr] .uppy-size--md .uppy-StatusBar-content,[dir=rtl] .uppy-size--md.uppy-Dashboard--singleFile .uppy-Dashboard-Item-fileInfo {
    padding-left: 15px
}

[dir=ltr] .uppy-size--md.uppy-Dashboard--singleFile .uppy-Dashboard-Item-fileInfo,[dir=rtl] .uppy-size--md .uppy-StatusBar-content {
    padding-right: 15px
}

[dir=ltr] .uppy-StatusBar-status {
    padding-right: .3em
}

[dir=ltr] .uppy-StatusBar-actionBtn--uploadNewlyAdded,[dir=rtl] .uppy-StatusBar-actionBtn--uploadNewlyAdded {
    padding-right: 3px
}

[dir=rtl] .uppy-StatusBar-status {
    padding-left: .3em
}

.uppy-StatusBar-status {
    display: flex;
    flex-direction: column;
    font-weight: 400;
    justify-content: center;
    line-height: 1.4
}

.uppy-StatusBar-statusPrimary {
    display: flex;
    font-weight: 500;
    line-height: 1
}

.uppy-Dashboard-Item-fileName button,.uppy-StatusBar-statusPrimary button.uppy-StatusBar-details,[dir=rtl] .uppy-StatusBar-statusSecondaryHint {
    margin-left: 5px
}

.uppy-StatusBar-statusSecondary {
    color: #757575;
    display: inline-block;
    font-size: 11px;
    line-height: 1.2;
    margin-top: 1px;
    white-space: nowrap
}

[data-uppy-theme=dark] .uppy-Dashboard-Item-status,[data-uppy-theme=dark] .uppy-StatusBar-statusSecondary {
    color: #bbb
}

[dir=ltr] .uppy-StatusBar-statusSecondaryHint {
    margin-right: 5px
}

.uppy-StatusBar-statusSecondaryHint {
    display: inline-block;
    line-height: 1;
    vertical-align: middle
}

[dir=ltr] .uppy-size--md .uppy-StatusBar-statusSecondaryHint {
    margin-right: 8px
}

[dir=rtl] .uppy-size--md .uppy-StatusBar-statusSecondaryHint {
    margin-left: 8px
}

[dir=ltr] .uppy-StatusBar-statusIndicator {
    margin-right: 7px
}

[dir=rtl] .uppy-StatusBar-statusIndicator {
    margin-left: 7px
}

.uppy-StatusBar-statusIndicator {
    color: #525252;
    position: relative;
    top: 1px
}

[dir=ltr] .uppy-Dashboard-FileCard-edit,[dir=ltr] .uppy-StatusBar-actions {
    right: 10px
}

[dir=rtl] .uppy-Dashboard-FileCard-edit,[dir=rtl] .uppy-StatusBar-actions {
    left: 10px
}

.uppy-StatusBar-actions {
    align-items: center;
    bottom: 0;
    display: flex;
    position: absolute;
    top: 0;
    z-index: 1004
}

.uppy-StatusBar.is-waiting .uppy-StatusBar-actions {
    background-color: #fafafa;
    height: 100%;
    padding: 0 15px;
    position: static;
    width: 100%
}

.uppy-StatusBar:not([aria-hidden=true]).is-waiting.has-ghosts {
    flex-direction: column;
    height: 90px
}

.uppy-size--md .uppy-StatusBar:not([aria-hidden=true]).is-waiting.has-ghosts {
    flex-direction: row;
    height: 65px
}

.uppy-StatusBar:not([aria-hidden=true]).is-waiting.has-ghosts .uppy-StatusBar-actions {
    flex-direction: column;
    justify-content: center
}

.uppy-size--md .uppy-StatusBar:not([aria-hidden=true]).is-waiting.has-ghosts .uppy-StatusBar-actions {
    flex-direction: row;
    justify-content: normal
}

.uppy-StatusBar-actionCircleBtn {
    cursor: pointer;
    line-height: 1;
    margin: 3px;
    opacity: .9
}

.uppy-StatusBar-actionCircleBtn::-moz-focus-inner {
    border: 0
}

[data-uppy-theme=dark] .uppy-StatusBar-actionCircleBtn::-moz-focus-inner {
    border: 0
}

.uppy-StatusBar-actionCircleBtn:focus {
    box-shadow: 0 0 0 3px #1269cf80;
    border-radius: 50%
}

.uppy-StatusBar-actionCircleBtn svg {
    vertical-align: bottom
}

.uppy-StatusBar-actionBtn {
    color: #1269cf;
    display: inline-block;
    font-size: 10px;
    line-height: inherit;
    vertical-align: middle
}

.uppy-size--md .uppy-StatusBar-actionBtn {
    font-size: 11px
}

.uppy-StatusBar-actionBtn--disabled {
    opacity: .4
}

.uppy-Dashboard-Item.is-ghost .uppy-Dashboard-Item-name,[data-uppy-theme=dark] .uppy-StatusBar-actionBtn--disabled {
    opacity: .7
}

[dir=ltr] .uppy-StatusBar-actionBtn--retry {
    margin-right: 6px
}

[dir=rtl] .uppy-StatusBar-actionBtn--retry {
    margin-left: 6px
}

.uppy-StatusBar-actionBtn--retry {
    background-color: #ff4b23;
    border-radius: 8px;
    color: #fff;
    height: 16px;
    line-height: 1;
    padding: 1px 6px 3px 18px;
    position: relative
}

.uppy-StatusBar-actionBtn--retry:focus {
    outline: 0;
    box-shadow: 0 0 0 3px #1269cf80
}

.uppy-StatusBar-actionBtn--retry::-moz-focus-inner {
    border: 0
}

[data-uppy-theme=dark] .uppy-StatusBar-actionBtn--retry::-moz-focus-inner {
    border: 0
}

.uppy-StatusBar-actionBtn--retry:hover {
    background-color: #f92d00
}

[dir=ltr] .uppy-StatusBar-actionBtn--retry svg {
    left: 6px
}

[dir=rtl] .uppy-StatusBar-actionBtn--retry svg {
    right: 6px
}

.uppy-StatusBar-actionBtn--retry svg {
    position: absolute;
    top: 3px
}

.uppy-StatusBar.is-waiting .uppy-StatusBar-actionBtn--upload {
    background-color: #1bb240;
    color: #fff;
    font-size: 14px;
    line-height: 1;
    padding: 15px 10px;
    width: 100%
}

.uppy-StatusBar.is-waiting .uppy-StatusBar-actionBtn--upload:hover {
    background-color: #189c38
}

[data-uppy-theme=dark] .uppy-StatusBar.is-waiting .uppy-StatusBar-actionBtn--upload,[data-uppy-theme=dark] .uppy-StatusBar.is-waiting .uppy-StatusBar-actionBtn--upload.uppy-StatusBar-actionBtn--disabled:hover {
    background-color: #1c8b37
}

[data-uppy-theme=dark] .uppy-StatusBar.is-waiting .uppy-StatusBar-actionBtn--upload:hover {
    background-color: #18762f
}

.uppy-size--md .uppy-StatusBar.is-waiting .uppy-StatusBar-actionBtn--upload {
    padding: 13px 22px;
    width: auto
}

.uppy-StatusBar.is-waiting .uppy-StatusBar-actionBtn--upload.uppy-StatusBar-actionBtn--disabled:hover {
    background-color: #1bb240;
    cursor: not-allowed
}

.uppy-StatusBar:not(.is-waiting) .uppy-StatusBar-actionBtn--upload {
    background-color: initial;
    color: #1269cf
}

[dir=ltr] .uppy-StatusBar-actionBtn--uploadNewlyAdded,[dir=rtl] .uppy-StatusBar-actionBtn--uploadNewlyAdded {
    padding-left: 3px
}

.uppy-StatusBar-actionBtn--uploadNewlyAdded {
    border-radius: 3px;
    padding-bottom: 1px
}

.uppy-Audio-button:focus,.uppy-Dashboard-FileCard-edit:focus,.uppy-Dashboard-Item-action:focus,.uppy-ProviderBrowser-searchFilterReset:focus,.uppy-ScreenCapture-button:focus,.uppy-StatusBar-actionBtn--uploadNewlyAdded:focus,.uppy-Webcam-button:focus {
    outline: 0;
    box-shadow: 0 0 0 3px #1269cf80
}

.uppy-StatusBar-actionBtn--uploadNewlyAdded::-moz-focus-inner {
    border: 0
}

[data-uppy-theme=dark] .uppy-StatusBar-actionBtn--uploadNewlyAdded::-moz-focus-inner {
    border: 0
}

.uppy-StatusBar.is-postprocessing .uppy-StatusBar-actionBtn--uploadNewlyAdded,.uppy-StatusBar.is-preprocessing .uppy-StatusBar-actionBtn--uploadNewlyAdded {
    display: none
}

.uppy-StatusBar-actionBtn--done {
    border-radius: 3px;
    line-height: 1;
    padding: 7px 8px
}

.uppy-Provider-breadcrumbs button:focus,.uppy-ProviderBrowser-userLogout:focus,.uppy-StatusBar-actionBtn--done:focus {
    outline: 0;
    background-color: #dfe6f1
}

.uppy-StatusBar-actionBtn--done::-moz-focus-inner {
    border: 0
}

.uppy-Provider-breadcrumbs button:hover,.uppy-StatusBar-actionBtn--done:hover {
    color: #0e51a0
}

[data-uppy-theme=dark] .uppy-Provider-breadcrumbs button:focus,[data-uppy-theme=dark] .uppy-ProviderBrowser-searchFilterInput:focus,[data-uppy-theme=dark] .uppy-ProviderBrowser-userLogout:focus,[data-uppy-theme=dark] .uppy-ProviderBrowserItem--is-checked .uppy-ProviderBrowserItem-checkbox,[data-uppy-theme=dark] .uppy-StatusBar-actionBtn--done:focus {
    background-color: #333
}

[data-uppy-theme=dark] .uppy-StatusBar-actionBtn--done {
    color: #02baf2
}

.uppy-size--md .uppy-Dashboard-FileCard-label,.uppy-size--md .uppy-StatusBar-actionBtn--done {
    font-size: 14px
}

.uppy-StatusBar-serviceMsg {
    color: #000;
    font-size: 11px;
    line-height: 1.1;
    padding-left: 10px
}

.uppy-size--md .uppy-StatusBar-serviceMsg {
    font-size: 14px;
    padding-left: 15px
}

.uppy-StatusBar-serviceMsg-ghostsIcon {
    left: 6px;
    opacity: .5;
    position: relative;
    top: 2px;
    vertical-align: text-bottom;
    width: 10px
}

.uppy-size--md .uppy-StatusBar-serviceMsg-ghostsIcon {
    left: 10px;
    top: 1px;
    width: 15px
}

[dir=ltr] .uppy-Dashboard-Item-errorDetails,[dir=ltr] .uppy-StatusBar-details {
    left: 2px
}

[dir=rtl] .uppy-Dashboard-Item-errorDetails,[dir=rtl] .uppy-StatusBar-details {
    right: 2px
}

.uppy-StatusBar-details {
    appearance: none;
    background-color: #939393;
    border-radius: 50%;
    color: #fff;
    cursor: help;
    display: inline-block;
    font-size: 10px;
    font-weight: 600;
    height: 13px;
    line-height: 12px;
    position: relative;
    text-align: center;
    top: 0;
    vertical-align: middle;
    width: 13px
}

[dir=ltr] .uppy-Dashboard-FileCard-actionsBtn,[dir=ltr] .uppy-StatusBar-spinner {
    margin-right: 10px
}

[dir=rtl] .uppy-Dashboard-FileCard-actionsBtn,[dir=rtl] .uppy-StatusBar-spinner {
    margin-left: 10px
}

.uppy-StatusBar-spinner {
    animation-duration: 1s;
    animation-iteration-count: infinite;
    animation-name: c;
    animation-timing-function: linear;
    fill: #1269cf
}

.uppy-StatusBar.is-postprocessing .uppy-StatusBar-spinner,.uppy-StatusBar.is-preprocessing .uppy-StatusBar-spinner {
    fill: #f6a623
}

@keyframes c {
    0% {
        transform: rotate(0)
    }

    to {
        transform: rotate(1turn)
    }
}

.uppy-ProviderBrowser-viewType--grid ul.uppy-ProviderBrowser-list,.uppy-ProviderBrowser-viewType--unsplash ul.uppy-ProviderBrowser-list {
    align-items: flex-start;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 6px
}

.uppy-ProviderBrowser-viewType--grid ul.uppy-ProviderBrowser-list:after,.uppy-ProviderBrowser-viewType--unsplash ul.uppy-ProviderBrowser-list:after {
    content: "";
    flex: auto
}

.uppy-ProviderBrowser-viewType--grid li.uppy-ProviderBrowserItem,.uppy-ProviderBrowser-viewType--unsplash li.uppy-ProviderBrowserItem {
    margin: 0;
    position: relative;
    width: 50%
}

.uppy-size--md .uppy-ProviderBrowser-viewType--grid li.uppy-ProviderBrowserItem,.uppy-size--md .uppy-ProviderBrowser-viewType--unsplash li.uppy-ProviderBrowserItem {
    width: 33.3333%
}

.uppy-size--lg .uppy-ProviderBrowser-viewType--grid li.uppy-ProviderBrowserItem,.uppy-size--lg .uppy-ProviderBrowser-viewType--unsplash li.uppy-ProviderBrowserItem {
    width: 25%
}

.uppy-ProviderBrowser-viewType--grid li.uppy-ProviderBrowserItem:before,.uppy-ProviderBrowser-viewType--unsplash li.uppy-ProviderBrowserItem:before {
    content: "";
    display: block;
    padding-top: 100%
}

.uppy-ProviderBrowser-viewType--grid li.uppy-ProviderBrowserItem--selected img,.uppy-ProviderBrowser-viewType--grid li.uppy-ProviderBrowserItem--selected svg,.uppy-ProviderBrowser-viewType--unsplash li.uppy-ProviderBrowserItem--selected img,.uppy-ProviderBrowser-viewType--unsplash li.uppy-ProviderBrowserItem--selected svg {
    opacity: .85
}

.uppy-ProviderBrowser-viewType--grid li.uppy-ProviderBrowserItem--disabled,.uppy-ProviderBrowser-viewType--unsplash li.uppy-ProviderBrowserItem--disabled {
    opacity: .5
}

.uppy-ProviderBrowser-viewType--grid li.uppy-ProviderBrowserItem--noPreview .uppy-ProviderBrowserItem-inner,.uppy-ProviderBrowser-viewType--unsplash li.uppy-ProviderBrowserItem--noPreview .uppy-ProviderBrowserItem-inner {
    background-color: #93939333
}

[data-uppy-theme=dark] .uppy-ProviderBrowser-viewType--grid li.uppy-ProviderBrowserItem--noPreview .uppy-ProviderBrowserItem-inner,[data-uppy-theme=dark] .uppy-ProviderBrowser-viewType--unsplash li.uppy-ProviderBrowserItem--noPreview .uppy-ProviderBrowserItem-inner {
    background-color: #eaeaea33
}

.uppy-ProviderBrowser-viewType--grid li.uppy-ProviderBrowserItem--noPreview svg,.uppy-ProviderBrowser-viewType--unsplash li.uppy-ProviderBrowserItem--noPreview svg {
    height: 30%;
    width: 30%;
    fill: #000000b3
}

[data-uppy-theme=dark] .uppy-ProviderBrowser-viewType--grid li.uppy-ProviderBrowserItem--noPreview svg,[data-uppy-theme=dark] .uppy-ProviderBrowser-viewType--unsplash li.uppy-ProviderBrowserItem--noPreview svg {
    fill: #fffc
}

.uppy-ProviderBrowser-viewType--grid .uppy-ProviderBrowserItem-inner,.uppy-ProviderBrowser-viewType--unsplash .uppy-ProviderBrowserItem-inner {
    border-radius: 4px;
    bottom: 7px;
    height: calc(100% - 14px);
    left: 7px;
    overflow: hidden;
    position: absolute;
    right: 7px;
    text-align: center;
    top: 7px;
    width: calc(100% - 14px)
}

[data-uppy-theme=dark] .uppy-ProviderBrowser-viewType--grid .uppy-ProviderBrowserItem-inner,[data-uppy-theme=dark] .uppy-ProviderBrowser-viewType--unsplash .uppy-ProviderBrowserItem-inner {
    box-shadow: 0 0 0 3px #aae1ffb3
}

.uppy-ProviderBrowser-viewType--grid .uppy-ProviderBrowserItem-inner img,.uppy-ProviderBrowser-viewType--unsplash .uppy-ProviderBrowserItem-inner img {
    border-radius: 4px;
    height: 100%;
    object-fit: cover;
    width: 100%
}

.uppy-ProviderBrowser-viewType--grid .uppy-ProviderBrowserItem-author,.uppy-ProviderBrowser-viewType--unsplash .uppy-ProviderBrowserItem-author {
    background: #0000004d;
    bottom: 0;
    color: #fff;
    display: none;
    font-size: 12px;
    font-weight: 500;
    left: 0;
    margin: 0;
    padding: 5px;
    position: absolute;
    text-decoration: none;
    width: 100%
}

.uppy-ProviderBrowser-viewType--grid .uppy-ProviderBrowserItem-author:hover,.uppy-ProviderBrowser-viewType--unsplash .uppy-ProviderBrowserItem-author:hover {
    background: #0006;
    text-decoration: underline
}

.uppy-ProviderBrowser-viewType--grid .uppy-ProviderBrowserItem-checkbox,.uppy-ProviderBrowser-viewType--unsplash .uppy-ProviderBrowserItem-checkbox {
    background-color: #1269cf;
    border-radius: 50%;
    height: 26px;
    opacity: 0;
    position: absolute;
    right: 16px;
    top: 16px;
    width: 26px;
    z-index: 1002
}

[dir=ltr] .uppy-ProviderBrowser-viewType--grid .uppy-ProviderBrowserItem-checkbox:after,[dir=ltr] .uppy-ProviderBrowser-viewType--unsplash .uppy-ProviderBrowserItem-checkbox:after {
    left: 7px
}

[dir=rtl] .uppy-ProviderBrowser-viewType--grid .uppy-ProviderBrowserItem-checkbox:after,[dir=rtl] .uppy-ProviderBrowser-viewType--unsplash .uppy-ProviderBrowserItem-checkbox:after {
    right: 7px
}

.uppy-ProviderBrowser-viewType--grid .uppy-ProviderBrowserItem-checkbox:after,.uppy-ProviderBrowser-viewType--unsplash .uppy-ProviderBrowserItem-checkbox:after {
    height: 7px;
    top: 8px;
    width: 12px
}

.uppy-ProviderBrowser-viewType--grid .uppy-ProviderBrowserItem-checkbox--grid:focus+label,.uppy-ProviderBrowser-viewType--unsplash .uppy-ProviderBrowserItem-checkbox--grid:focus+label {
    box-shadow: 0 0 0 3px #1269cf80
}

.uppy-ProviderBrowser-viewType--grid .uppy-ProviderBrowserItem-checkbox--grid:focus+label::-moz-focus-inner,.uppy-ProviderBrowser-viewType--unsplash .uppy-ProviderBrowserItem-checkbox--grid:focus+label::-moz-focus-inner {
    border: 0
}

.section-stack_dXJp h2,.section-stack_dXJp p,.uppy-ProviderBrowser-viewType--list {
    background-color: #fff
}

[data-uppy-theme=dark] .uppy-Dashboard-FileCard-info,[data-uppy-theme=dark] .uppy-DashboardContent-panelBody,[data-uppy-theme=dark] .uppy-ProviderBrowser-headerBar,[data-uppy-theme=dark] .uppy-ProviderBrowser-list,[data-uppy-theme=dark] .uppy-ProviderBrowser-viewType--list,[data-uppy-theme=dark] .uppy-SearchProvider {
    background-color: #1f1f1f
}

.uppy-ProviderBrowser-viewType--list li.uppy-ProviderBrowserItem {
    align-items: center;
    display: flex;
    margin: 0;
    padding: 7px 15px
}

[data-uppy-theme=dark] .uppy-Dashboard-FileCard-label,[data-uppy-theme=dark] .uppy-Dashboard-Item-action:hover,[data-uppy-theme=dark] .uppy-Dashboard-Item-name,[data-uppy-theme=dark] .uppy-Provider-breadcrumbs,[data-uppy-theme=dark] .uppy-Provider-breadcrumbs button,[data-uppy-theme=dark] .uppy-ProviderBrowser-user,[data-uppy-theme=dark] .uppy-ProviderBrowser-userLogout,[data-uppy-theme=dark] .uppy-ProviderBrowser-viewType--list li.uppy-ProviderBrowserItem {
    color: #eaeaea
}

.uppy-ProviderBrowser-viewType--list li.uppy-ProviderBrowserItem--disabled {
    opacity: .6
}

[dir=ltr] .uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-checkbox {
    margin-right: 15px
}

[dir=rtl] .uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-checkbox {
    margin-left: 15px
}

.uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-checkbox {
    background-color: #fff;
    border: 1px solid #cfcfcf;
    border-radius: 3px;
    height: 17px;
    width: 17px
}

.uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-checkbox:focus {
    border: 1px solid #1269cf;
    box-shadow: 0 0 0 3px #1269cf40;
    outline: 0
}

[dir=ltr] .uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-checkbox:after {
    left: 3px
}

[dir=rtl] .uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-checkbox:after {
    right: 3px
}

.uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-checkbox:after {
    height: 5px;
    opacity: 0;
    top: 4px;
    width: 9px
}

[data-uppy-theme=dark] .uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-checkbox:focus {
    border-color: #02baf2b3;
    box-shadow: 0 0 0 3px #02baf233
}

.uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem--is-checked .uppy-ProviderBrowserItem-checkbox,.uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem--is-partial .uppy-ProviderBrowserItem-checkbox {
    background-color: #1269cf;
    border-color: #1269cf
}

.uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem--is-checked .uppy-ProviderBrowserItem-checkbox:after,.uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem--is-partial .uppy-ProviderBrowserItem-checkbox:after {
    opacity: 1
}

.uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-inner {
    align-items: center;
    color: inherit;
    display: flex;
    overflow: hidden;
    padding: 2px;
    text-overflow: ellipsis;
    white-space: nowrap
}

.uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-inner:focus {
    outline: 0;
    text-decoration: underline
}

.uppy-Provider-btn-google svg,[dir=ltr] .uppy-ProviderBrowser-footer button,[dir=ltr] .uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-inner img,[dir=ltr] .uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-inner svg {
    margin-right: 8px
}

[dir=ltr] .uppy-DashboardContent-addMore svg,[dir=ltr] .uppy-Provider-breadcrumbsIcon {
    margin-right: 4px
}

[dir=rtl] .uppy-ProviderBrowser-footer button,[dir=rtl] .uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-inner img,[dir=rtl] .uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-inner svg {
    margin-left: 8px
}

[dir=rtl] .uppy-DashboardContent-addMore svg,[dir=rtl] .uppy-Provider-breadcrumbsIcon {
    margin-left: 4px
}

.uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-inner span {
    line-height: 1.2;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
}

.uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem--disabled .uppy-ProviderBrowserItem-inner,.uppy-ProviderBrowserItem-checkbox:disabled,.uppy-ProviderBrowserItem-checkbox:disabled:after {
    cursor: default
}

[dir=ltr] .uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-iconWrap {
    margin-right: 7px
}

[dir=rtl] .uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-iconWrap {
    margin-left: 7px
}

.uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-iconWrap {
    width: 20px
}

.uppy-ProviderBrowserItem-checkbox {
    cursor: pointer;
    flex-shrink: 0;
    position: relative
}

[data-uppy-theme=dark] .uppy-ProviderBrowserItem-checkbox {
    background-color: #1f1f1f;
    border-color: #939393
}

.uppy-ProviderBrowserItem--is-checked .uppy-ProviderBrowserItem-checkbox:after {
    border-bottom: 2px solid #eaeaea;
    border-left: 2px solid #eaeaea;
    content: "";
    cursor: pointer;
    position: absolute;
    transform: rotate(-45deg)
}

.uppy-ProviderBrowserItem--is-partial .uppy-ProviderBrowserItem-checkbox:after {
    background-color: #eaeaea!important;
    content: ""!important;
    height: 2px!important;
    left: 20%!important;
    position: absolute!important;
    right: 20%!important;
    top: 50%!important;
    transform: translateY(-50%)!important
}

.uppy-SearchProvider,.uppy-Url {
    align-items: center;
    display: flex;
    flex: 1;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    width: 100%
}

.uppy-SearchProvider-input,.uppy-Url-input {
    margin-bottom: 15px;
    max-width: 650px;
    width: 90%
}

.uppy-size--md .uppy-SearchProvider-input,.uppy-size--md .uppy-Url-input {
    margin-bottom: 20px
}

.uppy-SearchProvider-input::-webkit-search-cancel-button {
    display: none
}

.uppy-SearchProvider-searchButton,.uppy-Url-importButton {
    padding: 13px 25px
}

.uppy-size--md .uppy-SearchProvider-searchButton,.uppy-size--md .uppy-Url-importButton {
    padding: 13px 30px
}

.uppy-DashboardContent-panelBody {
    align-items: center;
    display: flex;
    flex: 1;
    justify-content: center
}

.uppy-Provider-auth,.uppy-Provider-empty,.uppy-Provider-error,.uppy-Provider-loading {
    align-items: center;
    color: #939393;
    display: flex;
    flex: 1;
    flex-flow: column wrap;
    justify-content: center
}

.uppy-Provider-authIcon svg {
    height: 75px;
    width: 100px
}

.uppy-Provider-authTitle {
    color: #757575;
    font-size: 17px;
    font-weight: 400;
    line-height: 1.4;
    margin-bottom: 30px;
    max-width: 500px;
    padding: 0 15px;
    text-align: center
}

.uppy-size--md .uppy-Provider-authTitle {
    font-size: 20px
}

[data-uppy-theme=dark] .uppy-Dashboard-Item-action,[data-uppy-theme=dark] .uppy-Provider-authTitle {
    color: #cfcfcf
}

.uppy-Provider-btn-google {
    align-items: center;
    background: #4285f4;
    display: flex;
    padding: 8px 12px!important
}

.uppy-Provider-btn-google:hover {
    background-color: #1266f1
}

.uppy-Provider-btn-google:focus {
    box-shadow: 0 0 0 3px #4285f466;
    outline: 0
}

.uppy-Provider-breadcrumbs {
    color: #525252;
    flex: 1;
    font-size: 12px;
    margin-bottom: 10px
}

.uppy-Provider-breadcrumbsIcon {
    color: #525252;
    display: inline-block;
    line-height: 1;
    vertical-align: middle
}

.uppy-Provider-breadcrumbsIcon svg {
    height: 13px;
    width: 13px;
    fill: #525252
}

.uppy-Provider-breadcrumbs button {
    border-radius: 3px;
    display: inline-block;
    line-height: inherit;
    padding: 4px
}

.uppy-Provider-breadcrumbs button::-moz-focus-inner {
    border: 0
}

.uppy-Provider-breadcrumbs button:last-of-type {
    color: #333;
    cursor: normal;
    font-weight: 500;
    pointer-events: none
}

.uppy-ProviderBrowser {
    display: flex;
    flex: 1;
    flex-direction: column;
    font-size: 14px;
    font-weight: 400;
    height: 100%
}

.uppy-ProviderBrowser-user {
    color: #333;
    font-weight: 500;
    margin: 0 8px 0 0
}

[dir=ltr] .uppy-ProviderBrowser-user:after {
    left: 4px
}

[dir=rtl] .uppy-ProviderBrowser-user:after {
    right: 4px
}

.uppy-ProviderBrowser-user:after {
    color: #939393;
    content: "·";
    font-weight: 400;
    position: relative
}

.uppy-ProviderBrowser-header {
    border-bottom: 1px solid #eaeaea;
    position: relative;
    z-index: 1001
}

[data-uppy-theme=dark] .uppy-ProviderBrowser-header {
    border-bottom: 1px solid #333
}

.uppy-ProviderBrowser-headerBar {
    background-color: #fafafa;
    color: #757575;
    font-size: 12px;
    line-height: 1.4;
    padding: 7px 15px;
    z-index: 1001
}

.uppy-ProviderBrowser-headerBar--simple {
    display: block;
    justify-content: center;
    text-align: center
}

.uppy-ProviderBrowser-headerBar--simple .uppy-Provider-breadcrumbsWrap {
    display: inline-block;
    flex: none;
    vertical-align: middle
}

.uppy-ProviderBrowser-searchFilter {
    align-items: center;
    display: flex;
    height: 30px;
    margin-bottom: 15px;
    margin-top: 15px;
    padding-left: 8px;
    padding-right: 8px;
    position: relative;
    width: 100%
}

[dir=ltr] .uppy-ProviderBrowser-searchFilterInput,[dir=rtl] .uppy-ProviderBrowser-searchFilterInput {
    padding-left: 30px;
    padding-right: 30px
}

.uppy-ProviderBrowser-searchFilterInput {
    background-color: #eaeaea;
    border: 0;
    border-radius: 4px;
    color: #333;
    font-size: 13px;
    height: 30px;
    line-height: 1.4;
    outline: 0;
    width: 100%;
    z-index: 1001
}

.uppy-ProviderBrowser-searchFilterInput::-webkit-search-cancel-button {
    display: none
}

[data-uppy-theme=dark] .uppy-ProviderBrowser-searchFilterInput {
    background-color: #1f1f1f;
    color: #eaeaea
}

.uppy-ProviderBrowser-searchFilterInput:focus {
    background-color: #cfcfcf;
    border: 0
}

[dir=ltr] .uppy-ProviderBrowser-searchFilterIcon,[dir=rtl] .uppy-ProviderBrowser-searchFilterReset {
    left: 16px
}

[dir=ltr] .uppy-ProviderBrowser-searchFilterReset,[dir=rtl] .uppy-ProviderBrowser-searchFilterIcon {
    right: 16px
}

.uppy-ProviderBrowser-searchFilterIcon {
    color: #757575;
    height: 12px;
    position: absolute;
    width: 12px;
    z-index: 1002
}

.uppy-ProviderBrowser-searchFilterInput::placeholder {
    color: #939393;
    opacity: 1
}

.uppy-ProviderBrowser-searchFilterReset {
    border-radius: 3px;
    color: #939393;
    cursor: pointer;
    height: 22px;
    padding: 6px;
    position: absolute;
    width: 22px;
    z-index: 1002
}

.uppy-ProviderBrowser-searchFilterReset::-moz-focus-inner {
    border: 0
}

.uppy-Dashboard-Item-author a,.uppy-ProviderBrowser-searchFilterReset:hover {
    color: #757575
}

.uppy-ProviderBrowser-searchFilterReset svg {
    vertical-align: text-top
}

.uppy-ProviderBrowser-userLogout {
    border-radius: 3px;
    color: #1269cf;
    cursor: pointer;
    line-height: inherit;
    padding: 4px
}

.uppy-ProviderBrowser-userLogout::-moz-focus-inner {
    border: 0
}

.uppy-ProviderBrowser-userLogout:hover {
    color: #0e51a0;
    text-decoration: underline
}

.uppy-ProviderBrowser-body {
    flex: 1;
    position: relative
}

.uppy-ProviderBrowser-list {
    background-color: #fff;
    border-spacing: 0;
    bottom: 0;
    display: block;
    flex: 1;
    height: 100%;
    left: 0;
    list-style: none;
    margin: 0;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: 100%;
    -webkit-overflow-scrolling: touch
}

.uppy-ProviderBrowserItem-inner {
    cursor: pointer;
    font-size: 13px;
    font-weight: 500
}

.uppy-ProviderBrowser-footer {
    align-items: center;
    background-color: #fff;
    border-top: 1px solid #eaeaea;
    display: flex;
    justify-content: space-between;
    padding: 15px
}

.uppy-ProviderBrowser-footer-buttons {
    flex-shrink: 0
}

.uppy-ProviderBrowser-footer-error {
    color: #e32437;
    line-height: 18px
}

.uppy-Dashboard-Item-previewInnerWrap {
    align-items: center;
    border-radius: 3px;
    box-shadow: 0 0 2px 0 #0006;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    overflow: hidden;
    position: relative;
    width: 100%
}

.uppy-size--md .uppy-Dashboard-Item-previewInnerWrap {
    box-shadow: 0 1px 2px #00000026
}

.uppy-Dashboard--singleFile .uppy-Dashboard-Item-previewInnerWrap {
    box-shadow: none
}

.uppy-Dashboard-Item-previewInnerWrap:after {
    background-color: #000000a6;
    bottom: 0;
    content: "";
    display: none;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 1001
}

.uppy-Dashboard-Item-previewLink {
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 1002
}

.uppy-Dashboard-Item-previewLink:focus {
    box-shadow: inset 0 0 0 3px #579df0
}

[data-uppy-theme=dark] .uppy-Dashboard-Item-previewLink:focus {
    box-shadow: inset 0 0 0 3px #016c8d
}

.uppy-Dashboard-Item-preview img.uppy-Dashboard-Item-previewImg {
    border-radius: 3px;
    height: 100%;
    object-fit: cover;
    transform: translateZ(0);
    width: 100%
}

.uppy-Dashboard--singleFile .uppy-Dashboard-Item-preview img.uppy-Dashboard-Item-previewImg {
    height: auto;
    max-height: 100%;
    max-width: 100%;
    object-fit: contain;
    padding: 10px;
    width: auto;
}

.uppy-Dashboard-Item-progress {
    color: #fff;
    left: 50%;
    position: absolute;
    text-align: center;
    top: 50%;
    transform: translate(-50%,-50%);
    width: 120px;
    z-index: 1002
}

.uppy-Dashboard-Item-progressIndicator {
    color: #fff;
    display: inline-block;
    height: 38px;
    opacity: .9;
    width: 38px
}

.uppy-size--md .uppy-Dashboard-Item-progressIndicator {
    height: 55px;
    width: 55px
}

button.uppy-Dashboard-Item-progressIndicator::-moz-focus-inner {
    border: 0
}

button.uppy-Dashboard-Item-progressIndicator:focus .uppy-Dashboard-Item-progressIcon--bg,button.uppy-Dashboard-Item-progressIndicator:focus .uppy-Dashboard-Item-progressIcon--retry {
    fill: #579df0
}

.uppy-Dashboard-Item-progressIcon--circle {
    height: 100%;
    width: 100%
}

.uppy-Dashboard-Item-progressIcon--bg {
    stroke: #fff6
}

.uppy-Dashboard-Item-progressIcon--progress {
    transition: stroke-dashoffset .5s ease-out;
    stroke: #fff
}

.uppy-Dashboard-Item-progressIcon--cancel,.uppy-Dashboard-Item-progressIcon--check,.uppy-Dashboard-Item-progressIcon--play {
    fill: #fff;
    transition: .2s
}

.uppy-Dashboard-Item-progressIcon--play {
    stroke: #fff
}

.uppy-Dashboard-Item-progressIcon--pause {
    transition: .2s;
    fill: #fff;
    stroke: #fff
}

.uppy-Dashboard-Item-progressIcon--retry {
    fill: #fff
}

[dir=rtl] .uppy-Dashboard-Item.is-complete .uppy-Dashboard-Item-progress {
    left: -8px
}

[dir=ltr] .uppy-Dashboard-Item.is-complete .uppy-Dashboard-Item-progress {
    right: -8px;
    left: auto
}

[dir=rtl] .uppy-Dashboard-Item.is-complete .uppy-Dashboard-Item-progress {
    right: auto
}

.uppy-Dashboard-Item.is-complete .uppy-Dashboard-Item-progress {
    top: -9px;
    transform: none;
    width: auto
}

.uppy-Dashboard-Item.is-error .uppy-Dashboard-Item-progressIndicator {
    height: 18px;
    width: 18px
}

.uppy-size--md .uppy-Dashboard-Item.is-error .uppy-Dashboard-Item-progressIndicator {
    height: 28px;
    width: 28px
}

.uppy-Dashboard-Item.is-complete .uppy-Dashboard-Item-progressIndicator {
    height: 18px;
    opacity: 1;
    width: 18px
}

.uppy-size--md .uppy-Dashboard-Item.is-complete .uppy-Dashboard-Item-progressIndicator {
    height: 22px;
    width: 22px
}

.cropper-invisible,.uppy-Dashboard-Item.is-processing .uppy-Dashboard-Item-progress,.uppy-ImageCropper .cropper-face {
    opacity: 0
}

[dir=ltr] .uppy-Dashboard-Item-fileInfo {
    padding-right: 5px
}

[dir=rtl] .uppy-Dashboard-Item-fileInfo {
    padding-left: 5px
}

.uppy-Dashboard-Item-name {
    font-size: 12px;
    font-weight: 500;
    line-height: 1.3;
    margin-bottom: 5px;
    word-wrap: anywhere;
    word-break: break-all
}

.uppy-Dashboard-Item-author,.uppy-Dashboard-Item-status {
    color: #757575;
    font-size: 11px;
    font-weight: 400;
    line-height: 1
}

.uppy-size--md.uppy-Dashboard--singleFile .uppy-Dashboard-Item-name {
    font-size: 14px;
    line-height: 1.4
}

.uppy-Dashboard-Item-fileName {
    align-items: baseline;
    display: flex
}

.uppy-Dashboard-Item-author,.uppy-Dashboard-Item-statusSize {
    display: inline-block;
    margin-bottom: 5px;
    vertical-align: bottom
}

.uppy-Dashboard-Item-reSelect {
    color: #1269cf;
    font-family: inherit;
    font-size: inherit;
    font-weight: 600
}

.uppy-Dashboard-Item-errorMessage {
    background-color: #fdeff1;
    color: #a51523;
    font-size: 11px;
    font-weight: 500;
    line-height: 1.3;
    padding: 5px 6px
}

.uppy-Dashboard-Item-errorMessageBtn {
    color: #a51523;
    cursor: pointer;
    font-size: 11px;
    font-weight: 500;
    text-decoration: underline
}

.uppy-Dashboard-Item-preview .uppy-Dashboard-Item-errorMessage,.uppy-size--md .uppy-Dashboard-Item-fileInfo .uppy-Dashboard-Item-errorMessage {
    display: none
}

.uppy-size--md .uppy-Dashboard-Item-preview .uppy-Dashboard-Item-errorMessage {
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
    border-top: 1px solid #f7c2c8;
    bottom: 0;
    display: block;
    left: 0;
    line-height: 1.4;
    padding: 6px 8px;
    position: absolute;
    right: 0
}

.uppy-Dashboard-Item-fileInfo .uppy-Dashboard-Item-errorMessage {
    border: 1px solid #f7c2c8;
    border-radius: 3px;
    display: inline-block;
    position: static
}

.uppy-Dashboard-Item-action {
    color: #939393;
    cursor: pointer
}

.uppy-Dashboard-Item-action::-moz-focus-inner {
    border: 0
}

.uppy-Dashboard-Item-action:hover {
    color: #1f1f1f;
    opacity: 1
}

[data-uppy-theme=dark] .uppy-Dashboard-Item-action::-moz-focus-inner {
    border: 0
}

.uppy-Dashboard-Item-action--remove {
    color: #1f1f1f;
    opacity: .95
}

.uppy-Dashboard-Item-action--remove:hover {
    color: #000;
    opacity: 1
}

[dir=ltr] .uppy-size--md .uppy-Dashboard-Item-action--remove {
    right: -8px
}

[dir=rtl] .uppy-size--md .uppy-Dashboard-Item-action--remove {
    left: -8px
}

.uppy-size--md .uppy-Dashboard-Item-action--remove {
    height: 18px;
    padding: 0;
    position: absolute;
    top: -8px;
    width: 18px;
    z-index: 1002
}

.uppy-size--md .uppy-Dashboard-Item-action--remove:focus {
    border-radius: 50%
}

[dir=ltr] .uppy-Dashboard--singleFile.uppy-size--height-md .uppy-Dashboard-Item-action--remove {
    right: 8px
}

[dir=rtl] .uppy-Dashboard--singleFile.uppy-size--height-md .uppy-Dashboard-Item-action--remove {
    left: 8px
}

.uppy-Dashboard--singleFile.uppy-size--height-md .uppy-Dashboard-Item-action--remove {
    position: absolute;
    top: 8px
}

[data-uppy-theme=dark] .uppy-Dashboard-Item-action--remove {
    color: #525252
}

[data-uppy-theme=dark] .uppy-Dashboard-Item-action--remove:hover {
    color: #333
}

.section-much-more_zGqh ul span:first-of-type,.uppy-Dashboard:not(.uppy-size--md):not(.uppy-Dashboard--singleFile.uppy-size--height-md) .uppy-Dashboard-Item-actionWrapper {
    align-items: center;
    display: flex
}

.uppy-Dashboard:not(.uppy-size--md):not(.uppy-Dashboard--singleFile.uppy-size--height-md) .uppy-Dashboard-Item-action {
    height: 22px;
    margin-left: 3px;
    padding: 3px;
    width: 22px
}

.uppy-Dashboard:not(.uppy-size--md):not(.uppy-Dashboard--singleFile.uppy-size--height-md) .uppy-Dashboard-Item-action:focus,.uppy-size--md .uppy-Dashboard-Item-action--copyLink:focus,.uppy-size--md .uppy-Dashboard-Item-action--edit:focus {
    border-radius: 3px
}

.uppy-size--md .uppy-Dashboard-Item-action--copyLink,.uppy-size--md .uppy-Dashboard-Item-action--edit {
    height: 16px;
    padding: 0;
    width: 16px
}

.uppy-Dashboard-Item {
    align-items: center;
    border-bottom: 1px solid #eaeaea;
    display: flex;
    padding: 10px
}

:not(.containsTaskList_mC6p>li)>.containsTaskList_mC6p,[dir=rtl] .uppy-Dashboard:not(.uppy-Dashboard--singleFile) .uppy-Dashboard-Item {
    padding-left: 0
}

[data-uppy-theme=dark] .uppy-Dashboard-Item {
    border-bottom: 1px solid #333
}

[dir=ltr] .uppy-size--md .uppy-Dashboard-Item {
    float: left
}

[dir=rtl] .uppy-size--md .uppy-Dashboard-Item {
    float: right
}

.uppy-size--md .uppy-Dashboard-Item {
    border-bottom: 0;
    display: block;
    height: 215px;
    margin: 5px 15px;
    padding: 0;
    position: relative;
    width: calc(33.333% - 30px)
}

.uppy-size--lg .uppy-Dashboard-Item {
    height: 190px;
    margin: 5px 15px;
    padding: 0;
    width: calc(25% - 30px)
}

.uppy-size--xl .uppy-Dashboard-Item {
    height: 210px;
    padding: 0;
    width: calc(20% - 30px)
}

.uppy-Dashboard--singleFile .uppy-Dashboard-Item {
    border-bottom: 0;
    display: flex;
    flex-direction: column;
    height: 100%;
    max-width: 400px;
    padding: 15px;
    position: relative;
    width: 100%
}

.uppy-Dashboard-Item.is-ghost .uppy-Dashboard-Item-previewInnerWrap {
    opacity: .2
}

.uppy-Dashboard-Item.is-ghost .uppy-Dashboard-Item-preview:before {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='35' height='39'%3E%3Cpath fill='%2523000' d='M1.708 38.66c1.709 0 3.417-3.417 6.834-3.417s5.125 3.417 8.61 3.417c3.348 0 5.056-3.417 8.473-3.417 4.305 0 5.125 3.417 6.833 3.417.889 0 1.709-.889 1.709-1.709v-19.68C34.167-5.757 0-5.757 0 17.271v19.68c0 .82.888 1.709 1.708 1.709m8.542-17.084a3.383 3.383 0 0 1-3.417-3.416 3.383 3.383 0 0 1 3.417-3.417 3.383 3.383 0 0 1 3.417 3.417 3.383 3.383 0 0 1-3.417 3.416m13.667 0A3.383 3.383 0 0 1 20.5 18.16a3.383 3.383 0 0 1 3.417-3.417 3.383 3.383 0 0 1 3.416 3.417 3.383 3.383 0 0 1-3.416 3.416'/%3E%3C/svg%3E");
    background-position: 50% 10px;
    background-repeat: no-repeat;
    background-size: 25px;
    bottom: 0;
    content: "";
    left: 0;
    opacity: .5;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 1005
}

.uppy-size--md .uppy-Dashboard-Item.is-ghost .uppy-Dashboard-Item-preview:before {
    background-position: 50% 50%;
    background-size: 40px
}

.uppy-Dashboard--singleFile .uppy-Dashboard-Item.is-ghost .uppy-Dashboard-Item-preview:before {
    background-position: 50% 50%;
    background-size: 30%
}

.uppy-Dashboard-Item-preview {
    flex-grow: 0;
    flex-shrink: 0;
    height: 50px;
    position: relative;
    width: 50px
}

.uppy-size--md .uppy-Dashboard-Item-preview {
    height: 140px;
    width: 100%
}

.uppy-size--lg .uppy-Dashboard-Item-preview {
    height: 120px
}

.uppy-size--xl .uppy-Dashboard-Item-preview {
    height: 140px
}

.uppy-Dashboard--singleFile .uppy-Dashboard-Item-preview {
    flex-grow: 1;
    max-height: 75%;
    width: 100%
}

.uppy-Dashboard--singleFile.uppy-size--md .uppy-Dashboard-Item-preview {
    max-height: 100%
}

[dir=rtl] .uppy-Dashboard-Item-fileInfoAndButtons {
    padding-left: 8px
}

[dir=ltr] .uppy-Dashboard-Item-fileInfoAndButtons {
    padding-right: 8px;
    padding-left: 12px
}

[dir=rtl] .uppy-Dashboard-Item-fileInfoAndButtons {
    padding-right: 12px
}

.uppy-Dashboard-Item-fileInfoAndButtons {
    align-items: center;
    display: flex;
    flex-grow: 1;
    justify-content: space-between
}

.uppy-Dashboard--singleFile .uppy-Dashboard-Item-fileInfoAndButtons,.uppy-size--md .uppy-Dashboard-Item-fileInfoAndButtons {
    align-items: flex-start;
    padding: 9px 0 0
}

.uppy-Audio-audioSourceContainer,.uppy-Dashboard--singleFile .uppy-Dashboard-Item-fileInfoAndButtons {
    flex-grow: 0;
    width: 100%
}

.uppy-Dashboard-Item-fileInfo {
    flex-grow: 1;
    flex-shrink: 1
}

.uppy-Dashboard-Item-actionWrapper {
    flex-grow: 0;
    flex-shrink: 0
}

.uppy-Dashboard-Item-errorDetails {
    appearance: none;
    background-color: #939393;
    border: none;
    border-radius: 50%;
    color: #fff;
    cursor: help;
    flex-shrink: 0;
    font-size: 10px;
    font-weight: 600;
    height: 13px;
    line-height: 12px;
    position: relative;
    text-align: center;
    top: 0;
    width: 13px
}

.uppy-Dashboard-FileCard {
    background-color: #fff;
    border-radius: 5px;
    bottom: 0;
    box-shadow: 0 0 10px 4px #0000001a;
    display: flex;
    flex-direction: column;
    height: 100%;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: 100%;
    z-index: 1005
}

.uppy-Dashboard-FileCard .uppy-DashboardContent-bar {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px
}

.uppy-Dashboard-FileCard .uppy-Dashboard-FileCard-actions {
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px
}

.uppy-Dashboard-FileCard-inner {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    flex-shrink: 1;
    height: 100%;
    min-height: 0
}

.uppy-Dashboard-FileCard-preview {
    align-items: center;
    border-bottom: 1px solid #eaeaea;
    display: flex;
    flex-grow: 0;
    flex-shrink: 1;
    height: 60%;
    justify-content: center;
    min-height: 0;
    position: relative
}

[data-uppy-theme=dark] .uppy-Dashboard-FileCard-preview {
    background-color: #333;
    border-bottom: 0
}

.uppy-Dashboard-FileCard-preview img.uppy-Dashboard-Item-previewImg {
    border-radius: 3px;
    box-shadow: 0 3px 20px #00000026;
    flex: 0 0 auto;
    max-height: 90%;
    max-width: 90%;
    object-fit: cover
}

.uppy-Dashboard-FileCard-edit {
    background-color: #00000080;
    border-radius: 50px;
    color: #fff;
    font-size: 13px;
    padding: 7px 15px;
    position: absolute;
    top: 10px
}

.uppy-Dashboard-FileCard-edit::-moz-focus-inner {
    border: 0
}

.uppy-Dashboard-FileCard-edit:hover {
    background-color: #000c
}

.uppy-Dashboard-FileCard-info {
    flex-grow: 0;
    flex-shrink: 0;
    height: 40%;
    overflow-y: auto;
    padding: 30px 20px 20px;
    -webkit-overflow-scrolling: touch
}

.uppy-Dashboard-FileCard-fieldset {
    border: 0;
    font-size: 0;
    margin: auto auto 12px;
    max-width: 640px;
    padding: 0
}

.uppy-Dashboard-FileCard-label {
    color: #525252;
    display: inline-block;
    font-size: 12px;
    vertical-align: middle;
    width: 22%
}

.uppy-Dashboard-FileCard-input {
    display: inline-block;
    vertical-align: middle;
    width: 78%
}

.uppy-Dashboard-FileCard-actions {
    align-items: center;
    background-color: #fafafa;
    border-top: 1px solid #eaeaea;
    display: flex;
    flex-grow: 0;
    flex-shrink: 0;
    height: 55px;
    padding: 0 15px
}

.uppy-size--md .uppy-Dashboard-FileCard-actions {
    height: 65px
}

.uppy-transition-slideDownUp-enter {
    opacity: .01;
    transform: translate3d(0,-105%,0);
    transition: transform .25s ease-in-out,opacity .25s ease-in-out
}

.uppy-transition-slideDownUp-enter.uppy-transition-slideDownUp-enter-active {
    opacity: 1;
    transform: translateZ(0)
}

.uppy-transition-slideDownUp-leave {
    opacity: 1;
    transform: translateZ(0);
    transition: transform .25s ease-in-out,opacity .25s ease-in-out
}

.uppy-transition-slideDownUp-leave.uppy-transition-slideDownUp-leave-active {
    opacity: .01;
    transform: translate3d(0,-105%,0)
}

@keyframes d {
    0% {
        opacity: 0
    }

    to {
        opacity: 1
    }
}

@keyframes e {
    0% {
        opacity: 1
    }

    to {
        opacity: 0
    }
}

@keyframes f {
    0% {
        opacity: 0;
        transform: translate3d(-50%,-70%,0)
    }

    to {
        opacity: 1;
        transform: translate3d(-50%,-50%,0)
    }
}

@keyframes g {
    0% {
        opacity: 0;
        transform: translate3d(0,-20%,0)
    }

    to {
        opacity: 1;
        transform: translateZ(0)
    }
}

@keyframes h {
    0% {
        opacity: 1;
        transform: translate3d(-50%,-50%,0)
    }

    to {
        opacity: 0;
        transform: translate3d(-50%,-70%,0)
    }
}

@keyframes i {
    0% {
        opacity: 1;
        transform: translateZ(0)
    }

    to {
        opacity: 0;
        transform: translate3d(0,-20%,0)
    }
}

.uppy-Dashboard--modal {
    z-index: 1001
}

.uppy-Dashboard--modal[aria-hidden=true] {
    display: none
}

.uppy-Dashboard--modal.uppy-Dashboard--animateOpenClose>.uppy-Dashboard-inner {
    animation: .3s cubic-bezier(0,0,.2,1) g
}

.uppy-Dashboard--modal.uppy-Dashboard--animateOpenClose>.uppy-Dashboard-overlay {
    animation: .3s cubic-bezier(0,0,.2,1) d
}

.uppy-Dashboard--modal.uppy-Dashboard--animateOpenClose.uppy-Dashboard--isClosing>.uppy-Dashboard-inner {
    animation: .3s cubic-bezier(0,0,.2,1) i
}

.uppy-Dashboard--modal.uppy-Dashboard--animateOpenClose.uppy-Dashboard--isClosing>.uppy-Dashboard-overlay {
    animation: .3s cubic-bezier(0,0,.2,1) e
}

.uppy-Dashboard-isFixed {
    height: 100vh;
    overflow: hidden
}

.uppy-Dashboard--modal .uppy-Dashboard-overlay {
    background-color: #00000080;
    bottom: 0;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 1001
}

.uppy-Dashboard-inner {
    background-color: #f4f4f4;
    border: 1px solid #eaeaea;
    border-radius: 5px;
    max-height: 100%;
    max-width: 100%;
    outline: 0;
    position: relative
}

.uppy-size--md .uppy-Dashboard-inner {
    min-height: auto
}

[data-uppy-theme=dark] .uppy-Dashboard-inner,[data-uppy-theme=dark] .uppy-Url {
    background-color: #1f1f1f
}

.uppy-Dashboard--isDisabled .uppy-Dashboard-inner {
    cursor: not-allowed
}

.uppy-Dashboard-innerWrap {
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    height: 100%;
    opacity: 0;
    overflow: hidden;
    position: relative
}

.uppy-Dashboard--isInnerWrapVisible .uppy-Dashboard-innerWrap {
    opacity: 1
}

.uppy-Dashboard--isDisabled .uppy-Dashboard-innerWrap {
    cursor: not-allowed;
    filter: grayscale(100%);
    opacity: .6;
    -webkit-user-select: none;
    user-select: none
}

.uppy-Dashboard--isDisabled .uppy-ProviderIconBg {
    fill: #9f9f9f
}

.uppy-Dashboard--isDisabled [aria-disabled],.uppy-Dashboard--isDisabled [disabled] {
    cursor: not-allowed;
    pointer-events: none
}

.uppy-Dashboard--modal .uppy-Dashboard-inner {
    z-index: 1002;
    border: none;
    bottom: 15px;
    left: 15px;
    position: fixed;
    right: 15px;
    top: 35px
}

[dir=ltr] .uppy-Dashboard-close {
    right: -2px
}

[dir=rtl] .uppy-Dashboard-close {
    left: -2px
}

.uppy-Dashboard-close {
    color: #ffffffe6;
    cursor: pointer;
    display: block;
    font-size: 27px;
    position: absolute;
    top: -33px;
    z-index: 1005
}

.uppy-Dashboard-close:focus {
    outline: 0;
    color: #6eabf2
}

.uppy-Dashboard-close::-moz-focus-inner {
    border: 0
}

.uppy-Dashboard-serviceMsg {
    background-color: #fffbf7;
    border-bottom: 1px solid #edd4b9;
    border-top: 1px solid #edd4b9;
    font-size: 12px;
    font-weight: 500;
    line-height: 1.3;
    padding: 12px 0;
    position: relative;
    top: -1px;
    z-index: 1004
}

.uppy-size--md .uppy-Dashboard-serviceMsg {
    font-size: 14px;
    line-height: 1.4
}

[data-uppy-theme=dark] .uppy-Dashboard-serviceMsg {
    background-color: #1f1f1f;
    border-bottom: 1px solid #333;
    border-top: 1px solid #333;
    color: #eaeaea
}

.uppy-Dashboard-serviceMsg-title {
    display: block;
    line-height: 1;
    margin-bottom: 4px;
    padding-left: 42px
}

.uppy-Dashboard-serviceMsg-text {
    padding: 0 15px
}

.uppy-Dashboard-serviceMsg-actionBtn {
    color: #1269cf;
    font-size: inherit;
    font-weight: inherit;
    vertical-align: initial
}

[data-uppy-theme=dark] .uppy-Dashboard-browse,[data-uppy-theme=dark] .uppy-Dashboard-serviceMsg-actionBtn {
    color: #02baf2e6
}

.uppy-Dashboard-serviceMsg-icon {
    left: 15px;
    position: absolute;
    top: 10px
}

.uppy-Dashboard-AddFiles {
    align-items: center;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    position: relative;
    text-align: center
}

[data-uppy-drag-drop-supported=true] .uppy-Dashboard-AddFiles {
    border: 1px dashed #dfdfdf;
    border-radius: 3px;
    height: calc(100% - 14px);
    margin: 7px
}

.uppy-Dashboard-AddFilesPanel .uppy-Dashboard-AddFiles {
    border: none;
    height: calc(100% - 54px)
}

.uppy-Dashboard--modal .uppy-Dashboard-AddFiles {
    border-color: #cfcfcf
}

[data-uppy-theme=dark] .uppy-Dashboard-AddFiles {
    border-color: #757575
}

.uppy-Dashboard-AddFiles-info {
    display: none;
    margin-top: auto;
    padding-bottom: 15px;
    padding-top: 15px
}

.tocCollapsibleContent_vkbj a,.uppy-size--height-md .uppy-Dashboard-AddFiles-info {
    display: block
}

.uppy-size--md .uppy-Dashboard-AddFiles-info {
    bottom: 25px;
    left: 0;
    padding-bottom: 0;
    padding-top: 30px;
    position: absolute;
    right: 0
}

.docItemContainer_Djhp article>:first-child,.docItemContainer_Djhp header+*,[data-uppy-num-acquirers="0"] .uppy-Dashboard-AddFiles-info {
    margin-top: 0
}

.uppy-Dashboard-browse {
    color: #1269cf;
    cursor: pointer
}

.uppy-Dashboard-browse:focus,.uppy-DashboardTab-btn:focus,.uppy-ImageCropper-range:focus {
    outline: 0
}

.uppy-Dashboard-browse::-moz-focus-inner {
    border: 0
}

.uppy-Dashboard-browse:focus,.uppy-Dashboard-browse:hover {
    border-bottom: 1px solid #1269cf
}

[data-uppy-theme=dark] .uppy-Dashboard-browse:focus,[data-uppy-theme=dark] .uppy-Dashboard-browse:hover {
    border-bottom: 1px solid #02baf2
}

.uppy-Dashboard-browseBtn {
    display: block;
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 5px;
    margin-top: 8px;
    width: 100%
}

.uppy-size--md .uppy-Dashboard-browseBtn {
    font-size: 15px;
    margin: 15px auto;
    padding: 13px 44px;
    width: auto
}

.uppy-Dashboard-AddFiles-list {
    display: flex;
    flex: 1;
    flex-direction: column;
    margin-top: 2px;
    overflow-y: auto;
    padding: 2px 0;
    width: 100%;
    -webkit-overflow-scrolling: touch
}

.uppy-size--md .uppy-Dashboard-AddFiles-list {
    flex: none;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    margin-top: 15px;
    max-width: 600px;
    overflow-y: visible;
    padding-top: 0
}

.uppy-DashboardTab {
    border-bottom: 1px solid #eaeaea;
    text-align: center;
    width: 100%
}

[data-uppy-theme=dark] .uppy-DashboardTab {
    border-bottom: 1px solid #333
}

.uppy-size--md .uppy-DashboardTab {
    border-bottom: none;
    display: inline-block;
    margin-bottom: 10px;
    width: auto
}

.uppy-DashboardTab-btn {
    align-items: center;
    appearance: none;
    background-color: initial;
    color: #525252;
    cursor: pointer;
    flex-direction: row;
    height: 100%;
    justify-content: left;
    padding: 12px 15px;
    width: 100%
}

[dir=ltr] .uppy-size--md .uppy-DashboardTab-btn {
    margin-right: 1px
}

[dir=rtl] .uppy-size--md .uppy-DashboardTab-btn {
    margin-left: 1px
}

.uppy-size--md .uppy-DashboardTab-btn {
    border-radius: 5px;
    flex-direction: column;
    padding: 10px 3px;
    width: 86px
}

[data-uppy-theme=dark] .uppy-Audio-title,[data-uppy-theme=dark] .uppy-Dashboard-AddFiles-title,[data-uppy-theme=dark] .uppy-DashboardContent-title,[data-uppy-theme=dark] .uppy-DashboardTab-btn,[data-uppy-theme=dark] .uppy-DashboardTab-iconBox,[data-uppy-theme=dark] .uppy-DashboardTab-iconDropbox,[data-uppy-theme=dark] .uppy-DashboardTab-iconScreenRec,[data-uppy-theme=dark] .uppy-DashboardTab-iconUnsplash,[data-uppy-theme=dark] .uppy-Webcam-title {
    color: #eaeaea
}

.uppy-DashboardTab-btn::-moz-focus-inner {
    border: 0
}

.uppy-DashboardTab-btn:hover {
    background-color: #e9ecef
}

[data-uppy-theme=dark] .uppy-DashboardContent-addMore:focus,[data-uppy-theme=dark] .uppy-DashboardContent-back:focus,[data-uppy-theme=dark] .uppy-DashboardContent-save:focus,[data-uppy-theme=dark] .uppy-DashboardTab-btn:hover {
    background-color: #333
}

.uppy-DashboardTab-btn:active,.uppy-DashboardTab-btn:focus {
    background-color: #dfe6f1
}

[data-uppy-theme=dark] .uppy-DashboardTab-btn:active,[data-uppy-theme=dark] .uppy-DashboardTab-btn:focus {
    background-color: #525252
}

.uppy-DashboardTab-btn svg {
    display: inline-block;
    max-height: 100%;
    max-width: 100%;
    overflow: hidden;
    transition: transform .15s ease-in-out;
    vertical-align: text-top
}

[dir=ltr] .uppy-DashboardTab-inner {
    margin-right: 10px
}

[dir=rtl] .uppy-DashboardTab-inner {
    margin-left: 10px
}

.uppy-DashboardTab-inner {
    align-items: center;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 1px 1px 0 #0000001a,0 1px 2px 0 #0000001a,0 2px 3px 0 #00000005;
    display: flex;
    height: 32px;
    justify-content: center;
    width: 32px
}

[dir=ltr] .uppy-size--md .uppy-DashboardTab-inner {
    margin-right: 0
}

[dir=rtl] .uppy-size--md .uppy-DashboardTab-inner {
    margin-left: 0
}

[data-uppy-theme=dark] .uppy-DashboardTab-inner {
    background-color: #323232;
    box-shadow: 0 1px 1px 0 #0003,0 1px 2px 0 #0003,0 2px 3px 0 #00000014
}

.uppy-DashboardTab-name {
    font-size: 14px;
    font-weight: 400
}

.uppy-size--md .uppy-DashboardTab-name {
    font-size: 12px;
    line-height: 15px;
    margin-bottom: 0;
    margin-top: 8px
}

.uppy-DashboardTab-iconMyDevice {
    color: #1269cf
}

[data-uppy-theme=dark] .uppy-DashboardContent-addMore,[data-uppy-theme=dark] .uppy-DashboardContent-back,[data-uppy-theme=dark] .uppy-DashboardContent-save,[data-uppy-theme=dark] .uppy-DashboardTab-iconMyDevice {
    color: #02baf2
}

.uppy-DashboardTab-iconBox {
    color: #0061d5
}

.uppy-DashboardTab-iconDropbox {
    color: #0061fe
}

.uppy-DashboardTab-iconUnsplash {
    color: #111
}

.uppy-DashboardTab-iconScreenRec {
    color: #2c3e50
}

.uppy-DashboardTab-iconAudio {
    color: #8030a3
}

[data-uppy-theme=dark] .uppy-DashboardTab-iconAudio {
    color: #bf6ee3
}

.uppy-Dashboard-input {
    height: .1px;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    width: .1px;
    z-index: -1
}

.uppy-DashboardContent-bar {
    align-items: center;
    background-color: #fafafa;
    border-bottom: 1px solid #eaeaea;
    display: flex;
    flex-shrink: 0;
    height: 40px;
    justify-content: space-between;
    padding: 0 10px;
    position: relative;
    width: 100%;
    z-index: 1004
}

.uppy-size--md .uppy-DashboardContent-bar {
    /*height: 50px;*/
    padding: 0 15px
}

[data-uppy-theme=dark] .uppy-DashboardContent-bar {
    background-color: #1f1f1f;
    border-bottom: 1px solid #333
}

.uppy-DashboardContent-title {
    font-size: 12px;
    font-weight: 500;
    left: 0;
    line-height: 40px;
    margin: auto;
    max-width: 170px;
    overflow-x: hidden;
    position: absolute;
    right: 0;
    text-align: center;
    text-overflow: ellipsis;
    top: 0;
    white-space: nowrap;
    width: 100%
}

.uppy-DashboardContent-addMore,.uppy-DashboardContent-back,.uppy-DashboardContent-save {
    background: none;
    color: #1269cf;
    font-family: inherit;
    line-height: 1;
    cursor: pointer;
    -webkit-appearance: none
}

.uppy-size--md .uppy-DashboardContent-title {
    font-size: 14px;
    /*line-height: 50px;*/
    max-width: 300px
}

[dir=ltr] .uppy-DashboardContent-back,[dir=ltr] .uppy-DashboardContent-save {
    margin-left: -6px
}

[dir=rtl] .uppy-DashboardContent-back,[dir=rtl] .uppy-DashboardContent-save {
    margin-right: -6px
}

.uppy-DashboardContent-back,.uppy-DashboardContent-save {
    border: 0;
    border-radius: 3px;
    font-size: 12px;
    font-weight: 400;
    margin: 0;
    padding: 7px 6px
}

.uppy-DashboardContent-addMore:focus,.uppy-DashboardContent-back:focus,.uppy-DashboardContent-save:focus {
    outline: 0;
    background-color: #dfe6f1
}

.uppy-DashboardContent-back::-moz-focus-inner,.uppy-DashboardContent-save::-moz-focus-inner {
    border: 0
}

.uppy-DashboardContent-addMore:hover,.uppy-DashboardContent-back:hover,.uppy-DashboardContent-save:hover {
    color: #0e51a0
}

.uppy-size--md .uppy-DashboardContent-back,.uppy-size--md .uppy-DashboardContent-save {
    font-size: 14px
}

[dir=ltr] .uppy-DashboardContent-addMore {
    margin-right: -5px
}

[dir=rtl] .uppy-DashboardContent-addMore {
    margin-left: -5px
}

.uppy-DashboardContent-addMore {
    border: 0;
    border-radius: 3px;
    font-size: inherit;
    font-weight: 500;
    height: 29px;
    margin: 0;
    padding: 7px 8px;
    width: 29px
}

.uppy-DashboardContent-addMore::-moz-focus-inner {
    border: 0
}

[dir=ltr] .uppy-size--md .uppy-DashboardContent-addMore {
    margin-right: -8px
}

[dir=rtl] .uppy-size--md .uppy-DashboardContent-addMore {
    margin-left: -8px
}

.uppy-size--md .uppy-DashboardContent-addMore {
    font-size: 14px;
    height: auto;
    width: auto
}

.uppy-DashboardContent-addMore svg {
    vertical-align: initial
}

.uppy-size--md .uppy-DashboardContent-addMore svg {
    height: 11px;
    width: 11px
}

.uppy-DashboardContent-addMoreCaption {
    display: none
}

.uppy-size--md .uppy-DashboardContent-addMoreCaption {
    display: inline
}

.uppy-DashboardContent-panel {
    background-color: #f5f5f5;
    flex: 1
}

.uppy-Dashboard-AddFilesPanel,.uppy-DashboardContent-panel {
    border-radius: 5px;
    bottom: 0;
    display: flex;
    flex-direction: column;
    left: 0;
    overflow: hidden;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 1005
}

.uppy-Dashboard-AddFilesPanel {
    background: #fafafa;
    background: linear-gradient(0deg,#fafafa 35%,#fafafad9);
    box-shadow: 0 0 10px 5px #00000026
}

[data-uppy-theme=dark] .uppy-Dashboard-AddFilesPanel {
    background-color: #333;
    background-image: linear-gradient(0deg,#1f1f1f 35%,#1f1f1fd9)
}

.uppy-Dashboard--isAddFilesPanelVisible .uppy-Dashboard-files {
    filter: blur(2px)
}

.uppy-Dashboard-progress {
    bottom: 0;
    height: 12%;
    left: 0;
    position: absolute;
    width: 100%
}

.uppy-Dashboard-progressBarContainer.is-active {
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 1004
}

.uppy-Dashboard-filesContainer {
    flex: 1;
    margin: 0;
    overflow-y: hidden;
    position: relative
}

.uppy-Dashboard-filesContainer:after {
    clear: both;
    content: "";
    display: table
}

.uppy-Dashboard-files {
    flex: 1;
    margin: 0;
    overflow-y: auto;
    padding: 0 0 10px;
    -webkit-overflow-scrolling: touch
}

.uppy-size--md .uppy-Dashboard-files {
    padding-top: 10px
}

.uppy-Dashboard--singleFile .uppy-Dashboard-filesInner {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center
}

.uppy-Dashboard-dropFilesHereHint {
    align-items: center;
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='48' height='48'%3E%3Cpath fill='%231269CF' d='M24 1v1C11.85 2 2 11.85 2 24s9.85 22 22 22 22-9.85 22-22S36.15 2 24 2zm0 0V0c13.254 0 24 10.746 24 24S37.254 48 24 48 0 37.254 0 24 10.746 0 24 0zm7.707 19.293a.999.999 0 1 1-1.414 1.414L25 16.414V34a1 1 0 1 1-2 0V16.414l-5.293 5.293a.999.999 0 1 1-1.414-1.414l7-7a1 1 0 0 1 1.414 0z'/%3E%3C/svg%3E");
    background-position: 50% 50%;
    background-repeat: no-repeat;
    border: 1px dashed #1269cf;
    border-radius: 3px;
    bottom: 7px;
    color: #757575;
    display: flex;
    font-size: 16px;
    justify-content: center;
    left: 7px;
    padding-top: 90px;
    position: absolute;
    right: 7px;
    text-align: center;
    top: 7px;
    visibility: hidden;
    z-index: 2000
}

[data-uppy-theme=dark] .uppy-Dashboard-dropFilesHereHint {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='48' height='48'%3E%3Cpath fill='%2302BAF2' d='M24 1v1C11.85 2 2 11.85 2 24s9.85 22 22 22 22-9.85 22-22S36.15 2 24 2zm0 0V0c13.254 0 24 10.746 24 24S37.254 48 24 48 0 37.254 0 24 10.746 0 24 0zm7.707 19.293a.999.999 0 1 1-1.414 1.414L25 16.414V34a1 1 0 1 1-2 0V16.414l-5.293 5.293a.999.999 0 1 1-1.414-1.414l7-7a1 1 0 0 1 1.414 0z'/%3E%3C/svg%3E");
    border-color: #02baf2;
    color: #bbb
}

.uppy-Dashboard.uppy-Dashboard--isDraggingOver .uppy-Dashboard-dropFilesHereHint {
    pointer-events: none;
    visibility: visible
}

.uppy-Dashboard.uppy-Dashboard--isDraggingOver .uppy-Dashboard-files,.uppy-Dashboard.uppy-Dashboard--isDraggingOver .uppy-Dashboard-progressindicators,.uppy-Dashboard.uppy-Dashboard--isDraggingOver .uppy-Dashboard-serviceMsg,.uppy-Dashboard.uppy-Dashboard--isDraggingOver .uppy-DashboardContent-bar {
    opacity: .15
}

.uppy-Dashboard.uppy-Dashboard--isDraggingOver .uppy-Dashboard-AddFiles {
    opacity: .03
}

.uppy-Dashboard-AddFiles-title {
    color: #000;
    font-size: 17px;
    font-weight: 500;
    line-height: 1.35;
    margin-bottom: 5px;
    margin-top: 15px;
    padding: 0 15px;
    text-align: inline-start;
    width: 100%
}

.uppy-size--md .uppy-Dashboard-AddFiles-title {
    font-size: 16px;
    font-weight: 400;
    /*margin-top: 5px;*/
    max-width: 480px;
    padding: 0 35px;
    text-align: center
}

[data-uppy-num-acquirers="0"] .uppy-Dashboard-AddFiles-title {
    text-align: center
}

.uppy-Dashboard-AddFiles-title button {
    font-weight: 500
}

.uppy-size--md .uppy-Dashboard-AddFiles-title button {
    font-weight: 400
}

.uppy-Dashboard-note {
    color: #757575;
    font-size: 14px;
    line-height: 1.25;
    margin: auto;
    max-width: 350px;
    padding: 0 15px;
    text-align: center
}

.uppy-size--md .uppy-Dashboard-note {
    line-height: 1.35;
    max-width: 600px
}

[data-uppy-theme=dark] .uppy-Dashboard-note {
    color: #cfcfcf
}

a.uppy-Dashboard-poweredBy {
    color: #939393;
    display: inline-block;
    font-size: 11px;
    margin-top: 8px;
    text-align: center;
    text-decoration: none
}

.uppy-Dashboard-poweredByIcon {
    margin-left: 1px;
    margin-right: 1px;
    opacity: .9;
    position: relative;
    top: 1px;
    vertical-align: text-top;
    fill: none;
    stroke: #939393
}

.uppy-Dashboard-Item-previewIcon {
    height: 25px;
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-50%,-50%);
    width: 25px;
    z-index: 100
}

.uppy-size--md .uppy-Dashboard-Item-previewIcon {
    height: 38px;
    width: 38px
}

.uppy-Dashboard-Item-previewIcon svg {
    height: 100%;
    width: 100%
}

.uppy-Dashboard--singleFile .uppy-Dashboard-Item-previewIcon {
    height: 100%;
    max-height: 60%;
    max-width: 60%;
    width: 100%
}

.uppy-Dashboard-Item-previewIconWrap {
    height: 76px;
    max-height: 75%;
    position: relative
}

.uppy-Dashboard--singleFile .uppy-Dashboard-Item-previewIconWrap {
    height: 100%;
    width: 100%
}

.uppy-Dashboard-Item-previewIconBg {
    filter: drop-shadow(rgba(0,0,0,.1) 0 1px 1px);
    height: 100%;
    width: 100%
}

.uppy-Dashboard-upload {
    height: 50px;
    position: relative;
    width: 50px
}

.uppy-size--md .uppy-Dashboard-upload {
    height: 60px;
    width: 60px
}

.uppy-Dashboard-upload .uppy-c-icon {
    position: relative;
    top: 1px;
    width: 50%
}

[dir=ltr] .uppy-Dashboard-uploadCount {
    right: -12px
}

[dir=rtl] .uppy-Dashboard-uploadCount {
    left: -12px
}

.uppy-Dashboard-uploadCount {
    background-color: #1bb240;
    border-radius: 50%;
    color: #fff;
    font-size: 8px;
    height: 16px;
    line-height: 16px;
    position: absolute;
    top: -12px;
    width: 16px
}

.uppy-size--md .uppy-Dashboard-uploadCount {
    font-size: 9px;
    height: 18px;
    line-height: 18px;
    width: 18px
}

.uppy-size--lg .uppy-Audio-audioSource-select,.uppy-size--lg .uppy-Webcam-videoSource-select {
    font-size: 14px;
    margin-bottom: 0
}

.blogPostFooterDetailsFull_Wr5y,.uppy-Audio-container {
    flex-direction: column
}

.uppy-Audio-audioContainer,.uppy-Audio-container {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    width: 100%
}

.uppy-Audio-audioContainer {
    background-color: #cfcfcf;
    position: relative
}

.uppy-Audio-player {
    border-radius: 12px;
    width: 85%
}

.uppy-Audio-canvas {
    bottom: 0;
    height: 100%;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: 100%
}

.uppy-Audio-footer {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 20px;
    width: 100%
}

.uppy-size--lg .uppy-Audio-audioSourceContainer {
    margin: 0;
    width: 33%
}

.uppy-Audio-audioSource-select {
    background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23757575%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E");
    background-position: right .4em top 50%,0 0;
    background-repeat: no-repeat;
    background-size: .65em auto,100%;
    border: 1px solid #757575;
    display: block;
    font-size: 16px;
    line-height: 1.2;
    margin: auto auto 10px;
    max-width: 90%;
    padding: .4em 1em .3em .4em;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%
}

.uppy-Audio-audioSource-select::-ms-expand {
    display: none
}

.uppy-Audio-buttonContainer {
    flex: 1;
    margin-left: 25%;
    text-align: center;
    width: 50%
}

.uppy-size--lg .uppy-Audio-buttonContainer,.uppy-size--lg .uppy-Webcam-buttonContainer {
    margin-left: 0;
    width: 34%
}

.uppy-Audio-recordingLength,.uppy-Webcam-recordingLength {
    color: #757575;
    flex-grow: 0;
    font-family: SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;
    text-align: right;
    width: 25%
}

.uppy-size--lg .uppy-Audio-recordingLength,.uppy-size--lg .uppy-Webcam-recordingLength {
    width: 33%
}

.uppy-Audio-button {
    background-color: #e32437;
    border-radius: 50%;
    color: #fff;
    cursor: pointer;
    height: 45px;
    transition: .3s;
    width: 45px
}

.uppy-Audio-button::-moz-focus-inner {
    border: 0
}

.uppy-Audio-button:hover,.uppy-ScreenCapture-button:hover,.uppy-Webcam-button:hover {
    background-color: #d31b2d
}

.uppy-Audio-button--submit:hover,.uppy-ScreenCapture-button--submit:hover {
    background-color: #105db8
}

[data-uppy-theme=dark] .uppy-Audio-button::-moz-focus-inner {
    border: 0
}

.uppy-Audio-button--submit {
    background-color: #1269cf;
    margin: 0 12px
}

.uppy-Audio-button svg {
    display: inline-block;
    height: 26px;
    max-height: 100%;
    max-width: 100%;
    overflow: hidden;
    vertical-align: text-top;
    width: 26px;
    fill: currentColor
}

.uppy-size--md .uppy-Audio-button,.uppy-size--md .uppy-ScreenCapture-button {
    height: 60px;
    width: 60px
}

.uppy-Audio-permissons,.uppy-Webcam-permissons {
    align-items: center;
    display: flex;
    flex: 1;
    flex-flow: column wrap;
    height: 100%;
    justify-content: center;
    padding: 15px
}

.uppy-Audio-permissons p,.uppy-Webcam-permissons p {
    color: #939393;
    line-height: 1.45;
    margin: 0;
    max-width: 450px;
    text-align: center
}

.uppy-Audio-permissonsIcon svg,.uppy-Webcam-permissonsIcon svg {
    color: #bbb;
    height: 75px;
    margin-bottom: 30px;
    width: 100px
}

.uppy-Audio-title,.uppy-ScreenCapture-title,.uppy-Webcam-title {
    color: #333;
    font-size: 22px;
    font-weight: 400;
    line-height: 1.35;
    margin: 0 0 5px;
    max-width: 500px;
    padding: 0 15px;
    text-align: center
}

.uppy-ScreenCapture-container,.uppy-Webcam-container {
    align-items: center;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    width: 100%
}

.uppy-ScreenCapture-videoContainer,.uppy-Webcam-videoContainer {
    background-color: #333;
    flex: 1;
    flex-grow: 1;
    overflow: hidden;
    position: relative;
    text-align: center;
    width: 100%
}

.uppy-ScreenCapture-video {
    bottom: 0;
    left: 0;
    margin: auto;
    max-height: 100%;
    max-width: 100%;
    outline: 0;
    position: absolute;
    right: 0;
    top: 0
}

.uppy-ScreenCapture-buttonContainer {
    align-items: center;
    background-color: #fff;
    border-top: 1px solid #eaeaea;
    display: flex;
    height: 75px;
    justify-content: center;
    padding: 0 20px;
    width: 100%
}

.uppy-ScreenCapture-button {
    border-radius: 50%;
    color: #fff;
    cursor: pointer;
    height: 45px;
    transition: .3s;
    width: 45px
}

.uppy-ScreenCapture-button::-moz-focus-inner {
    border: 0
}

[data-uppy-theme=dark] .uppy-ScreenCapture-button::-moz-focus-inner {
    border: 0
}

.uppy-ScreenCapture-button svg {
    display: inline-block;
    height: 30px;
    max-height: 100%;
    max-width: 100%;
    overflow: hidden;
    vertical-align: text-top;
    width: 30px;
    fill: currentColor
}

.uppy-ScreenCapture-button--submit {
    background-color: #1269cf;
    margin-left: 12px
}

.uppy-ScreenCapture-button--submit:disabled {
    background-color: #939393;
    cursor: default
}

.uppy-ScreenCapture-button--submit:disabled:hover {
    background-color: #eaeaea
}

.uppy-ScreenCapture-icon--stream {
    margin: 1rem;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 1
}

.uppy-ScreenCapture-icon--stream svg {
    fill: #939393
}

.uppy-ScreenCapture-icon--streamActive svg {
    animation: 1s cubic-bezier(.47,0,.75,.72) infinite j
}

@keyframes j {
    0%,to {
        fill: #1269cf
    }

    50% {
        fill: #939393
    }
}

.uppy-ScreenCapture-button--video {
    background: #e32437;
    color: #fff
}

.uppy-ScreenCapture-button--video:hover {
    background-color: #bc1828
}

.uppy-ImageCropper-range {
    -webkit-appearance: none;
    background: #0000;
    margin: 8px 0;
    width: 100%
}

.uppy-ImageCropper-range::-moz-focus-outer {
    border: 0
}

.uppy-ImageCropper-range:focus::-webkit-slider-runnable-track {
    background: #fff3
}

.uppy-ImageCropper-range:focus::-ms-fill-lower,.uppy-ImageCropper-range:focus::-ms-fill-upper {
    background: #fff3
}

.uppy-ImageCropper-range::-webkit-slider-runnable-track {
    background: #fff3;
    border: 0 solid #0000;
    border-radius: 5px;
    box-shadow: 0 0 0 #0000,0 0 0 #0d0d0d00;
    cursor: default;
    height: 4px;
    transition: .2s;
    width: 100%
}

.uppy-ImageCropper-range::-webkit-slider-thumb {
    -webkit-appearance: none;
    background: #fff;
    border: 0 solid #0000;
    border-radius: 9px;
    box-shadow: 0 0 4px #0003,0 0 0 #0d0d0d33;
    box-sizing: border-box;
    cursor: default;
    height: 16px;
    margin-top: -6px;
    width: 16px
}

.uppy-ImageCropper-range::-moz-range-track {
    background: #fff3;
    border: 0 solid #0000;
    border-radius: 5px;
    box-shadow: 0 0 0 #0000,0 0 0 #0d0d0d00;
    cursor: default;
    transition: .2s;
    width: 100%
}

.uppy-ImageCropper-range::-moz-range-thumb {
    background: #fff;
    border: 0 solid #0000;
    border-radius: 9px;
    box-shadow: 0 0 4px #0003,0 0 0 #0d0d0d33;
    box-sizing: border-box;
    cursor: default;
    height: 16px;
    width: 16px
}

.uppy-ImageCropper-range::-ms-track {
    background: #0000;
    border-color: #0000;
    border-width: 8px 0;
    color: #0000;
    cursor: default;
    height: 4px;
    transition: .2s;
    width: 100%
}

.uppy-ImageCropper-range::-ms-fill-lower {
    background: #f2f2f233;
    border: 0 solid #0000;
    border-radius: 10px;
    box-shadow: 0 0 0 #0000,0 0 0 #0d0d0d00
}

.uppy-ImageCropper-range::-ms-fill-upper {
    background: #fff3;
    border: 0 solid #0000;
    border-radius: 10px;
    box-shadow: 0 0 0 #0000,0 0 0 #0d0d0d00
}

.uppy-ImageCropper-range::-ms-thumb {
    background: #fff;
    border: 0 solid #0000;
    border-radius: 9px;
    box-shadow: 0 0 4px #0003,0 0 0 #0d0d0d33;
    box-sizing: border-box;
    cursor: default;
    height: 16px;
    margin-top: 1px;
    width: 16px
}

.uppy-ImageCropper-range:disabled::-moz-range-thumb,.uppy-ImageCropper-range:disabled::-ms-fill-lower,.uppy-ImageCropper-range:disabled::-ms-fill-upper,.uppy-ImageCropper-range:disabled::-ms-thumb,.uppy-ImageCropper-range:disabled::-webkit-slider-runnable-track,.uppy-ImageCropper-range:disabled::-webkit-slider-thumb {
    cursor: not-allowed
}

.cropper-container {
    direction: ltr;
    font-size: 0;
    line-height: 0;
    position: relative;
    touch-action: none;
    -webkit-user-select: none;
    user-select: none
}

.cropper-container img {
    display: block;
    height: 100%;
    image-orientation: 0deg;
    max-height: none!important;
    max-width: none!important;
    min-height: 0!important;
    min-width: 0!important;
    width: 100%
}

.cropper-canvas,.cropper-crop-box,.cropper-drag-box,.cropper-modal,.cropper-wrap-box {
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0
}

.cropper-canvas,.cropper-wrap-box {
    overflow: hidden
}

.cropper-drag-box {
    background-color: #fff;
    opacity: 0
}

.cropper-modal {
    background-color: #000;
    opacity: .5
}

.cropper-view-box {
    display: block;
    height: 100%;
    outline: #39f solid 1px;
    outline-color: #3399ffbf;
    overflow: hidden;
    width: 100%
}

.cropper-dashed {
    border: 0 dashed #eee;
    display: block;
    opacity: .5;
    position: absolute
}

.cropper-dashed.dashed-h {
    border-bottom-width: 1px;
    border-top-width: 1px;
    height: 33.3333333333%;
    left: 0;
    top: 33.3333333333%;
    width: 100%
}

.cropper-dashed.dashed-v {
    border-left-width: 1px;
    border-right-width: 1px;
    height: 100%;
    left: 33.3333333333%;
    top: 0;
    width: 33.3333333333%
}

.cropper-center {
    display: block;
    height: 0;
    left: 50%;
    opacity: .75;
    position: absolute;
    top: 50%;
    width: 0
}

.cropper-center:after,.cropper-center:before {
    background-color: #eee;
    content: " ";
    display: block;
    position: absolute
}

.cropper-center:before {
    height: 1px;
    left: -3px;
    top: 0;
    width: 7px
}

.cropper-center:after {
    height: 7px;
    left: 0;
    top: -3px;
    width: 1px
}

.cropper-face,.cropper-line,.cropper-point {
    display: block;
    height: 100%;
    opacity: .1;
    position: absolute;
    width: 100%
}

.cropper-face {
    background-color: #fff;
    left: 0;
    top: 0
}

.cropper-line,.cropper-point {
    background-color: #39f
}

.cropper-line.line-e {
    cursor: ew-resize;
    right: -3px;
    top: 0;
    width: 5px
}

.cropper-line.line-n {
    cursor: ns-resize;
    height: 5px;
    left: 0;
    top: -3px
}

.cropper-line.line-w {
    cursor: ew-resize;
    left: -3px;
    top: 0;
    width: 5px
}

.cropper-line.line-s {
    bottom: -3px;
    cursor: ns-resize;
    height: 5px;
    left: 0
}

.cropper-point {
    height: 5px;
    opacity: .75;
    width: 5px
}

.cropper-point.point-e {
    cursor: ew-resize;
    margin-top: -3px;
    right: -3px;
    top: 50%
}

.cropper-point.point-n {
    cursor: ns-resize;
    left: 50%;
    margin-left: -3px;
    top: -3px
}

.cropper-point.point-w {
    cursor: ew-resize;
    left: -3px;
    margin-top: -3px;
    top: 50%
}

.cropper-point.point-s {
    bottom: -3px;
    cursor: s-resize;
    left: 50%;
    margin-left: -3px
}

.cropper-point.point-ne {
    cursor: nesw-resize;
    right: -3px;
    top: -3px
}

.cropper-point.point-nw {
    cursor: nwse-resize;
    left: -3px;
    top: -3px
}

.cropper-point.point-sw {
    bottom: -3px;
    cursor: nesw-resize;
    left: -3px
}

.cropper-point.point-se {
    bottom: -3px;
    cursor: nwse-resize;
    height: 20px;
    opacity: 1;
    right: -3px;
    width: 20px
}

.cropper-point.point-se:before {
    background-color: #39f;
    bottom: -50%;
    content: " ";
    display: block;
    height: 200%;
    opacity: 0;
    position: absolute;
    right: -50%;
    width: 200%
}

.cropper-bg {
    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAA3NCSVQICAjb4U/gAAAABlBMVEXMzMz////TjRV2AAAACXBIWXMAAArrAAAK6wGCiw1aAAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M26LyyjAAAABFJREFUCJlj+M/AgBVhF/0PAH6/D/HkDxOGAAAAAElFTkSuQmCC")
}

.cropper-hide {
    display: block;
    height: 0;
    position: absolute;
    width: 0
}

.cropper-hidden {
    display: none!important
}

.cropper-move {
    cursor: move
}

.cropper-crop {
    cursor: crosshair
}

.cropper-disabled .cropper-drag-box,.cropper-disabled .cropper-face,.cropper-disabled .cropper-line,.cropper-disabled .cropper-point,.options_J1Ai input[type=checkbox]:disabled:hover,.options_J1Ai input[type=checkbox]:disabled:hover+label {
    cursor: not-allowed
}

.uppy-ImageCropper {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%
}

.uppy-ImageCropper-image {
    display: block;
    max-height: 400px;
    max-width: 100%
}

.uppy-ImageCropper-controls {
    align-items: center;
    background-color: #0009;
    border-radius: 5px;
    bottom: 15px;
    color: #fff;
    display: flex;
    justify-content: center;
    left: 50%;
    padding-top: 38px;
    position: absolute;
    transform: translateX(-50%)
}

.uppy-ImageCropper-controls button {
    border-radius: 5px;
    height: 35px;
    width: 35px
}

.uppy-ImageCropper-controls button svg {
    padding: 3px
}

.uppy-size--md .uppy-ImageCropper-controls button {
    height: 40px;
    width: 40px
}

.uppy-size--md .uppy-ImageCropper-controls button svg {
    padding: 1px
}

.uppy-ImageCropper-controls button:hover {
    background-color: #ffffff80
}

.uppy-ImageCropper-controls button:focus {
    background-color: #ffffff80;
    outline: 0
}

.uppy-Dashboard:not(.uppy-size--md) .uppy-ImageCropper-rangeWrapper {
    height: 38px;
    left: 10px;
    position: absolute!important;
    right: 10px;
    top: 0
}

.uppy-size--md .uppy-ImageCropper-range {
    margin-left: 5px;
    margin-right: 5px;
    width: 180px
}

.uppy-ImageCropper .cropper-point {
    height: 8px;
    width: 8px
}

.uppy-ImageCropper .cropper-view-box {
    background: repeating-conic-gradient(#bdbdbd33 0 25%,#fff 0 50%) 50%/16px 16px;
    outline: #39f solid 2px
}

[data-uppy-theme=dark] .uppy-ImageCropper .cropper-view-box {
    background: repeating-conic-gradient(#2b2a2a 0 25%,#000 0 50%) 50%/16px 16px
}

.uppy-ImageCropper .cropper-modal {
    background-color: #fff;
    opacity: .9
}

[data-uppy-theme=dark] .uppy-ImageCropper .cropper-modal {
    background-color: #000;
    opacity: .7
}

.uppy-ImageCropper-range::-moz-range-track {
    height: 4px
}

.uppy-ImageCropper-range:focus::-webkit-slider-runnable-track,.uppy-ImageCropper-range:hover::-webkit-slider-runnable-track {
    background: #ffffff80
}

.uppy-ImageCropper-range:focus::-ms-fill-lower,.uppy-ImageCropper-range:focus::-ms-fill-upper,.uppy-ImageCropper-range:hover::-ms-fill-lower,.uppy-ImageCropper-range:hover::-ms-fill-upper {
    background: #ffffff80
}

.uppy-ImageCropper-range:focus::-moz-range-track,.uppy-ImageCropper-range:hover::-moz-range-track {
    background: #ffffff80
}

.uppy-Webcam-video {
    bottom: 0;
    left: 0;
    margin: auto;
    max-height: 100%;
    max-width: 100%;
    position: absolute;
    right: 0;
    top: 0
}

.uppy-Webcam-video--mirrored {
    transform: scaleX(-1)
}

.uppy-Webcam-footer {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    min-height: 75px;
    padding: 20px;
    width: 100%
}

.uppy-Webcam-videoSourceContainer {
    flex-grow: 0;
    width: 100%
}

.uppy-size--lg .uppy-Webcam-videoSourceContainer {
    margin: 0;
    width: 33%
}

.uppy-Webcam-videoSource-select {
    background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23757575%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E");
    background-position: right .4em top 50%,0 0;
    background-repeat: no-repeat;
    background-size: .65em auto,100%;
    border: 1px solid #757575;
    display: block;
    font-size: 16px;
    line-height: 1.2;
    margin: auto auto 10px;
    max-width: 90%;
    padding: .4em 1em .3em .4em;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%
}

.header_gB2a,.main_iUjq section h2,.main_iUjq section p {
    max-width: 30rem
}

.uppy-Webcam-videoSource-select::-ms-expand {
    display: none
}

.uppy-Webcam-buttonContainer {
    margin-left: 25%;
    text-align: center;
    width: 50%
}

.uppy-Webcam-button {
    background-color: #e32437;
    border-radius: 50%;
    color: #fff;
    cursor: pointer;
    height: 45px;
    transition: .3s;
    width: 45px
}

.uppy-Webcam-button::-moz-focus-inner {
    border: 0
}

[data-uppy-theme=dark] .uppy-Webcam-button::-moz-focus-inner {
    border: 0
}

.uppy-Webcam-button--submit {
    background-color: #1269cf;
    margin: 0 12px
}

.uppy-Webcam-button--submit:hover {
    background-color: #105db8
}

.uppy-Webcam-button svg {
    display: inline-block;
    height: 30px;
    max-height: 100%;
    max-width: 100%;
    overflow: hidden;
    vertical-align: text-top;
    width: 30px;
    fill: currentColor
}

.uppy-size--md .uppy-Webcam-button {
    height: 60px;
    width: 60px
}

.uppy-Webcam-button--picture {
    margin-right: 12px
}

.main_iUjq code {
    font-size: .8rem!important
}

.main_iUjq {
    margin: 1rem
}

.main_iUjq>section {
    margin: 5rem auto 0;
    max-width: 50rem
}

.button_JGCe {
    background-color: var(--bg-blue);
    border-radius: 5px;
    color: var(--blue);
    font-weight: 600;
    padding: .5rem 1rem;
    transition: filter .15s ease-in-out
}

.button_JGCe:focus,.button_JGCe:hover {
    color: var(--blue);
    filter: brightness(95%);
    text-decoration: none
}

.header_gB2a {
    margin: 7rem auto 1rem;
    padding: 0 1rem;
    text-align: center
}

.quote_cnET blockquote {
    border: none;
    font-style: italic;
    margin: 0;
    padding: 0
}

.quote_cnET figcaption a {
    color: #6b7280;
    font-size: .85rem;
    text-decoration: underline
}

.dashboard-inner_NQH3 {
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0 1px 2px #0000001a,0 2px 5px #0000000d;
    padding: 5px;
    position: relative;
    z-index: 1
}

.main_iUjq .section-dashboard_ZjRL {
    max-width: 65rem
}

.dashboard_zMnL:after {
    background: linear-gradient(90deg,#f373,#fbcfe8);
    background-position: 100% 50%;
    background-size: 200% 200%;
    content: "";
    filter: blur(60px);
    height: 100%;
    margin: 0 auto;
    position: absolute;
    right: 0;
    top: 0;
    width: 100%;
    z-index: -1
}

.dashboard_zMnL div[class*=codeBlockContainer] {
    display: none
}

.upload_uOvW {
    content: "";
    position: absolute;
    z-index: -10
}

.upload-one_B1LP {
    height: 130%;
    right: 50px;
    top: 60px;
    transform: rotate(5deg) translateY(30px);
    width: 150px
}

.upload-two_f2qY {
    display: none;
    height: 130%;
    left: 400px;
    top: 20px;
    transform: rotate(-10deg) translateY(30px);
    width: 150px
}

.upload_uOvW svg {
    transform: rotate(7deg) translateY(55px) translateX(-10px);
    width: 100%
}

.upload_uOvW div {
    background: #fff;
    background: linear-gradient(0deg,#fff0,#ff337726 80%);
    height: 100%;
    width: 110px
}

.upload-two_f2qY div {
    background: linear-gradient(0deg,#fff0,#ff33771a)
}

.companion_gSfg {
    display: flex;
    margin-bottom: -3rem;
    margin-top: 7rem;
    width: 100%
}

.companion_gSfg .provider_QNcp {
    background: linear-gradient(#f373,#fff 90%);
    border-radius: 5px 5px 0 0;
    display: flex;
    flex: 1;
    height: 150px;
    justify-content: center
}

.provider_QNcp img {
    margin: .7rem;
    max-height: 1.5rem;
    max-width: 1.5rem
}

.companion_gSfg .provider_QNcp:nth-of-type(2),.companion_gSfg .provider_QNcp:nth-of-type(6) {
    margin-top: 1.5rem
}

.companion_gSfg .provider_QNcp:nth-of-type(4) {
    margin-top: 4.5rem
}

.section-stack_dXJp {
    background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MDAiIGhlaWdodD0iNDAwIiBmaWxsPSJub25lIj48ZyBzdHJva2U9IiNGMzciIHN0cm9rZS1vcGFjaXR5PSIuNCIgY2xpcC1wYXRoPSJ1cmwoI2EpIj48cGF0aCBkPSJNNTAuNSAwdjQwME0xMDAuNSAwdjQwME0xNTAuNSAwdjQwME0yMDAuNSAwdjQwME0yNTAuNSAwdjQwME0zMDAuNSAwdjQwME0zNTAuNSAwdjQwME0wIDM0OS41aDQwME0wIDI5OS41aDQwME0wIDI0OS41aDQwME0wIDE5OS41aDQwME0wIDE0OS41aDQwME0wIDk5LjVoNDAwTTAgNDkuNWg0MDAiLz48L2c+PGRlZnM+PGNsaXBQYXRoIGlkPSJhIj48cGF0aCBmaWxsPSIjZmZmIiBkPSJNMCAwaDQwMHY0MDBIMHoiLz48L2NsaXBQYXRoPjwvZGVmcz48L3N2Zz4=);
    background-position: 50%;
    background-repeat: repeat-y;
    background-size: 100%;
    padding: 1rem 0;
    position: relative
}

.section-stack_dXJp:after {
    background: radial-gradient(circle,#fff0 0,#fff 75%);
    content: "";
    display: block;
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%
}

.section-stack_dXJp>div {
    position: inherit;
    z-index: 10
}

.frameworks_iEH8 {
    display: grid;
    grid-template-columns: repeat(4,minmax(0,1fr));
    margin: 2rem 0
}

.framework-input_OQJX {
    position: absolute;
    clip: rect(0,0,0,0)
}

.framework-input_OQJX+label svg {
    width: 2rem
}

.framework-input_OQJX+label {
    align-items: center;
    background-color: #fff;
    border: 2px solid #d3d3d3;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    font-family: var(--ifm-font-family-monospace);
    font-size: .85rem;
    font-weight: 600;
    justify-content: center;
    padding: 1rem
}

.framework-input_OQJX:not(:first-of-type)+label {
    border-left: none
}

.framework-input_OQJX+label:first-of-type {
    border-radius: 5px 0 0 5px
}

.framework-input_OQJX+label:last-of-type {
    border-radius: 0 5px 5px 0
}

.framework-input_OQJX:checked+label {
    border: 2px solid var(--blue)
}

.framework-input_OQJX:not(:first-child):checked+label {
    margin-left: -2px
}

.framework-input_OQJX:not(:checked)+label {
    color: #a9a9a9
}

.framework-input_OQJX:not(:checked)+label:hover,.options_J1Ai input[type=checkbox]:disabled+label {
    color: gray
}

.framework-input_OQJX:checked+label span,.options_J1Ai input[type=checkbox]:not(:checked,:disabled):hover+label {
    color: #000
}

.framework-input_OQJX[value=React]:checked+label {
    color: #61dafb
}

.framework-input_OQJX[value=Vue]:checked+label {
    color: #4fc08d
}

.framework-input_OQJX[value=Svelte]:checked+label {
    color: #ff3e00
}

.framework-input_OQJX[value=Angular]:checked+label {
    color: #dd0031
}

.section-much-more_zGqh ul+div {
    display: flex;
    justify-content: center;
    margin: 4rem 0
}

.section-much-more_zGqh svg {
    background-color: #f373;
    border-radius: 50%;
    color: var(--pink);
    height: 2rem;
    padding: .4rem;
    width: 2rem
}

.section-much-more_zGqh li {
    align-items: center;
    display: flex;
    gap: 1rem;
    margin: 1rem 0
}

.iconEdit_Z9Sw {
    margin-right: .3em;
    vertical-align: sub
}

.details_lb9f {
    --docusaurus-details-summary-arrow-size: 0.38rem;
    --docusaurus-details-transition: transform 200ms ease;
    --docusaurus-details-decoration-color: grey
}

.details_lb9f>summary {
    cursor: pointer;
    list-style: none;
    padding-left: 1rem;
    position: relative
}

.details_lb9f>summary::-webkit-details-marker {
    display: none
}

.details_lb9f>summary:before {
    border-color: #0000 #0000 #0000 var(--docusaurus-details-decoration-color);
    border-style: solid;
    border-width: var(--docusaurus-details-summary-arrow-size);
    content: "";
    left: 0;
    position: absolute;
    top: .45rem;
    transform: rotate(0);
    transform-origin: calc(var(--docusaurus-details-summary-arrow-size)/2) 50%;
    transition: var(--docusaurus-details-transition)
}

.collapsibleContent_i85q {
    border-top: 1px solid var(--docusaurus-details-decoration-color);
    margin-top: 1rem;
    padding-top: 1rem
}

.lastUpdated_JAkA {
    font-size: smaller;
    font-style: italic;
    margin-top: .2rem
}

.tocCollapsibleButton_TO0P {
    align-items: center;
    display: flex;
    font-size: inherit;
    justify-content: space-between;
    padding: .4rem .8rem;
    width: 100%
}

.tocCollapsibleButton_TO0P:after {
    background: var(--ifm-menu-link-sublist-icon) 50% 50%/2rem 2rem no-repeat;
    content: "";
    filter: var(--ifm-menu-link-sublist-icon-filter);
    height: 1.25rem;
    transform: rotate(180deg);
    transition: transform var(--ifm-transition-fast);
    width: 1.25rem
}

.tocCollapsibleButtonExpanded_MG3E:after,.tocCollapsibleExpanded_sAul {
    transform: none
}

.tocCollapsible_ETCw {
    background-color: var(--ifm-menu-color-background-active);
    border-radius: var(--ifm-global-radius);
    margin: 1rem 0
}

.tocCollapsibleContent_vkbj>ul {
    border-left: none;
    border-top: 1px solid var(--ifm-color-emphasis-300);
    font-size: 15px;
    padding: .2rem 0
}

.tocCollapsibleContent_vkbj ul li {
    margin: .4rem .8rem
}

.details_b_Ee {
    --docusaurus-details-decoration-color: var(--ifm-alert-border-color);
    --docusaurus-details-transition: transform var(--ifm-transition-fast) ease;
    border: 1px solid var(--ifm-alert-border-color);
    margin: 0 0 var(--ifm-spacing-vertical)
}

.containsTaskList_mC6p {
    list-style: none
}

.img_ev3q {
    height: auto
}

.admonition_xJq3 {
    margin-bottom: 1em
}

.admonitionHeading_Gvgb {
    font: var(--ifm-heading-font-weight) var(--ifm-h5-font-size)/var(--ifm-heading-line-height) var(--ifm-heading-font-family)
}

.h3_P9GU,.item_MAQH h2 {
    font-family: var(--ifm-font-family-base)
}

.admonitionHeading_Gvgb:not(:last-child) {
    margin-bottom: .3rem
}

.admonitionHeading_Gvgb code {
    text-transform: none
}

.admonitionIcon_Rf37 {
    display: inline-block;
    margin-right: .4em;
    vertical-align: middle
}

.admonitionIcon_Rf37 svg {
    display: inline-block;
    height: 1.6em;
    width: 1.6em;
    fill: var(--ifm-alert-foreground-color)
}

.footer_ZfVL {
    border: 1px solid #d3d3d3;
    border-radius: var(--ifm-pagination-nav-border-radius);
    display: grid;
    grid-template-columns: repeat(3,minmax(0,1fr));
    list-style: none;
    margin: 0 1rem;
    padding: 1rem;
    text-align: center
}

.tableOfContents_bqdL {
    max-height: calc(100vh - var(--ifm-navbar-height) - 2rem);
    overflow-y: auto;
    position: sticky;
    top: calc(var(--ifm-navbar-height) + 1rem)
}

.breadcrumbHomeIcon_YNFT {
    height: 1.1rem;
    position: relative;
    top: 1px;
    vertical-align: top;
    width: 1.1rem
}

.breadcrumbsContainer_Z_bl {
    --ifm-breadcrumb-size-multiplier: 0.8;
    margin-bottom: .8rem
}

.mdxPageWrapper_j9I6 {
    justify-content: center
}

.main_tfAN {
    margin: 4rem auto;
    max-width: 60rem;
    padding: 0 1rem
}

.h3_P9GU {
    font-size: 1rem
}

.dashboard-docs-stackblitz_VII1 {
    align-items: baseline;
    display: flex;
    gap: 1rem;
    margin-top: 2rem
}

.dashboard-docs-stackblitz_VII1 h2,.dashboard-docs-stackblitz_VII1 p {
    margin-bottom: .5rem
}

.options-and-uppy_WGZs {
    border-radius: 5px;
    box-shadow: 0 0 0 0 #fff,0 0 0 1px #1118270d,0 4px 6px -1px #0000001a,0 2px 4px -2px #0000001a;
    margin-bottom: 1rem;
    position: relative
}

.options_J1Ai {
    border-radius: 5px;
    display: grid;
    gap: 1rem;
    grid-template-columns: repeat(2,minmax(0,1fr));
    max-width: 30rem;
    min-height: 500px;
    padding: 1rem
}

.options_J1Ai input[type=checkbox] {
    accent-color: #f37;
    margin-left: 0;
    margin-right: 5px
}

.options-inner_qpwT>div {
    align-items: center;
    display: flexl;
    margin: .25rem 0
}

.options_J1Ai select {
    background: #fff;
    border: 1px solid #d3d3d3;
    border-radius: 5px;
    font-size: 1rem;
    grid-column: 1/3;
    padding: .2rem 1rem
}

.dashboard-inner_Egwd {
    position: relative;
    z-index: 1
}

.section_kw8a {
    display: grid;
    grid-gap: 1em;
    align-items: stretch
}

.item_MAQH {
    border: 1px solid var(--ifm-color-emphasis-300);
    border-radius: var(--ifm-pagination-nav-border-radius);
    padding: 1em;
    position: relative;
    transition: border-color var(--ifm-transition-fast) var(--ifm-transition-timing-default)
}

.item_MAQH h2 {
    font-size: 1rem;
    margin-bottom: .5rem
}

.item_MAQH:hover {
    border-color: var(--ifm-color-primary)
}

.item_MAQH p {
    color: var(--ifm-font-color-base);
    color: gray;
    margin: 0
}

@media screen and (min-width: 40em) {
    .section_kw8a {
        grid-template-columns:1fr 1fr
    }
}

@media screen and (min-width: 40rem) {
    .header_gB2a {
        min-height:75vh;
        padding-top: 5rem
    }

    .dashboard_zMnL div[class*=codeBlockContainer] {
        display: block
    }
}

@media (min-width: 768px) {
    .cropper-point.point-se {
        height:15px;
        width: 15px
    }
}

@media screen and (min-width: 50rem) {
    .dashboard-inner_NQH3 {
        background-color:initial;
        border-radius: 0;
        box-shadow: none;
        padding: 0
    }

    .dashboard_zMnL {
        align-items: center;
        display: grid;
        grid-template-columns: minmax(0,1.3fr) minmax(0,1fr)
    }

    .dashboard_zMnL:after {
        right: calc(50% - 150px);
        width: 300px
    }

    .upload-one_B1LP {
        height: 90%;
        right: calc(50% - 320px);
        transform: rotate(10deg) translateY(30px)
    }

    .upload-two_f2qY {
        display: block;
        left: calc(50% - 250px)
    }

    .companion_gSfg {
        margin-top: 10rem
    }

    .provider_QNcp img {
        margin-top: 2rem
    }

    .companion_gSfg .provider_QNcp {
        height: 250px
    }

    .companion_gSfg .provider_QNcp:nth-of-type(2),.companion_gSfg .provider_QNcp:nth-of-type(6) {
        margin-top: 3rem
    }

    .companion_gSfg .provider_QNcp:nth-of-type(3),.companion_gSfg .provider_QNcp:nth-of-type(5) {
        margin-top: 6rem
    }

    .companion_gSfg .provider_QNcp:nth-of-type(4) {
        margin-top: 9rem
    }

    .section-stack_dXJp {
        background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMDAiIGhlaWdodD0iMzAwIiBmaWxsPSJub25lIj48ZyBzdHJva2U9IiNGRUNERDMiIHN0cm9rZS13aWR0aD0iLjUiIGNsaXAtcGF0aD0idXJsKCNhKSI+PHBhdGggZD0iTTI1LjI1LTF2MzAwTS4yNS0xdjMwME0wIDI3My43NWgzMDBNLTEgMjk5aDMwME01MC4yNS0xdjMwME0wIDI0OC43NWgzMDBNNzUuMjUtMXYzMDBNMCAyMjMuNzVoMzAwTTEwMC4yNS0xdjMwME0wIDE5OC43NWgzMDBNMTI1LjI1LTF2MzAwTTAgMTczLjc1aDMwME0xNTAuMjUtMXYzMDBNMCAxNDguNzVoMzAwTTE3NS4yNS0xdjMwME0wIDEyMy43NWgzMDBNMjAwLjI1LTF2MzAwTTAgOTguNzVoMzAwTTIyNS4yNS0xdjMwME0wIDczLjc1aDMwME0yNTAuMjUtMXYzMDBNMCA0OC43NWgzMDBNMjc1LjI1IDB2MzAwTTI5OS43NSAzMDFWLTFNMCAyMy43NWgzMDBNMCAwaDMwMCIvPjwvZz48ZGVmcz48Y2xpcFBhdGggaWQ9ImEiPjxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0wIDBoMzAwdjMwMEgweiIvPjwvY2xpcFBhdGg+PC9kZWZzPjwvc3ZnPg==);
        padding: 8rem 0
    }

    .frameworks-wrapper_v6zN {
        align-items: start;
        display: grid;
        grid-template-columns: repeat(12,minmax(0,1fr))
    }

    .frameworks-wrapper_v6zN div:first-of-type {
        grid-column: 1/6
    }

    .frameworks-wrapper_v6zN div:nth-of-type(2) {
        box-shadow: 0 1px 1px #0000001f,0 2px 2px #0000001f,0 4px 4px #0000001f,0 8px 8px #0000001f,0 16px 16px #0000001f;
        grid-column: 7/13
    }

    .section-much-more_zGqh ul {
        align-items: start;
        display: grid;
        gap: 0 1rem;
        grid-template-columns: repeat(2,minmax(0,1fr))
    }
}
    .uppy-Dashboard-inner {
        height: 100% !important;
        width: 100% !important;
    }
    .uppy-Root {
        height: 100% !important;
        width: 100% !important;
    }
    .uppy-Dashboard {
        height: 100% !important;
        width: 100% !important;
    }
    #uppyDashboard {
        height: 100% !important;
        width: 100% !important;
    }
    .uppy-Dashboard--modal .uppy-Dashboard-inner{
        max-width: 90vw !important;
        max-height: 90vh !important;
        z-index: 1000000 !important;
    }
    .uppy-Dashboard-inner {
        height: 100% !important;
        width: 100% !important;
        max-width: 100% !important;
        max-height: 100% !important;
    }
@media only screen and (min-width: 820px) {
    .uppy-Dashboard--modal.uppy-Dashboard--animateOpenClose>.uppy-Dashboard-inner {
        animation:.3s cubic-bezier(0,0,.2,1) f
    }

    .uppy-Dashboard--modal.uppy-Dashboard--animateOpenClose.uppy-Dashboard--isClosing>.uppy-Dashboard-inner {
        animation: .3s cubic-bezier(0,0,.2,1) h
    }
    .uppy-Dashboard--modal .uppy-Dashboard-inner{
        max-width: 90vw !important;
        max-height: 90vh !important;
        z-index: 1000000 !important;
    }
    .uppy-Dashboard-inner {
        height: 100% !important;
        width: 100% !important;
        max-width: 100% !important;
        max-height: 100% !important;
    }

    .uppy-Dashboard--modal .uppy-Dashboard-inner {
        box-shadow: 0 5px 15px 4px #00000026;
        left: 50%;
        right: auto;
        top: 50%;
        transform: translate(-50%,-50%)
    }

    [dir=ltr] .uppy-Dashboard-close {
        right: -35px
    }

    [dir=rtl] .uppy-Dashboard-close {
        left: -35px
    }

    .uppy-Dashboard-close {
        font-size: 35px;
        top: -10px
    }
}

@media screen and (min-width: 60rem) {
    .main_tfAN {
        padding:0
    }

    .options_J1Ai {
        align-items: center;
        gap: .5rem;
        grid-template-columns: repeat(2,minmax(0,1fr))
    }

    .options_J1Ai>div:first-of-type {
        grid-column: 1/3
    }

    .options-inner_qpwT[wrapper-for="Remote sources"] {
        display: grid;
        grid-template-columns: repeat(2,minmax(0,1fr))
    }

    .options-and-uppy_WGZs {
        display: grid;
        grid-template-columns: minmax(20rem,1fr) 2fr
    }
}

@media (min-width: 992px) {
    .cropper-point.point-se {
        height:10px;
        width: 10px
    }
}

@media (min-width: 997px) {
    .collapseSidebarButton_PEFL,.expandButton_TmdG {
        background-color:var(--docusaurus-collapse-button-bg)
    }

    :root {
        --docusaurus-announcement-bar-height: 30px
    }

    .announcementBarClose_gvF7,.announcementBarPlaceholder_vyr4 {
        flex-basis: 50px
    }

    .collapseSidebarButton_PEFL {
        border: 1px solid var(--ifm-toc-border-color);
        border-radius: 0;
        bottom: 0;
        display: block!important;
        height: 40px;
        position: sticky
    }

    .collapseSidebarButtonIcon_kv0_ {
        margin-top: 4px;
        transform: rotate(180deg)
    }

    .expandButtonIcon_i1dp,[dir=rtl] .collapseSidebarButtonIcon_kv0_ {
        transform: rotate(0)
    }

    .collapseSidebarButton_PEFL:focus,.collapseSidebarButton_PEFL:hover,.expandButton_TmdG:focus,.expandButton_TmdG:hover {
        background-color: var(--docusaurus-collapse-button-bg-hover)
    }

    .menuHtmlItem_M9Kj {
        padding: var(--ifm-menu-link-padding-vertical) var(--ifm-menu-link-padding-horizontal)
    }

    .menu_SIkG {
        flex-grow: 1;
        padding: .5rem
    }

    @supports (scrollbar-gutter:stable) {
        .menu_SIkG {
            padding: .5rem 0 .5rem .5rem;
            scrollbar-gutter: stable
        }
    }

    .menuWithAnnouncementBar_GW3s {
        margin-bottom: var(--docusaurus-announcement-bar-height)
    }

    .sidebar_njMd {
        display: flex;
        flex-direction: column;
        height: 100%;
        padding-top: var(--ifm-navbar-height);
        width: var(--doc-sidebar-width)
    }

    .sidebarWithHideableNavbar_wUlq {
        padding-top: 0
    }

    .sidebarHidden_VK0M {
        opacity: 0;
        visibility: hidden
    }

    .sidebarLogo_isFc {
        align-items: center;
        color: inherit!important;
        display: flex!important;
        margin: 0 var(--ifm-navbar-padding-horizontal);
        max-height: var(--ifm-navbar-height);
        min-height: var(--ifm-navbar-height);
        text-decoration: none!important
    }

    .sidebarLogo_isFc img {
        height: 2rem;
        margin-right: .5rem
    }

    .expandButton_TmdG {
        align-items: center;
        display: flex;
        height: 100%;
        justify-content: center;
        position: absolute;
        right: 0;
        top: 0;
        transition: background-color var(--ifm-transition-fast) ease;
        width: 100%
    }

    [dir=rtl] .expandButtonIcon_i1dp {
        transform: rotate(180deg)
    }

    .docSidebarContainer_YfHR {
        border-right: 1px solid var(--ifm-toc-border-color);
        clip-path: inset(0);
        display: block;
        margin-top: calc(var(--ifm-navbar-height)*-1);
        transition: width var(--ifm-transition-fast) ease;
        width: var(--doc-sidebar-width);
        will-change: width
    }

    .docSidebarContainerHidden_DPk8 {
        cursor: pointer;
        width: var(--doc-sidebar-hidden-width)
    }

    .sidebarViewport_aRkj {
        height: 100%;
        max-height: 100vh;
        position: sticky;
        top: 0
    }

    .docMainContainer_TBSr {
        flex-grow: 1;
        max-width: calc(100% - var(--doc-sidebar-width))
    }

    .docMainContainerEnhanced_lQrH {
        max-width: calc(100% - var(--doc-sidebar-hidden-width))
    }

    .docItemWrapperEnhanced_JWYK {
        max-width: calc(var(--ifm-container-width) + var(--doc-sidebar-width))!important
    }

    .navbarSearchContainer_Bca1 {
        padding: var(--ifm-navbar-item-padding-vertical) var(--ifm-navbar-item-padding-horizontal)
    }

    .lastUpdated_JAkA {
        text-align: right
    }

    .tocMobile_ITEo {
        display: none
    }

    .docItemCol_VOVn {
        max-width: 75%!important
    }
}

@media screen and (min-width: 1000px) and (max-width:1300px) {
    :root {
        --ifm-font-size-base:16px
    }
}

@media (min-width: 1200px) {
    .cropper-point.point-se {
        height:5px;
        opacity: .75;
        width: 5px
    }
}

@media (min-width: 1440px) {
    .container {
        max-width:var(--ifm-container-width-xl)
    }
}

@media (max-width: 996px) {
    .col {
        --ifm-col-width:100%;
        flex-basis: var(--ifm-col-width);
        margin-left: 0
    }

    .footer {
        --ifm-footer-padding-horizontal: 0
    }

    .colorModeToggle_DEke,.footer__link-separator,.navbar__item,.sidebar_re4s,.tableOfContents_bqdL {
        display: none
    }

    .footer__col {
        margin-bottom: calc(var(--ifm-spacing-vertical)*3)
    }

    .footer__link-item {
        display: block
    }

    .hero {
        padding-left: 0;
        padding-right: 0
    }

    .navbar>.container,.navbar>.container-fluid {
        padding: 0
    }

    .navbar__toggle {
        display: inherit
    }

    .navbar__search-input {
        width: 9rem
    }

    .pills--block,.tabs--block {
        flex-direction: column
    }

    .navbarSearchContainer_Bca1 {
        position: absolute;
        right: var(--ifm-navbar-padding-horizontal)
    }

    .docItemContainer_F8PC {
        padding: 0 .3rem
    }
}

@media only screen and (max-width: 996px) {
    .searchQueryColumn_RTkw,.searchResultsColumn_JPFH {
        max-width:60%!important
    }

    .searchLogoColumn_rJIA,.searchVersionColumn_ypXd {
        max-width: 40%!important
    }

    .searchLogoColumn_rJIA {
        padding-left: 0!important
    }
}

@media (max-width: 768px) {
    .DocSearch-Button-Keys,.DocSearch-Button-Placeholder,.DocSearch-Commands,.DocSearch-Hit-Tree {
        display:none
    }

    :root {
        --docsearch-spacing: 10px;
        --docsearch-footer-height: 40px
    }

    .DocSearch-Dropdown {
        height: 100%;
        max-height: calc(var(--docsearch-vh,1vh)*100 - var(--docsearch-searchbox-height) - var(--docsearch-spacing) - var(--docsearch-footer-height))
    }

    .DocSearch-Container {
        height: 100vh;
        height: -webkit-fill-available;
        height: calc(var(--docsearch-vh,1vh)*100);
        position: absolute
    }

    .DocSearch-Footer {
        border-radius: 0;
        bottom: 0;
        position: absolute
    }

    .DocSearch-Hit-content-wrapper {
        display: flex;
        position: relative;
        width: 80%
    }

    .DocSearch-Modal {
        border-radius: 0;
        box-shadow: none;
        height: 100vh;
        height: -webkit-fill-available;
        height: calc(var(--docsearch-vh,1vh)*100);
        margin: 0;
        max-width: 100%;
        width: 100%
    }

    .DocSearch-Cancel {
        appearance: none;
        background: none;
        border: 0;
        color: var(--docsearch-highlight-color);
        cursor: pointer;
        display: inline-block;
        flex: none;
        font: inherit;
        font-size: 1em;
        font-weight: 500;
        margin-left: var(--docsearch-spacing);
        outline: 0;
        overflow: hidden;
        padding: 0;
        -webkit-user-select: none;
        user-select: none;
        white-space: nowrap
    }
}

@media (max-width: 576px) {
    .markdown h1:first-child {
        --ifm-h1-font-size:2rem
    }

    .markdown>h2 {
        --ifm-h2-font-size: 1.5rem
    }

    .markdown>h3 {
        --ifm-h3-font-size: 1.25rem
    }

    .title_f1Hy {
        font-size: 2rem
    }
}

@media screen and (max-width: 576px) {
    .searchQueryColumn_RTkw {
        max-width:100%!important
    }

    .searchVersionColumn_ypXd {
        max-width: 100%!important;
        padding-left: var(--ifm-spacing-horizontal)!important
    }
}

@media (max-width: 426px) {
    .uppy-ProviderBrowser-footer {
        align-items:stretch;
        flex-direction: column-reverse
    }

    .uppy-ProviderBrowser-footer-error {
        padding-bottom: 10px
    }
}

@media (hover: hover) {
    .backToTopButton_sjWU:hover {
        background-color:var(--ifm-color-emphasis-300)
    }
}

@media (hover: none) {
    .uppy-ProviderBrowser-viewType--grid .uppy-ProviderBrowserItem-inner .uppy-ProviderBrowserItem-author,.uppy-ProviderBrowser-viewType--unsplash .uppy-ProviderBrowserItem-inner .uppy-ProviderBrowserItem-author {
        display:block
    }
}

@media (pointer: fine) {
    .thin-scrollbar {
        scrollbar-width:thin
    }

    .thin-scrollbar::-webkit-scrollbar {
        height: var(--ifm-scrollbar-size);
        width: var(--ifm-scrollbar-size)
    }

    .thin-scrollbar::-webkit-scrollbar-track {
        background: var(--ifm-scrollbar-track-background-color);
        border-radius: 10px
    }

    .thin-scrollbar::-webkit-scrollbar-thumb {
        background: var(--ifm-scrollbar-thumb-background-color);
        border-radius: 10px
    }

    .thin-scrollbar::-webkit-scrollbar-thumb:hover {
        background: var(--ifm-scrollbar-thumb-hover-background-color)
    }
}

@media (prefers-reduced-motion:reduce) {
    :root {
        --ifm-transition-fast: 0ms;
        --ifm-transition-slow: 0ms
    }
}

@media screen and (prefers-reduced-motion:reduce) {
    .DocSearch-Reset {
        animation: none;
        appearance: none;
        background: none;
        border: 0;
        border-radius: 50%;
        color: var(--docsearch-icon-color);
        cursor: pointer;
        right: 0;
        stroke-width: var(--docsearch-icon-stroke-width)
    }

    .DocSearch-Hit--deleting,.DocSearch-Hit--favoriting {
        transition: none
    }

    .DocSearch-Hit-action-button:focus,.DocSearch-Hit-action-button:hover {
        background: #0003;
        transition: none
    }
}

@media print {
    .announcementBar_mb4j,.footer,.menu,.navbar,.pagination-nav,.table-of-contents,.tocMobile_ITEo {
        display: none
    }

    .tabs {
        page-break-inside: avoid
    }

    .codeBlockLines_e6Vv {
        white-space: pre-wrap
    }
}

</style>
`